import React, { useEffect, useState, useContext, useMemo, useCallback, useRef } from "react";
import toast, { Toaster } from "react-hot-toast";

import axios from "axios";
import { Autocomplete, Avatar, Stack, Chip } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SettingsIcon from "@mui/icons-material/Settings";
import PurchasingPopup from '../dashboard/purchasing-popup/PurchasingPopup'
import { applyProofsChangeToPurchaseOrder } from "../../../../utils/dashboardProofUpdates";
import { isEffectiveProofRow } from "../../../../utils/purchaseOrderProofScope";
import { resolvePurchasingDashboardReps } from "../../../../utils/purchasingRepFallbacks";
import { matchesAnyRole } from "../../../../utils/instanceRoleInheritance";
import { applyPurchaseOrderProofCompletion } from "./proofDashboardStatus";
import { getAuthoritativeDashboardPoInHandsDate } from "./dashboardPoInHandsDate";
import { matchesPurchasingDashboardOverdueRow } from "./purchasingDashboardFilters";
import PinnedReportQuickSelect, {
  doesPinnedReportMatchState,
  readPurchasingReportConfig,
} from "./PinnedReportQuickSelect";
import {
  PURCHASE_ORDER_IN_PROGRESS_STAGES,
  PURCHASE_ORDER_OPEN_STAGES,
  PURCHASE_ORDER_STAGE_LABELS,
  PURCHASE_ORDER_STATUS_RANK,
  PURCHASE_ORDER_STATUS_OPTIONS,
} from "../../../../constants/purchaseOrderStatuses";
import "./style.css"
import {
    Box,
    Dialog,
    DialogContent,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    DialogTitle,
    Tabs,
    Tab,
    MenuItem,
    Checkbox,
    Typography, 
    Button,
    DialogActions,
    TextField,
    FormControlLabel,
    Tooltip,
    CircularProgress,
    LinearProgress,
    Slider,
    Grid,
    Card,
    CardHeader,
    CardContent,
    FormHelperText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useParams, Link } from "react-router-dom";
import InstanceLeftSidebar from "../../InstanceLeftSidebar";
import PageHeaderWithBreadcrumbs from "../../../../components/PageHeaderWithBreadcrumbs";
import DataDashboard from "../../../../components/DataDashboard";
import DataTable from "../../../../components/DataTable";
import AssignedUsersColumn from "../../sales/orders/orders-single/order-components/orderUserAssignment/OrderUserAssignment";
import { AuthContext } from "../../../../helpers/AuthContext";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import AddIcon from "@mui/icons-material/Add";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { fetchProductionReps } from "../../../../services/users"
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import {
  fetchAllProofsList,
  approveProofList,
  uploadProofList,
  fetchAllDesignReps,
  fetchProductionNotes,
  addProductionNoteByPO,
  lookupPurchaseOrders,
  updatePurchaseOrderDetails,
} from "../../../../services/purchaseOrder";

import {
  listPurchasingReportDefinitions
} from "../../../../services/purchasingReport";

import {
  ReportingPanel
} from '../dashboard/ReportingPanel/ReportingPanel';
import GridViewIcon from "@mui/icons-material/GridView";
import { Menu, FormGroup } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import LaunchIcon from "@mui/icons-material/Launch"; 
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CancelIcon from '@mui/icons-material/Cancel'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import HistoryIcon from "@mui/icons-material/History";
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import UpdateIcon from "@mui/icons-material/Update";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import NoteAltIcon from "@mui/icons-material/NoteAlt"; // alternative
import DescriptionIcon from "@mui/icons-material/Description";
import PaymentsIcon from "@mui/icons-material/Payments";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { formatDistanceToNow } from "date-fns";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useInstanceNextActionTypes } from "../../../../helpers/instanceTerms";
import { fetchOperationsManagementSettings } from "../../../../services/operationsManagement";


import {
  UIStatusChip,
  UITableActionCell,
  UITableShell,
  UITableToolbar,
} from "../../../../components/ui";


import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Alert,
  Skeleton,
  InputAdornment,
  Snackbar,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";


import RefreshIcon from "@mui/icons-material/Refresh";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartIcon from "@mui/icons-material/TableChart";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ClearIcon from "@mui/icons-material/Clear";
import FolderOffIcon from "@mui/icons-material/FolderOff";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { alpha, useTheme } from "@mui/material/styles";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

import Collapse from "@mui/material/Collapse";
import FilterListIcon from "@mui/icons-material/FilterList";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";



const asYmd = (v) => {
  if (!v) return "";
  const s = String(v).trim();
  // If backend already sent YYYY-MM-DD, use it directly (avoid UTC parsing)
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  // Otherwise, let Date handle ISO etc., then format local yyyy-mm-dd
  const d = new Date(s);
  if (Number.isNaN(+d)) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
};

function resolveDashboardPoInHandsDate(po = {}) {
  return getAuthoritativeDashboardPoInHandsDate(po);
}

function getDashboardPoInHandsMeaningLabel(po = {}) {
  const meaning = String(po?.inhandsDateMeaning || "").trim().toLowerCase();
  const source = String(po?.inhandsDateSource || "").trim().toLowerCase();

  if (meaning === "goods_required_at_decorator") return "Goods required at decorator";
  if (meaning === "goods_required_at_client") return "Goods required at client";
  if (meaning === "decorated_goods_required_at_client") return "Decorated goods required at client";
  if (meaning === "final_customer_in_hands") return "Final customer in-hands date fallback";
  if (source === "legacy_po") return "Legacy PO date fallback";
  return "";
}

function formatDashboardPoIhd(dateLike) {
  if (!dateLike) return "N/A";
  const s = String(dateLike);
  const onlyDate = s.includes("T") ? s.split("T")[0] : s;
  const d = new Date(`${onlyDate}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return "N/A";

  return new Intl.DateTimeFormat("en-US", {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  }).format(d);
}

function getDateSortValue(value) {
  if (!value) return null;
  const time = new Date(value).getTime();
  return Number.isFinite(time) ? time : null;
}

function compareNullableValues(aValue, bValue, direction) {
  if (aValue == null && bValue == null) return 0;
  if (aValue == null) return 1;
  if (bValue == null) return -1;

  if (aValue < bValue) return direction === "asc" ? -1 : 1;
  if (aValue > bValue) return direction === "asc" ? 1 : -1;
  return 0;
}


export const purchaseOrderStatusOptions = PURCHASE_ORDER_STATUS_OPTIONS;

const ymdToStableIso = (ymdStr) => {
  if (!ymdStr) return null;
  const [y, m, d] = ymdStr.split("-").map(Number);
  const dt = new Date(y, m - 1, d, 12, 0, 0, 0); // local noon
  return dt.toISOString();
};



// put this near buildUserIndex
const normalizeAvatarUrl = (imgSrc) => {
  if (!imgSrc) return null;
  if (/^https?:\/\//i.test(imgSrc)) return imgSrc;
  if (imgSrc.startsWith('/')) return `${process.env.REACT_APP_NODEJS_SERVER_URL}${imgSrc}`;
  if (imgSrc.startsWith('uploads')) return `${process.env.REACT_APP_NODEJS_SERVER_URL}/${imgSrc}`;
  return imgSrc;
};

const getInitials = (name = "") => {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  return `${parts[0]?.[0] || ""}${parts[1]?.[0] || ""}`.toUpperCase();
};

const getStatusColors = (status) => {
  switch ((status || "").toLowerCase()) {
    case "problem":   return { bg: "#dc2626", fg: "#fff" }; // red
    case "ok":        return { bg: "#16a34a", fg: "#fff" }; // green
    case "follow up": return { bg: "#d97706", fg: "#fff" }; // amber
    default:          return { bg: "#6b7280", fg: "#fff" }; // gray for N/A
  }
};

const ACTION_META = {
  'sent-email':         { icon: <MailOutlineIcon fontSize="small" />,       label: 'Email Sent',          color: '#1976d2' /* blue */ },
  'update':             { icon: <UpdateIcon fontSize="small" />,            label: 'Customer Updated',             color: '#0288d1' /* light blue */ },
  'approve':            { icon: <CheckCircleIcon fontSize="small" />,      label: 'Approved',            color: '#2e7d32' /* green */ },
  'decline':            { icon: <CancelIcon fontSize="small" />,           label: 'Declined',            color: '#c62828' /* red */ },
  'order-create':          { icon: <ShoppingCartIcon fontSize="small" />,     label: 'New Order',           color: '#ff8f00' /* amber */ },
  'presentation-generate':   { icon: <SlideshowIcon fontSize="small" />,        label: 'New Presentation',    color: '#6a1b9a' /* purple */ },
  'presentation-comment':   { icon: <SlideshowIcon fontSize="small" />,        label: 'Presentation Comment',    color: '#6a1b9a' /* purple */ },
  'estimate-create':       { icon: <ReceiptLongIcon fontSize="small" />,      label: 'New Estimate',        color: '#00796b' /* teal */ },
  'new-sales-order':    { icon: <MonetizationOnIcon fontSize="small" />,   label: 'New Sales Order',     color: '#afb42b' /* lime */ },
  'purchase-order-create': { icon: <LocalOfferIcon fontSize="small" />,       label: 'New Purchase Order',  color: '#5d4037' /* brown */ },
  'new-invoice':        { icon: <DescriptionIcon fontSize="small" />,     label: 'New Invoice',         color: '#283593' /* indigo */ },
  'new-bill':           { icon: <PaymentsIcon fontSize="small" />,        label: 'New Bill',            color: '#c79100' /* golden */ },
  'completed-order':    { icon: <DoneAllIcon fontSize="small" />,         label: 'Order Completed',     color: '#388e3c' /* dark green */ },
};

const uniqLower = (arr=[]) =>
  Array.from(new Set(arr.filter(Boolean).map(s => String(s).trim().toLowerCase())));

const asEmail = (u) => u?.email || u?.Email || u?.contactEmail || null;

// helper: pull an email out of many shapes
const pullEmail = (x) => {
  if (!x) return null;
  if (typeof x === 'string') {
    const s = x.trim();
    return /@/.test(s) ? s : null;
  }
  // common shapes
  return (
    x.email || x.Email || x.contactEmail || x.primaryEmail ||
    x.userEmail || x.workEmail || x.personalEmail || null
  );
};

const collectEmails = (list, idx) => {
  const out = [];
  (Array.isArray(list) ? list : [list]).forEach((item) => {
    if (!item) return;
    // 1) direct email on the object/string
    const direct = pullEmail(item);
    if (direct) { out.push(direct); return; }
    // 2) treat numbers/strings as IDs → lookup in user index
    const maybeId =
      (typeof item === 'number' || typeof item === 'string') ? String(item) :
      (item.id != null ? String(item.id) : null);
    if (maybeId && idx?.get?.(maybeId)?.email) {
      out.push(idx.get(maybeId).email);
    }
    // 3) nested contact-ish shapes
    if (item.contact || item.client || item.customer) {
      const nested = pullEmail(item.contact || item.client || item.customer);
      if (nested) out.push(nested);
    }
  });
  return out;
};

const buildInitialRecipients = (po, userDirectory = []) => {

  console.log('[recips] input:', {
    poId: po?.id, poNumber: po?.poNumber,
    clientRepDetails: po?.clientRepDetails,
    clientRepIds: po?.clientRepIds,
    orderRepDetails: po?.orderRepDetails,
    orderRepIds: po?.orderRepIds,
    productionRep: po?.productionRep,
    productionRepDetails: po?.productionRepDetails,
    assignedTo: po?.assignedTo,
    customerEmail: po?.customerEmail,
    salesOrder: {
      clientRep: po?.salesOrder?.clientRep,
      clientRepId: po?.salesOrder?.clientRepId,
      orderRep: po?.salesOrder?.orderRep,
      orderRepId: po?.salesOrder?.orderRepId,
      customerEmail: po?.salesOrder?.customerEmail,
      clientEmail: po?.salesOrder?.clientEmail,
      contactEmail: po?.salesOrder?.contactEmail,
    },
    userDirectoryLen: Array.isArray(userDirectory) ? userDirectory.length : 'n/a',
  });

  const idx = buildUserIndex(userDirectory); // you already have this util
  const uniqLower = (arr=[]) =>
    Array.from(new Set(arr.filter(Boolean).map(s => String(s).trim().toLowerCase())));

  // --- Client reps ---
  const clientRepEmails = [
    ...collectEmails(po.clientRepDetails || [], idx),
    ...collectEmails(po.clientRepIds || [], idx),
    ...collectEmails(po.salesOrder?.clientRep || [], idx),
    ...collectEmails(po.salesOrder?.clientRepId || [], idx),
  ];

  // --- Order reps ---
  const orderRepEmails = [
    ...collectEmails(po.orderRepDetails || [], idx),
    ...collectEmails(po.orderRepIds || [], idx),
    ...collectEmails(po.salesOrder?.orderRep || [], idx),
    ...collectEmails(po.salesOrder?.orderRepId || [], idx),
  ];
  const isProofApprovalToRole = (role) =>
    matchesAnyRole(role, ["order-rep", "client-rep", "administrator", "admin"]);
  const orderAssignedUsers = [
    ...(Array.isArray(po?.orderAssignedUsers) ? po.orderAssignedUsers : []),
    ...(Array.isArray(po?.Order?.AssignedTo) ? po.Order.AssignedTo : []),
    ...(Array.isArray(po?.salesOrder?.AssignedTo) ? po.salesOrder.AssignedTo : []),
  ];
  const orderAssignedToRecipients = collectEmails(
    orderAssignedUsers.filter((u) => isProofApprovalToRole(u?.role)),
    idx
  );

  // --- Assigned/purchasing reps ---
  const assignedPool = (po.assignedTo && po.assignedTo.length
    ? po.assignedTo
    : (po.productionRepDetails ? [po.productionRepDetails] : []));
  const assignedToEmails = [
    ...collectEmails(assignedPool, idx),
    ...collectEmails(po.productionRep, idx), // if only an ID is present
  ];

  // --- Customer email (try many reasonable places) ---
  const customerCandidates = [
    po.customerEmail,
    po.clientEmail,
    po.clientContactEmail,
    po.contactEmail,
    po.customer?.email,
    po.client?.email,
    po.salesOrder?.customerEmail,
    po.salesOrder?.clientEmail,
    po.salesOrder?.contactEmail,
    po.salesOrder?.customer?.email,
    po.salesOrder?.client?.email,
    // sometimes stored on nested contact objects/arrays
    ...(Array.isArray(po.salesOrder?.contacts) ? po.salesOrder.contacts.map(pullEmail) : []),
  ];
  const customer = uniqLower(customerCandidates.filter(Boolean));

  const clientReps = uniqLower(clientRepEmails);
  const orderReps  = uniqLower(orderRepEmails);
  const assigned   = uniqLower(assignedToEmails);

  const orderAssignedTo = uniqLower(orderAssignedToRecipients);
  const all = uniqLower([...clientReps, ...orderReps, ...orderAssignedTo, ...assigned, ...customer]);

  return { clientReps, orderReps, orderAssignedToRecipients: orderAssignedTo, assignedToEmails: assigned, customer, all };
};



// Parse safely if backend ever returns proofs as a JSON string
const ensureArray = (v) => {
  if (Array.isArray(v)) return v;
  if (typeof v === 'string') { try { const p = JSON.parse(v); return Array.isArray(p) ? p : []; } catch { return []; } }
  return [];
};

// Build once (optional): pass the same array you already fetch as `allUsers`
const buildUserIndex = (users = []) => {
  const byId = new Map();
  users.forEach(u => {
    if (u?.id == null) return;
    const first = u.first_name || u.firstName || "";
    const last  = u.last_name  || u.lastName  || "";
    const email = u.email || "";
    const name  = `${first} ${last}`.trim() || email || `User #${u.id}`;
    const pic   = u.profilePicture || u.avatar || u.photoUrl || null;

    byId.set(String(u.id), {
      id: String(u.id),
      name,
      role: u.role || u.userRole || "",
      avatarUrl: normalizeAvatarUrl(pic),
      first, last, email,
    });
  });
  return byId;
};

// Safe label from ACTION_META (or prettify unknown actions)
const labelForAction = (action, ACTION_META = {}) => {
  const a = (action || "").trim();
  if (ACTION_META[a]) return ACTION_META[a].label;
  return a
    ? a.replace(/[-_]/g, " ").replace(/\b\w/g, c => c.toUpperCase())
    : "System";
};

const StatusPill = ({ status, onClick }) => {
  const { bg, fg } = getStatusColors(status);
  const label = status || "N/A";
  return (
    <Box
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick(e)}
      sx={{
        backgroundColor: bg,
        color: fg,
        px: 1,
        py: 0.5,
        borderRadius: 1,
        textAlign: "center",
        width: "100%",
        fontWeight: 700,
        fontSize: "0.875rem",
        cursor: "pointer",
        outline: "none",
        "&:focus-visible": { boxShadow: "0 0 0 2px rgba(25,118,210,0.6)" },
      }}
      title="Click to change status"
    >
      {label}
    </Box>
  );
};

export const normalizeCustomerNotes = (arr = [], userDirectory = [], ACTION_META = {}) => {
  const idx = Array.isArray(userDirectory) ? buildUserIndex(userDirectory) : userDirectory;

  return arr.map((n, i) => {
    const id        = n.id || `cust-${n.sequence ?? i}`;
    const createdAt = n.createdAt || n.timestamp || null;
    const action    = n.action || null;

    const userObj   = n.userId != null ? idx?.get?.(String(n.userId)) : null;
    const candidate = (n.userName || "").trim();
    const bad       = !candidate || /^undefined\s+undefined$/i.test(candidate) || /^no username/i.test(candidate);
    const userName  = !bad ? candidate : (userObj?.name || (action ? "System" : "Customer"));

    const userAvatar = normalizeAvatarUrl(n.userAvatar || userObj?.avatarUrl || null);

    return {
      ...n,
      id,
      message: n.message ?? "",
      createdAt,
      userId: n.userId ?? userObj?.id ?? null,
      userName,
      userAvatar,                      // ✅ add this
      userRole: n.userRole || userObj?.role || (action ? "system" : "user"),
      action,
      label: labelForAction(action, ACTION_META),
      orderId: n.orderId ?? null,
      poId: n.poId ?? null,
      parentId: n.parentId ?? null,
      parentSequence: n.parentSequence ?? null,
      pinned: Boolean(n.pinned || n.pinnedPurchasing),
      pinnedPurchasing: Boolean(n.pinnedPurchasing),
      deletedAt: n.deletedAt || null,
      deletedByUserId: n.deletedByUserId ?? null,
      noteType: n.noteType || null,
      _origin: "customer",
    };
  });
};


// Actions that are clearly production-related
const PROD_ACTIONS = new Set([
  "purchase-order-create",
  "completed-order",
  "production-note",
  "purchasing-note"
  // keep "update" but gate it by keywords below
]);

// Phrases that usually indicate production work
const PROD_KEYWORDS = /\b(production|po\b|purchase order|proof|artwork|designer|supplier|stage|ship|shipped|shipping|tracking|bill of lading|next action|na date|proj(ected)? ship|decoration)\b/i;

// Decide if a note is production-y
export const isProductionNote = (note) => {
  if (!note) return false;
  // If it’s tied to a PO in your data model, treat as production
  if (note.poId != null) return true;

  const action = (note.action || "").toLowerCase();

  if (PROD_ACTIONS.has(action)) {
    // 'update' is too generic — require a keyword
    if (action === "update") return PROD_KEYWORDS.test(note.message || "");
    return true;
  }
  // Heuristic fallback on message text
  return PROD_KEYWORDS.test(note.message || "");
};

// Aggregate a side's overall state across uploaded proofs
// returns: 'approved' | 'rejected' | 'pending' | 'na'
const aggregateSideState = (proofsRaw, side/*'user'|'client'*/) => {
  const proofs = ensureArray(proofsRaw).filter(p => !!p?.filePath); // only consider uploaded
  if (!proofs.length) return 'na';

  if (proofs.some(p => p?.approvals?.[side]?.state === 'rejected')) return 'rejected';
  if (proofs.every(p => p?.approvals?.[side]?.state === 'approved')) return 'approved';
  return 'pending';
};

// Simple dot UI
const colorForState = (state) => {
  switch (state) {
    case 'approved': return { fill: '#22c55e', border: '#16a34a' }; // green
    case 'rejected': return { fill: '#ef4444', border: '#dc2626' }; // red
    case 'pending':  return { fill: '#f59e0b', border: '#d97706' }; // amber
    default:         return { fill: '#e5e7eb', border: '#9ca3af' }; // gray (na/unknown)
  }
};

const humanize = (state) => {
  if (state === 'na') return '—';
  return state?.charAt(0).toUpperCase() + state?.slice(1);
};

// Tiny dot + compact orbs with tooltips
const SmallDot = ({ fill, border, label, state, onClick }) => (
  <Tooltip arrow placement="top" title={`${label}: ${humanize(state)}`}>
    <Box
      onClick={onClick}
      role="button"
      tabIndex={0}
      sx={{
        width: 12,
        height: 12,
        borderRadius: '50%',
        bgcolor: fill,
        border: `1px solid ${border}`,
        cursor: 'pointer',
      }}
    />
  </Tooltip>
);

const CompactApprovalOrbs = ({ proofs, onClick }) => {
  const userState   = aggregateSideState(proofs, 'user');
  const clientState = aggregateSideState(proofs, 'client');
  const u = colorForState(userState);
  const c = colorForState(clientState);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 'auto' }}>
      <SmallDot fill={u.fill} border={u.border} label="User"   state={userState}   onClick={onClick} />
      <SmallDot fill={c.fill} border={c.border} label="Client" state={clientState} onClick={onClick} />
    </Box>
  );
};

const buildProofTooltip = (ps) => {
  if (!ps) return '';
  const chunks = [];
  if (ps.total) chunks.push(`${ps.approved}/${ps.total} approved`);
  if (ps.rejected) chunks.push(`${ps.rejected} rejected`);
  if (ps.pendingUser || ps.pendingClient) {
    const wait = [];
    if (ps.pendingUser)   wait.push(`${ps.pendingUser} internal`);
    if (ps.pendingClient) wait.push(`${ps.pendingClient} client`);
    chunks.push(`waiting: ${wait.join(', ')}`);
  }
  return chunks.join(' • ') || 'No proofs';
};

// Shorten long status labels for the pill
const shortLabelMap = {
  'Pending Approval': 'Pending',
  'Proof Needed': 'Needed',
  'Not Required': 'No Proof',
};
const shortLabel = (label) => shortLabelMap[label] || label;

const EllipsisHeaderLabel = ({ label }) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const node = textRef.current;
    if (!node) return undefined;

    const measure = () => {
      const availableWidth = node.getBoundingClientRect().width;
      const range = document.createRange();
      range.selectNodeContents(node);
      const contentWidth = range.getBoundingClientRect().width;
      range.detach?.();

      const overflowByScrollWidth = node.scrollWidth - node.clientWidth > 0.5;
      const overflowByRangeWidth = contentWidth - availableWidth > 0.5;

      setIsTruncated(overflowByScrollWidth || overflowByRangeWidth);
    };

    const frameId = window.requestAnimationFrame(measure);

    let resizeObserver;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(node);
    }

    window.addEventListener("resize", measure);

    return () => {
      window.cancelAnimationFrame(frameId);
      resizeObserver?.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [label]);

  return (
    <Tooltip
      title={label}
      arrow
      disableHoverListener={!isTruncated}
      disableFocusListener={!isTruncated}
      disableTouchListener={!isTruncated}
    >
      <Box
        ref={textRef}
        component="span"
        sx={{
          display: "block",
          minWidth: 0,
          width: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          textAlign: "center",
        }}
      >
        {label}
      </Box>
    </Tooltip>
  );
};


const ApprovalOrb = ({ state, label }) => {
  const { fill, border } = colorForState(state);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 72 }}>
      <Typography variant="caption" sx={{ fontWeight: 600, color: '#374151', mb: 0.5 }}>
        {label}
      </Typography>
      <Box
        title={`${label}: ${humanize(state)}`}
        aria-label={`${label}: ${humanize(state)}`}
        sx={{
          width: 30,
          height: 30,
          borderRadius: '50%',
          backgroundColor: fill,
          border: `2px solid ${border}`,
          boxShadow: '0 0 0 2px #fff', // subtle ring separation if on colored bg
        }}
      />
      <Typography variant="caption" sx={{ mt: 0.5, color: '#6b7280', textTransform: 'capitalize' }}>
        {humanize(state)}
      </Typography>
    </Box>
  );
};


// Client-side fallback if backend didn't include proofSummary
// Client-side fallback if backend didn't include proofSummary
// Client-side fallback if backend didn't include proofSummary
const summarizeProofsClient = (po) => {
  const rawProofs = ensureArray(po?.proofs);
  const proofs = rawProofs.filter((proof) => isEffectiveProofRow(proof, po));
  const uploaded = proofs.filter(p => !!(p?.filePath || p?.proofFilePath));

  const isRejected = (p) => {
    const u = p?.approvals?.user?.state?.toLowerCase();
    const c = p?.approvals?.client?.state?.toLowerCase();
    return p?.status === 'Rejected' || u === 'rejected' || c === 'rejected';
  };
  const isApproved = (p) => {
    const u = p?.approvals?.user?.state?.toLowerCase();
    const c = p?.approvals?.client?.state?.toLowerCase();
    return p?.status === 'Approved' || (u === 'approved' && c === 'approved');
  };

  const approvedCount = uploaded.filter(isApproved).length;
  const rejectedCount = uploaded.filter(isRejected).length;

  const pendingClient = uploaded.filter(p => {
    const s = p?.approvals?.client?.state?.toLowerCase();
    return s !== 'approved' && s !== 'rejected';
  }).length;

  const pendingUser = uploaded.filter(p => {
    const s = p?.approvals?.user?.state?.toLowerCase();
    return s !== 'approved' && s !== 'rejected';
  }).length;

  const total = proofs.length;
  const proofRequired = !!po?.proofRequired;
  const dbStatus = (po?.proofStatus || '').trim().toLowerCase();

  // Only treat as "Not Required" if there is truly nothing proof-related
  const nothingProofy =
    total === 0 &&
    uploaded.length === 0 &&
    !proofRequired;

  if ((!dbStatus || dbStatus === 'no proof' || dbStatus === 'not required' || dbStatus === 'no proof required') && nothingProofy) {
    return {
      total: 0, uploaded: 0, approved: 0, rejected: 0,
      pendingClient: 0, pendingUser: 0,
      allProofsUploaded: false,
      displayStatus: 'Not Required',
      clientLinks: [],
    };
  }

  let displayStatus = 'Proof Needed';
  if (rejectedCount > 0) displayStatus = 'Rejected';
  else if (approvedCount === uploaded.length && uploaded.length > 0) displayStatus = 'Approved';
  else if (uploaded.length > 0) displayStatus = 'Pending Approval';

  const clientLinks = uploaded.map(p => ({
    proofId:  String(p.id),
    location: p.location || p.decoration?.location || null,
    path:     `/generated-proofs/${po.id}`,
  }));

  return {
    total,
    uploaded: uploaded.length,
    approved: approvedCount,
    rejected: rejectedCount,
    pendingClient,
    pendingUser,
    allProofsUploaded: proofs.some(p => p?.allProofsUploaded) && displayStatus !== 'Not Required',
    displayStatus,
    clientLinks,
  };
};
























const normalize = s => (s || '').trim().toLowerCase();

const finalizeProofSummaryForUI = (po) => {
  const client = summarizeProofsClient(po);
  const isPendingApproval = normalize(po?.proofStatus) === 'pending approval';

  // If anything is rejected, don't force Uploaded
  const anyRejected =
    (client.rejected ?? 0) > 0 ||
    ensureArray(po?.proofs).some(p => {
      const u = p?.approvals?.user?.state?.toLowerCase();
      const c = p?.approvals?.client?.state?.toLowerCase();
      return u === 'rejected' || c === 'rejected';
    });

  // Are ALL uploaded proofs approved?
  const allApproved =
    (client.uploaded ?? 0) > 0 &&
    (client.approved ?? 0) === (client.uploaded ?? 0);

  // Only show "Uploaded" while waiting on approvals
  if (po.allProofsUploaded === true &&
      client.displayStatus !== 'Not Required' &&
      !anyRejected &&
      !allApproved &&              // ← key change
      !isPendingApproval &&
      (client.uploaded ?? 0) > 0)  // must actually have uploads
  {
    return applyPurchaseOrderProofCompletion(po, {
      ...client,
      allProofsUploaded: true,
      displayStatus: 'Uploaded',
    });
  }

  return applyPurchaseOrderProofCompletion(po, client);
};

const getDashboardProofFilterStatus = (po) => {
  if (String(po?.proofStatus || "").trim() === "Proof Complete") {
    return "Proof Complete";
  }
  return finalizeProofSummaryForUI(po).displayStatus || "Not Required";
};

const DEFAULT_COL_WIDTH = 145;
const MIN_COL_WIDTH = 120;
const MAX_COL_WIDTH = 190;
const STAGE_MIN_COL_WIDTH = 176;

const clampColWidth = (value) => {
  const parsed = Number(value) || DEFAULT_COL_WIDTH;
  return Math.min(MAX_COL_WIDTH, Math.max(MIN_COL_WIDTH, parsed));
};

const DEFAULT_DENSITY = "comfortable";
const VALID_DENSITIES = new Set(["compact", "comfortable", "spacious"]);

const sanitizeDensityPreference = (value) => (
  VALID_DENSITIES.has(String(value || "")) ? String(value) : DEFAULT_DENSITY
);

const getDashboardPrefsStorageKey = ({ instanceUniqueId, userId }) => (
  `production-dashboard.prefs.${instanceUniqueId || "unknown-instance"}.${userId || "anonymous"}`
);

const safeReadDashboardPrefs = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (_err) {
    return null;
  }
};

const safeWriteDashboardPrefs = (key, prefs) => {
  try {
    localStorage.setItem(key, JSON.stringify(prefs));
  } catch (_err) {}
};

const DEFAULT_PURCHASING_DASHBOARD_SETTINGS = Object.freeze({
  infiniteDashboardScroll: false,
});

const DEFAULT_PURCHASING_DASHBOARD_META = Object.freeze({
  page: 1,
  limit: 25,
  total: 0,
  hasMore: false,
});

export const buildTerminalLookupMeta = (rows = []) => ({
  page: 1,
  limit: Array.isArray(rows) ? rows.length : 0,
  total: Array.isArray(rows) ? rows.length : 0,
  hasMore: false,
});

export const shouldBlockPurchasingInfiniteScroll = ({
  lookupMode = false,
  infiniteDashboardScrollEnabled = false,
  purchasingDashboardSettingsLoading = false,
  hasTriggeredSearch = false,
  poLoading = false,
  hasMore = false,
} = {}) => (
  lookupMode ||
  !infiniteDashboardScrollEnabled ||
  purchasingDashboardSettingsLoading ||
  !hasTriggeredSearch ||
  poLoading ||
  !hasMore
);

export const isStalePurchasingDashboardRequest = ({
  requestToken,
  activeToken,
}) => requestToken !== activeToken;

const dedupePurchaseOrdersById = (currentRows = [], nextRows = []) => {
  const byId = new Map();
  [...currentRows, ...nextRows].forEach((row) => {
    if (!row?.id) return;
    byId.set(String(row.id), row);
  });
  return Array.from(byId.values());
};


export default function InstanceDashboard() {



  const theme = useTheme();
  const location = useLocation();
const C = {
  paperBg: theme.palette.background.paper,
  subtleBg: theme.palette.action.hover,
  border: theme.palette.divider,
  textPri: theme.palette.text.primary,
  textSec: theme.palette.text.secondary,
  textMuted: theme.palette.text.disabled,
  white: theme.palette.common.white,
  headerBg: theme.eliteCore?.tokens?.color?.neutral?.[800] ?? "#1e293b",
  headerBgHover: theme.eliteCore?.tokens?.color?.neutral?.[700] ?? "#334155",
  headerText: theme.eliteCore?.tokens?.color?.neutral?.[50] ?? "#f8fafc",
  headerTextMuted: theme.eliteCore?.tokens?.color?.neutral?.[400] ?? "#94a3b8",
};




  const { instanceUniqueId } = useParams(); 
  const isPurchasingDashboardRoute = location.pathname.includes("/purchasing/dashboard");
  const { authState } = useContext(AuthContext);
  const dashboardPrefsUserId = useMemo(() => (
    String(
      authState?.user?.id ||
      authState?.id ||
      authState?.user?.email ||
      authState?.email ||
      "anonymous"
    ).trim() || "anonymous"
  ), [authState]);
  const { nextActionTypeOptions, nextActionTypes } = useInstanceNextActionTypes(instanceUniqueId);

  const nextActionLabelById = useMemo(() => (
    Object.fromEntries(
      nextActionTypeOptions.map((option) => [String(option.id), option.name])
    )
  ), [nextActionTypeOptions]);

  const nextActionIdByLabel = useMemo(() => (
    Object.fromEntries(
      nextActionTypeOptions.map((option) => [option.name.toLowerCase(), String(option.id)])
    )
  ), [nextActionTypeOptions]);

  const normalizeNextAction = useCallback((val) => {
    if (val == null || val === "") return { id: null, label: "" };
    const s = String(val).trim();
    if (nextActionLabelById[s]) return { id: s, label: nextActionLabelById[s] };
    const id = nextActionIdByLabel[s.toLowerCase()] || null;
    return id ? { id, label: nextActionLabelById[id] } : { id: null, label: s };
  }, [nextActionIdByLabel, nextActionLabelById]);

  const resolveNextActionFilter = useCallback((arr = []) => {
    const wantsNone = arr.some((x) => String(x).toLowerCase() === "none set");
    const ids = new Set();
    arr.forEach((x) => {
      const s = String(x).trim();
      if (nextActionLabelById[s]) ids.add(s);
      const id = nextActionIdByLabel[s.toLowerCase()];
      if (id) ids.add(id);
    });
    return { ids: Array.from(ids), wantsNone };
  }, [nextActionIdByLabel, nextActionLabelById]);

  const nextActionTypeEnums = useMemo(
    () => ["None set", ...nextActionTypes],
    [nextActionTypes]
  );

  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [purchaseOrders, setPurchaseOrders] = useState([]);

  const [proofOpen, setProofOpen] = useState(false);
  const [proofSrc, setProofSrc]   = useState("");

    // filter toggles
    const [showSO, setShowSO] = useState(false);
    const [repOptions, setRepOptions] = useState([]);     // unified list
    const [repOptionsLoading, setRepOptionsLoading] = useState(false);
    const [serverReps, setServerReps] = useState([]);
    
    // End filter toggles  

    const [selectedPO, setSelectedPO] = useState(null);
    const [proofInitialTab, setProofInitialTab] = useState("overview");

    // state for the slider
    const [colWidth, setColWidth] = useState(() => DEFAULT_COL_WIDTH);
    // track which rows are saving NA date
    const [savingNaDate, setSavingNaDate] = useState(() => new Set());
    const [inProdQuick, setInProdQuick] = useState(false);
    const [naDraft, setNaDraft] = useState(() => new Map());
    const setDraft = (id, v) => setNaDraft(prev => {
      const m = new Map(prev);
      if (v == null) m.delete(id); else m.set(id, v);
      return m;
    });
    const getDraft = (id) => naDraft.get(id);
    const isFullYmd = (s) => /^\d{4}-\d{2}-\d{2}$/.test(s || "");




const [density, setDensity] = useState(DEFAULT_DENSITY);
const densitySettings = {
  compact:     { py: 0.75, fontSize: "0.8125rem" },
  comfortable: { py: 1.5,  fontSize: "0.875rem"  },
  spacious:    { py: 2.25, fontSize: "0.9375rem" },
};
const currentDensity = densitySettings[density];

const [sortBy, setSortBy]   = useState("createdAt");
const [sortDir, setSortDir] = useState("desc");

const [exportAnchorEl,    setExportAnchorEl]    = useState(null);
const [columnMenuAnchor,  setColumnMenuAnchor]  = useState(null);
  const [styleMenuAnchor,   setStyleMenuAnchor]   = useState(null);
const [densityMenuAnchor, setDensityMenuAnchor] = useState(null);

const [rowsPerPage, setRowsPerPage] = useState(25);
const [tablePage,   setTablePage]   = useState(0);  
const [purchasingDashboardSettings, setPurchasingDashboardSettings] = useState(
  DEFAULT_PURCHASING_DASHBOARD_SETTINGS
);
const [purchasingDashboardSettingsLoading, setPurchasingDashboardSettingsLoading] = useState(
  isPurchasingDashboardRoute
);
const [dashboardFetchMeta, setDashboardFetchMeta] = useState(
  DEFAULT_PURCHASING_DASHBOARD_META
);

const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
const showSnackbar = (message, severity = "success") =>
  setSnackbar({ open: true, message, severity });





const ymd = (d) => {
  if (!d) return "";
  const x = new Date(d);
  const pad = (n) => String(n).padStart(2, "0");
  return `${x.getFullYear()}-${pad(x.getMonth()+1)}-${pad(x.getDate())}`;
};

const handleNextActionDateChange = async (row, nextYmd) => {
  const iso = nextYmd ? ymdToStableIso(nextYmd) : null;

  // optimistic: keep both keys in sync so megaRows (which reads po.nextActionDate || po.naDate)
  // immediately reflects the new value regardless of which the BE uses
  setPurchaseOrders(prev =>
    prev.map(po =>
      po.id === row.id
        ? { ...po, nextActionDate: iso, naDate: iso }
        : po
    )
  );

  setSavingNaDate(prev => {
    const s = new Set(prev);
    s.add(row.id);
    return s;
  });

  try {
    await axios.patch(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/purchase-order/${row.id}`,
      // send both; whichever your API stores will stay in sync
      { nextActionDate: iso, naDate: iso },
      { headers: { accessToken: localStorage.getItem("accessToken") } }
    );
    toast.success("Next Action Date updated");
  } catch (e) {
    toast.error(e?.response?.data?.message || "Failed to save Next Action Date");
  } finally {
    setSavingNaDate(prev => {
      const s = new Set(prev);
      s.delete(row.id);
      return s;
    });
  }
};
    const pageRef = useRef(null);
    const infiniteSentinelRef = useRef(null);
    const dashboardRequestPagesRef = useRef(new Set());
    const skipNextInfiniteReloadRef = useRef(false);

    const COL_WIDTH_LS_KEY = useMemo(
      () => `production-dashboard.csscolwidth.${instanceUniqueId}`,
      [instanceUniqueId]
    );
    const DASHBOARD_PREFS_LS_KEY = useMemo(
      () => getDashboardPrefsStorageKey({ instanceUniqueId, userId: dashboardPrefsUserId }),
      [instanceUniqueId, dashboardPrefsUserId]
    );
    const COLUMN_ORDER_LS_KEY = useMemo(
      () => `purchasingDashboardColumnOrder:${instanceUniqueId || "unknown-instance"}:${dashboardPrefsUserId || "anonymous"}`,
      [dashboardPrefsUserId, instanceUniqueId]
    );
    const skipNextDashboardPrefsWriteRef = useRef(false);
    const skipNextColumnOrderWriteRef = useRef(false);

    // keep the CSS variable in sync
    useEffect(() => {
      pageRef.current?.style.setProperty('--po-col-width', `${colWidth}px`);
    }, [colWidth]);


/* STATS  */

const [filters, setFilters] = useState({
  clientRepId: null,
  orderRepId: null,
  productionRepId: null,
  supplierIds: [],
  clientIds: [],
  shippingMethods: [],
  proofStatus: [],          // e.g. ['Approved','Rejected','Pending','Proof Needed','Not Required','Uploaded','Requested']
  productionRepStatus: [],  // your "Status" pill (Problem/OK/etc.)
  supplierStage: [],        // your "Stage" (Created, Submitted, Confirmed, Shipped, Ready For Billing, Closed, Billed)
  firm: null,               // true | false | null (null = ignore)
  nextActionTypes: [],          // "any" | "with" | "without"
  dateType: "nextActionDate", // "nextActionDate" | "inHandsDate" | "poCreated"
  dateQuick: "any",           // "any" | "overdue" | "today" | "dueByToday" | "next7" | "custom" | "noDate"
  dateCustom: "",
  dateFrom: "",             // yyyy-mm-dd
  dateTo: "",               // yyyy-mm-dd
});

const hasAppliedDefaultDateType = useRef(false);

useEffect(() => {
  if (!instanceUniqueId || hasAppliedDefaultDateType.current) return;
  const loadDefaultPoDate = async () => {
    try {
      const instanceRes = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`
      );
      const instanceId = instanceRes?.data?.id;
      if (!instanceId) return;
      const defaultsRes = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/${instanceId}/defaults`,
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      const defaultPoDate = defaultsRes?.data?.defaults?.defaultPoDate;
      const nextDateType = defaultPoDate === "in-hands" ? "inHandsDate" : "nextActionDate";
      setFilters((prev) => {
        if (prev.dateType !== "nextActionDate") return prev;
        return { ...prev, dateType: nextDateType };
      });
      hasAppliedDefaultDateType.current = true;
    } catch (error) {
      hasAppliedDefaultDateType.current = true;
    }
  };
  loadDefaultPoDate();
}, [instanceUniqueId]);

/* FIRST PAINT CACHE START */

// ---- DB-driven filter options (cached) ----
const FILTERS_REFRESH_MS = 10 * 60 * 1000; // 10 minutes
const FILTERS_LS_KEY = useMemo(
  () => `production-dashboard.filterOptions.${instanceUniqueId}`,
  [instanceUniqueId]
);

const [dbSupplierOptions, setDbSupplierOptions] = useState([]);     // ["SanMar", "S&S Activewear", ...]
const [dbClientOptions,   setDbClientOptions]   = useState([]);     // [{ id:"123", name:"Acme Inc." }, ...]
const [dbShippingOptions, setDbShippingOptions] = useState([]);     // ["UPS", "Purolator", ...]
const [filtersVersion,    setFiltersVersion]    = useState(null);
const [savingStatus, setSavingStatus] = useState(() => new Set());

const filtersAbortRef = useRef(null);

// open the small menu for a row
const openStatusMenu = (event, row) => {
  event.stopPropagation(); // don't trigger row selection
  setStatusMenu({ anchorEl: event.currentTarget, rowId: row.id });
};

// close
const closeStatusMenu = () => setStatusMenu({ anchorEl: null, rowId: null });
const [savingStage, setSavingStage] = useState(() => new Set());
const [savingProofCompletion, setSavingProofCompletion] = useState(() => new Set());
const [savingCostsConfirmed, setSavingCostsConfirmed] = useState(() => new Set());

const handleCostsConfirmedChange = async (row, confirmed) => {
  if (!row?.id) return;
  const oldValue = row.costsConfirmed === true;
  setSavingCostsConfirmed((previous) => new Set(previous).add(row.id));
  setPurchaseOrders((previous) => previous.map((po) =>
    po.id === row.id ? { ...po, costsConfirmed: confirmed } : po
  ));
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/purchase-order/${row.id}`,
      { costsConfirmed: confirmed },
      { headers: { accessToken: localStorage.getItem("accessToken") } }
    );
    const savedValue = response?.data?.purchaseOrder?.costsConfirmed;
    if (response?.data?.success !== true ||
        (savedValue !== true && savedValue !== false && savedValue !== 1 && savedValue !== 0) ||
        Boolean(savedValue) !== confirmed) {
      throw new Error("Server did not confirm the saved Costs Confirmed value.");
    }
  } catch (error) {
    setPurchaseOrders((previous) => previous.map((po) =>
      po.id === row.id ? { ...po, costsConfirmed: oldValue } : po
    ));
    toast.error(error?.response?.data?.message || error?.message || "Couldn't save Costs Confirmed");
  } finally {
    setSavingCostsConfirmed((previous) => {
      const next = new Set(previous);
      next.delete(row.id);
      return next;
    });
  }
};


const savingRowIds = useMemo(() => {
  const s = new Set();
  savingNaDate.forEach(id => s.add(id));
  savingStage.forEach(id => s.add(id));
  savingStatus.forEach(id => s.add(id));
  savingProofCompletion.forEach(id => s.add(id));
  savingCostsConfirmed.forEach(id => s.add(id));
  return s;
}, [savingNaDate, savingProofCompletion, savingCostsConfirmed, savingStage, savingStatus]);

const isRowSaving = useCallback((rowId) => savingRowIds.has(rowId), [savingRowIds]);

const handleStatusChange = async (rowId, newStatus) => {
  // block double-requests on same row
  setSavingStatus(prev => new Set(prev).add(rowId));

  // optimistic UI
  const prevStatus = purchaseOrders.find(p => p.id === rowId)?.productionRepStatus ?? "N/A";
  setPurchaseOrders(prev => prev.map(po => po.id === rowId ? { ...po, productionRepStatus: newStatus } : po));
  closeStatusMenu();

  try {
    await axios.patch(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/purchase-order/${rowId}`,
      { productionRepStatus: newStatus },
      { headers: { accessToken: localStorage.getItem("accessToken") } }
    );
    toast.success("Status updated");
  } catch (e) {
    // revert if failed
    setPurchaseOrders(prev => prev.map(po => po.id === rowId ? { ...po, productionRepStatus: prevStatus } : po));
    toast.error(e?.response?.data?.message || "Failed to save status");
  } finally {
    setSavingStatus(prev => { const s = new Set(prev); s.delete(rowId); return s; });
  }
};

const isNoProofPurchaseOrder = (row = {}) => {
  const persisted = String(row?.proofStatus || "").trim().toLowerCase();
  const summaryStatus = String(row?.proofSummary?.displayStatus || "").trim().toLowerCase();
  return (
    persisted === "no proof" ||
    persisted === "not required" ||
    summaryStatus === "not required"
  );
};

const handleMarkProofComplete = async (row) => {
  if (!row?.id) return;
  if (isNoProofPurchaseOrder(row)) return;
  if (row.proofStatus === "Proof Complete") return;
  if (row.canMarkProofComplete !== true) {
    toast.error("All required proofs must be approved before Proof Complete can be selected.");
    return;
  }

  setSavingProofCompletion((prev) => new Set(prev).add(row.id));

  try {
    const res = await updatePurchaseOrderDetails(row.id, { proofStatus: "Proof Complete" });
    const updatedPo = res?.purchaseOrder || {};
    setPurchaseOrders((prev) =>
      prev.map((po) =>
        po.id === row.id
          ? {
              ...po,
              proofStatus: updatedPo.proofStatus || "Proof Complete",
              canMarkProofComplete:
                updatedPo.canMarkProofComplete !== undefined
                  ? !!updatedPo.canMarkProofComplete
                  : true,
            }
          : po
      )
    );
    toast.success("Proofing marked complete");
  } catch (e) {
    toast.error(e?.response?.data?.message || "Failed to mark proofing complete");
  } finally {
    setSavingProofCompletion((prev) => {
      const next = new Set(prev);
      next.delete(row.id);
      return next;
    });
  }
};


// Tiny set helpers
const uniq = (arr=[]) => [...new Set(arr.filter(Boolean))].sort((a,b)=>`${a}`.localeCompare(`${b}`));
const union = (a=[], b=[]) => uniq([...(a||[]), ...(b||[])]);

// union for clients, by id
const unionClients = (a=[], b=[]) => {
  const map = new Map();
  [...(a||[]), ...(b||[])].forEach(c => {
    if (!c) return;
    const id = String(c.id ?? c.customerId ?? "");
    if (!id) return;
    const name = (c.name || c.customer || c.customerName || "").trim();
    const prev = map.get(id) || {};
    map.set(id, { id, name: name || prev.name || "" });
  });
  return [...map.values()].sort((x,y) => (x.name||"").localeCompare(y.name||""));
};

const readRepsFromCache = () => {
  const c = readFiltersCache();
  return (c && Array.isArray(c.repOptions)) ? c.repOptions : [];
};
const writeRepsToCache = (reps) => writeFiltersCache({ repOptions: reps });
const readFiltersCache = () => {
  try {
    const raw = localStorage.getItem(FILTERS_LS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

const writeFiltersCache = (payload) => {
  try {
    const prev = readFiltersCache() || {};
    localStorage.setItem(
      FILTERS_LS_KEY,
      JSON.stringify({ ...prev, ...payload, ts: Date.now() })
    );
  } catch {}
};

const fetchDbFilterOptions = async ({ checkOnly = false, signal } = {}) => {
  const headers = { accessToken: localStorage.getItem("accessToken") };
  const cache = readFiltersCache();
  const params = { instanceUniqueId };
  if (checkOnly && cache?.ts) params.since = cache.ts;

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/purchase-order/filter-options`,
      {
        params,
        headers,
        signal,
        validateStatus: s => s >= 200 && s < 500 // treat 304/404 like non-fatal
      }
    );

    // Support either 304 or an explicit "changed:false"
    if (res.status === 304 || res?.data?.changed === false) {
      if (cache) {
        setDbSupplierOptions(cache.suppliers || []);
        setDbClientOptions(cache.clients || []);
        setDbShippingOptions(cache.shipping || []);
        setFiltersVersion(cache.version || cache.updatedAt || cache.ts || null);
      }
      return;
    }

    const data = res?.data || {};
    const suppliers = Array.isArray(data.suppliers) ? data.suppliers : (data.supplierNames || []);
    const clients   = Array.isArray(data.clients)   ? data.clients   : [];
    const shipping  = Array.isArray(data.shippingMethods) ? data.shippingMethods : [];

    setDbSupplierOptions(suppliers);
    setDbClientOptions(clients.map(c => ({ id: String(c.id), name: c.name })));
    setDbShippingOptions(shipping);
    setFiltersVersion(data.version || data.updatedAt || Date.now());

    writeFiltersCache({
      suppliers,
      clients: clients.map(c => ({ id: String(c.id), name: c.name })),
      shipping,
      version: data.version || data.updatedAt || Date.now()
    });
  } catch (e) {
    // fall back to cache if we have it
    const cache = readFiltersCache();
    if (cache) {
      setDbSupplierOptions(cache.suppliers || []);
      setDbClientOptions(cache.clients || []);
      setDbShippingOptions(cache.shipping || []);
      setFiltersVersion(cache.version || cache.updatedAt || cache.ts || null);
    } else {
      console.warn("No DB filter options & no cache yet.");
    }
  }
};

// Re-scan users every 10 minutes and update cache-backed repOptions
useEffect(() => {
  const ctrl = new AbortController();
  const headers = { accessToken: localStorage.getItem("accessToken") };

  const refreshUsers = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/byinstanceUniqueId/${instanceUniqueId}`,
        { headers, signal: ctrl.signal }
      );
      setAllUsers(res.data.listOfUsers || []);
    } catch (e) {
      if (e.name !== "CanceledError") console.warn("User refresh failed", e);
    }
  };

  refreshUsers(); // initial
  const t = setInterval(refreshUsers, FILTERS_REFRESH_MS);
  return () => { ctrl.abort(); clearInterval(t); };
}, [instanceUniqueId]);

// Re-scan canonical production reps every 10 minutes (server registry)
useEffect(() => {
  let cancelled = false;
  const tick = async () => {
    try {
      setRepOptionsLoading(true);
      const reps = await fetchProductionReps(instanceUniqueId || "elite-promo-marketing");
      if (!cancelled) setServerReps(reps);
    } catch (e) {
      if (!cancelled) console.warn("Production rep refresh failed", e);
    } finally {
      if (!cancelled) setRepOptionsLoading(false);
    }
  };

  tick(); // initial
  const t = setInterval(tick, FILTERS_REFRESH_MS);
  return () => { cancelled = true; clearInterval(t); };
}, [instanceUniqueId]);


// On mount: warm from cache immediately, then fetch fresh, then poll every 10m
// In the "On mount: warm from cache immediately" effect:
useEffect(() => {
  const cache = readFiltersCache();
  if (cache) {
    setDbSupplierOptions(cache.suppliers || []);
    setDbClientOptions(cache.clients || []);
    setDbShippingOptions(cache.shipping || []);
    setFiltersVersion(cache.version || cache.updatedAt || cache.ts || null);

    // NEW: warm production rep dropdown instantly if cached
    if (Array.isArray(cache.repOptions) && cache.repOptions.length) {
      setRepOptions(cache.repOptions);
    }
  }

  // ...rest of effect unchanged
}, [FILTERS_LS_KEY, instanceUniqueId]);


/* FIRST PAINT CACHE END */

// what actually drives the table:
const [applied, setApplied] = useState(filters);
const infiniteDashboardScrollEnabled =
  isPurchasingDashboardRoute &&
  purchasingDashboardSettings.infiniteDashboardScroll === true;
const [lookupMode, setLookupMode] = useState(false);
const dashboardSearchTokenRef = useRef(0);

const beginDashboardSearchSession = useCallback(() => {
  dashboardSearchTokenRef.current += 1;
  dashboardRequestPagesRef.current.clear();
  if (poAbortRef.current) poAbortRef.current.abort();
  return dashboardSearchTokenRef.current;
}, []);

  // Which filter experience is active
  const [filterTab, setFilterTab] = useState("SEARCH"); // "SEARCH" | "LOOKUP"

  // Inputs for LOOKUP mode
  const [lookupInputs, setLookupInputs] = useState({
    purchaseOrder: "",   // maps to row.poNumber
    salesOrder: "",      // maps to row.estimationId
    projectNumber: "",   // maps to row.orderId
  });

  const [isFullscreen, setIsFullscreen] = useState(false);
  const FULL_KEY = 'production-dashboard.fullscreen';
  
  
  useEffect(() => {
    // restore preference
    try {
      const saved = localStorage.getItem(FULL_KEY);
      if (saved === '1') setIsFullscreen(true);
    } catch {}
  }, []);
  
  useEffect(() => {
    const cls = 'epm-fullscreen';
    const b = document.body;
    if (isFullscreen) b.classList.add(cls);
    else b.classList.remove(cls);
  
    // persist
    try { localStorage.setItem(FULL_KEY, isFullscreen ? '1' : '0'); } catch {}
  
    // cleanup if user navigates away
    return () => b.classList.remove(cls);
  }, [isFullscreen]);

// normalize & helpers
const norm = (s) => (s ?? "").toString().trim().toLowerCase();
const inList = (val, arr) => (arr?.length ? arr.includes(val) : true);
const inListCI = (val, arr) => (arr?.length ? arr.map(norm).includes(norm(val)) : true);
const boolMatches = (val, want) => (want === null ? true : Boolean(val) === Boolean(want));

const [hasTriggeredSearch, setHasTriggeredSearch] = useState(false);

const [refineMode, setRefineMode] = useState(false);     // after the first big search, use UI filters to refine locally
const [generatedOnce, setGeneratedOnce] = useState(false); // swaps button copy after first generation


const REPORTS_API = `${process.env.REACT_APP_NODEJS_SERVER_URL}/reports`;

const [reportLoading, setReportLoading] = useState(false);
const [lastReport, setLastReport] = useState(null); // { id, url, createdAt, ... } shape from API

const [statusMenu, setStatusMenu] = useState({
  anchorEl: null,
  rowId: null,
});

// turn arrays -> comma lists and include date filters
const buildReportParams = (crit) => {
  const toList = (v) =>
    Array.isArray(v) || v instanceof Set
      ? [...v].filter(Boolean).join(",")
      : v ?? "";

  const p = {
    clientRepId: crit.clientRepId || undefined,
    orderRepId: crit.orderRepId || undefined,
    productionRepId: crit.productionRepId || undefined,
    clientIds: toList(crit.clientIds),
    supplierIds: toList(crit.supplierIds),
    shippingMethods: toList(crit.shippingMethods),
    proofStatus: toList(crit.proofStatus),
    productionRepStatus: toList(crit.productionRepStatus),
    supplierStage: toList(expandStageSelections(crit.supplierStage)),    
    firm: crit.firm === null ? undefined : !!crit.firm,
    // ⛔️ don't send nextActionTypes as labels/strings anymore
    // nextActionTypes: toList(crit.nextActionTypes),

    // dates
    dateType: crit.dateType || "nextActionDate",

    // most-recent:
    sortBy: "createdAt",
    sortDir: "desc",
    limit: 1,
  };

  // ✅ map UI selection (labels/codes/"None set") → server params
  const { ids: naIds, wantsNone } = resolveNextActionFilter(crit.nextActionTypes || []);
  if (naIds.length) p.nextAction = naIds.join(","); // e.g. "1,2,6"
  if (wantsNone) p.nextActionNone = 1;              // tell server to include rows with no NA

  // Map quick preset → server dateFrom/dateTo
  const dr = getServerDateRange(crit);
  if (dr && crit.dateQuick !== "overdue") { p.dateFrom = dr.dateFrom; p.dateTo = dr.dateTo; }

  // Back-compat: if legacy dateFrom/dateTo exist, let them override
  if (crit.dateFrom || crit.dateTo) {
    p.dateFrom = crit.dateFrom || p.dateFrom;
    p.dateTo   = crit.dateTo   || p.dateTo;
  }

  // drop empties
  Object.keys(p).forEach((k) => (p[k] === "" || typeof p[k] === "undefined") && delete p[k]);
  return p;
};

const openReportUrl = (rep) => {
  const url = rep?.url || rep?.link;
  if (url) window.open(url, "_blank", "noopener,noreferrer");
};

// --- Simple CSV export of current filtered rows ---
const simpleExportColumns = [
  { header: "PO #",            get: r => r.poNumber || "" },
  { header: "Project #",       get: r => r.orderId || "" },
  { header: "SO #",   get: r => r.estimationId || "" },
  { header: "Customer",        get: r => r.customer || "" },
  { header: "Supplier",        get: r => r.supplier || "" },
  { header: "Stage",           get: r => r.supplierStatus || "" },
  { header: "Status",          get: r => r.productionRepStatus || "" },
  { header: "Proof",           get: r => (finalizeProofSummaryForUI(r).displayStatus || "") },
  { header: "Purchasing Rep",  get: r => (r.assignedTo?.map(u => `${u.first_name||u.firstName||""} ${u.last_name||u.lastName||""}`.trim()).join(", ") || "") },
  { header: "Client Rep",      get: r => r.clientRepName || "" },
  { header: "Order Rep",       get: r => r.orderRepName || "" },
  { header: "Next Action Date",get: r => (r.nextActionDate ? new Date(r.nextActionDate).toLocaleDateString() : "") },
  { header: "In Hands Date",   get: r => {
    const ihd = resolveDashboardPoInHandsDate(r);
    const formatted = formatDashboardPoIhd(ihd);
    return formatted === "N/A" ? "" : formatted;
  } },
];

const toCsv = (rows, cols) => {
  const esc = (v) => {
    const s = (v ?? "").toString();
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = cols.map(c => esc(c.header)).join(",");
  const lines  = rows.map(r => cols.map(c => esc(c.get(r))).join(","));
  return [header, ...lines].join("\n");
};

// --- helpers (paste once, above where they're used) ---
const _startOfDay = (d) => { const x = new Date(d); x.setHours(0,0,0,0); return x; };
const _endOfDay   = (d) => { const x = new Date(d); x.setHours(23,59,59,999); return x; };
const _ymd = (d) => {
  const x = new Date(d), pad = (n) => String(n).padStart(2, "0");
  return `${x.getFullYear()}-${pad(x.getMonth()+1)}-${pad(x.getDate())}`;
};

// Map quick preset -> concrete bounds (or special modes)
const deriveDateBounds = (crit) => {
  const todayS = _startOfDay(new Date());
  const todayE = _endOfDay(new Date());

  switch (crit.dateQuick) {
    case "overdue": {
      return { mode: "range", from: null, to: todayE };
    }
    case "dueByToday":
      return { mode: "range", from: null,   to: todayE };
    case "today":
      return { mode: "range", from: todayS, to: todayE };
    case "next7": {
      const to7 = _endOfDay(new Date(todayE)); to7.setDate(to7.getDate() + 7);
      return { mode: "range", from: todayS, to: to7 };
    }
    case "custom": {
      if (!crit.dateCustom) return { mode: "none" };
      const d0 = _startOfDay(new Date(crit.dateCustom));
      const d1 = _endOfDay(new Date(crit.dateCustom));
      return { mode: "range", from: d0, to: d1 };
    }
    case "noDate":
      return { mode: "noDate" };
    default:
      return { mode: "none" }; // "any"
  }
};

const expandStageSelections = (selected = []) => {
  const GROUPS = {
    // keep your existing grouping
    "In Progress": PURCHASE_ORDER_IN_PROGRESS_STAGES,
    // NEW: Open = everything but Closed
    "Open": PURCHASE_ORDER_OPEN_STAGES,
  };
  const out = new Set();
  (selected || []).forEach((s) => {
    (GROUPS[s] || [s]).forEach((x) => out.add(x));
  });
  return Array.from(out);
};

const getServerDateRange = (crit) => {
  const b = deriveDateBounds(crit);
  if (b.mode !== "range") return null;
  return {
    dateFrom: b.from ? _ymd(b.from) : undefined,
    dateTo:   b.to   ? _ymd(b.to)   : undefined,
  };
};


const exportFilteredRowsCsv = () => {
  const rows = filteredRows; // uses the memo you already have
  if (!rows?.length) { toast("No rows to export."); return; }
  const csv = toCsv(rows, simpleExportColumns);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `production-export-${new Date().toISOString().slice(0,10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
  toast.success(`Exported ${rows.length} rows`);
};

// 1) Let handleGetRecentReport accept an optional filter source
const handleGetRecentReport = useCallback(async (sourceFilters) => {
  setReportLoading(true);
  try {
    const params = {
      instanceUniqueId,                // <— include tenant/scope if your API expects it
      ...buildReportParams(sourceFilters ?? applied),
    };

    const res = await axios.get(`${REPORTS_API}/search`, {
      params,
      headers: { accessToken: localStorage.getItem("accessToken") },
    });

    const rpt =
      res?.data?.reports?.[0] ||
      res?.data?.data?.[0] ||
      res?.data?.[0] ||
      res?.data?.report ||
      null;

    if (!rpt) {
      const go = window.confirm("No matching report found. Generate a new one now?");
      if (go) {
        await handleGetReportNow();
      } else {
        toast("No matching reports found.");
      }
      return;
    }

    setLastReport(rpt);
    openReportUrl(rpt);
  } catch (e) {
    const status = e?.response?.status;
    // Many backends return 404 on “not found” — treat it like empty results
    if (status === 404) {
      const go = window.confirm("No matching report found. Generate a new one now?");
      if (go) {
        await handleGetReportNow();
      } else {
        toast("No matching reports found.");
      }
    } else {
      console.error(e);
      toast.error(e?.response?.data?.message || "Could not fetch the recent report.");
    }
  } finally {
    setReportLoading(false);
  }
}, [applied, instanceUniqueId]);

// Recompute summary for a given PO + latest proofs
const recomputeSummary = (po, nextProofs) =>
  finalizeProofSummaryForUI({ ...po, proofs: nextProofs });

// Called by the popup whenever proofs change
const handleProofsChange = React.useCallback((poId, nextProofs, patch = {}) => {
  setPurchaseOrders(prev =>
    prev.map(po => applyProofsChangeToPurchaseOrder(po, poId, nextProofs, patch, recomputeSummary))
  );
}, []);



// Per-row magnifying glass – fetch the most recent report for that row
const handleGetRecentReportForRow = useCallback(async (row) => {
  try {
    setReportLoading(true);
    const base = buildReportParams(applied);
    const params = {
      ...base,
      // Narrow to this record – tweak to what your API expects:
      poId: row.id,
      orderId: row.orderId,
      salesOrderId: row.estimationId,
    };
    const res = await axios.get(`${REPORTS_API}/search`, {
      params,
      headers: { accessToken: localStorage.getItem("accessToken") },
    });
    const rpt =
      res?.data?.reports?.[0] ||
      res?.data?.data?.[0] ||
      res?.data?.[0] ||
      res?.data?.report ||
      null;

    if (!rpt) { toast("No report found for this row."); return; }
    setLastReport(rpt);
    openReportUrl(rpt);
  } catch (e) {
    console.error(e);
    toast.error(e?.response?.data?.message || "Could not fetch report for this row.");
  } finally {
    setReportLoading(false);
  }
}, [applied]);

// General "get-report" (now) — ignores filters if your API generates a fresh default
const handleGetReportNow = useCallback(async () => {
  try {
    setReportLoading(true);
    const res = await axios.post(`${REPORTS_API}/get-report`, {}, {
      headers: { accessToken: localStorage.getItem("accessToken") },
    });
    const rpt = res?.data?.report || res?.data || null;
    if (!rpt) { toast("No report returned."); return; }
    setLastReport(rpt);
    openReportUrl(rpt);
  } catch (e) {
    console.error(e);
    toast.error(e?.response?.data?.message || "Could not generate the report.");
  } finally {
    setReportLoading(false);
  }
}, []);

const isEmptyFilters = (f) => {
  const has = (a) => Array.isArray(a) && a.length > 0;
  return !(
    f.clientRepId || f.orderRepId || f.productionRepId ||
    has(f.supplierIds) || has(f.clientIds) || has(f.shippingMethods) ||
    has(f.proofStatus) || has(f.productionRepStatus) || has(f.supplierStage) ||
    f.firm !== null || has(f.nextActionTypes) ||
    (f.dateFrom && f.dateFrom.trim()) || (f.dateTo && f.dateTo.trim())
  );
};
const filtersEmpty = useMemo(() => isEmptyFilters(filters), [filters]);

const [poLoading, setPoLoading] = useState(false);
const poAbortRef = useRef(null)

// near your other refs/state
const gridWrapRef = useRef(null);
const [hoverIcon, setHoverIcon] = useState({ visible: false, top: 0, row: null });

// handlers
const handleCellMouseEnter = (params, event) => {
  // only show for real PO rows (skip SO group rows etc.)
  if (!params?.row || params.row.rowType !== "PO") {
    setHoverIcon(s => ({ ...s, visible: false }));
    return;
  }

  const wrap = gridWrapRef.current;
  if (!wrap) return;

  // position the icon at the middle of the hovered cell (relative to wrapper)
  const wrapRect = wrap.getBoundingClientRect();
  const cellRect = event.currentTarget.getBoundingClientRect();
  const top = cellRect.top - wrapRect.top + cellRect.height / 2;

  setHoverIcon({ visible: true, top, row: params.row });
};

const handleGridMouseLeave = () => {
  setHoverIcon(s => ({ ...s, visible: false, row: null }));
};

// Canonicalize PO numbers: "PO-198" -> "198", " po_0198 " -> "0198"
const canonPo = (s) =>
  (s ?? "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "")   // strip spaces, hyphens, etc
    .replace(/^po/, "");         // drop "po" prefix if present

const canonStr = (s) =>
  (s ?? "").toString().trim().toLowerCase();

const equalsIfGiven = (input, candidate, canon = (x)=>x) => {
  if (!input) return true;                 // no filter provided => pass
  if (candidate == null) return false;
  return canon(input) === canon(candidate); // exact after canonicalization
};

// ───────────────────────────────
// LOOKUP: exact PO / SO / Project
// ───────────────────────────────
const handleLookup = useCallback(async () => {
  const requestToken = beginDashboardSearchSession();
  const ctrl = new AbortController();
  poAbortRef.current = ctrl;

  const poInput   = (lookupInputs.purchaseOrder || "").trim();
  const soInput   = (lookupInputs.salesOrder || "").trim();
  const projInput = (lookupInputs.projectNumber || "").trim();

  if (!poInput && !soInput && !projInput) {
    toast("Enter at least one value.");
    return;
  }

  setPoLoading(true);
  try {
    // 1) Try backend lookup (if wired)
    let data;
    try {
      data = await lookupPurchaseOrders({
        instanceUniqueId,
        purchaseOrder: poInput || undefined,
        salesOrder:    soInput || undefined,
        projectNumber: projInput || undefined,
        signal:        ctrl.signal,
      });
    } catch (e) {
      // ignore and fallback to client-side below
      if (e?.name === "CanceledError" || e?.code === "ERR_CANCELED") return;
    }

    const fromServer =
      data?.purchaseOrders || data?.data || data || [];

    if (fromServer.length) {
      if (isStalePurchasingDashboardRequest({
        requestToken,
        activeToken: dashboardSearchTokenRef.current,
      })) {
        return;
      }
      setPurchaseOrders(fromServer);
      setDashboardFetchMeta(buildTerminalLookupMeta(fromServer));
      dashboardRequestPagesRef.current.clear();
      setHasTriggeredSearch(true);
      setRefineMode(true);
      setLookupMode(true);
      return;
    }

    // 2) Fallback: pull ALL, then filter locally (bandaid, but fast to ship)
    const headers = { accessToken: localStorage.getItem("accessToken") };
    const resAll = await axios.get(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/purchase-order`,
      { headers, signal: ctrl.signal }
    );
    const all = resAll?.data?.purchaseOrders || resAll?.data?.data || resAll?.data || [];

    // exact-after-canonical matching:
    const filtered = all.filter((po) => {
      // poNumber: match canonically ("PO-198" == "198")
      const poOk = equalsIfGiven(poInput, po.poNumber, canonPo);

      // sales order: present as top-level salesOrderId OR nested salesOrder.estimationId
      const soCandidate = po.salesOrderId ?? po.salesOrder?.estimationId ?? null;
      const soOk = equalsIfGiven(soInput, soCandidate, canonStr);

      // project #: orderId on the PO
      const projOk = equalsIfGiven(projInput, po.orderId, canonStr);

      // If multiple inputs are filled, all must match
      return poOk && soOk && projOk;
    });

    if (isStalePurchasingDashboardRequest({
      requestToken,
      activeToken: dashboardSearchTokenRef.current,
    })) {
      return;
    }
    setPurchaseOrders(filtered);
    setDashboardFetchMeta(buildTerminalLookupMeta(filtered));
    dashboardRequestPagesRef.current.clear();
    setHasTriggeredSearch(true);
    setRefineMode(true);
    setLookupMode(true);

    if (!filtered.length) {
      toast("No matching purchase orders.");
    }
  } catch (e) {
    if (e?.name !== "CanceledError" && e?.code !== "ERR_CANCELED") {
      console.error(e);
      toast.error(e?.response?.data?.message || "Lookup failed.");
    }
  } finally {
    if (!isStalePurchasingDashboardRequest({
      requestToken,
      activeToken: dashboardSearchTokenRef.current,
    })) {
      setPoLoading(false);
    }
  }
}, [beginDashboardSearchSession, instanceUniqueId, lookupInputs]);

// Track which row ids are currently saving stage

// Optimistically change supplier stage + persist
const handleSupplierStageChange = useCallback(async (rowId, nextStage) => {
  if (!rowId || !nextStage) return;

  // prevent double-requests on same row
  setSavingStage(prev => {
    const s = new Set(prev);
    s.add(rowId);
    return s;
  });

  let prevStage = null;

  // optimistic UI
  setPurchaseOrders(prev =>
    prev.map(po => {
      if (po.id === rowId) {
        prevStage = po.supplierStatus ?? null;
        return { ...po, supplierStatus: nextStage };
      }
      return po;
    })
  );

  try {
    await axios.patch(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/purchase-order/${rowId}`,
      { supplierStatus: nextStage },
      { headers: { accessToken: localStorage.getItem("accessToken") } }
    );
    toast.success(`Stage → ${nextStage}`);
  } catch (e) {
    // revert on failure
    setPurchaseOrders(prev =>
      prev.map(po => (po.id === rowId ? { ...po, supplierStatus: prevStage } : po))
    );
    toast.error(e?.response?.data?.message || "Failed to save stage");
  } finally {
    setSavingStage(prev => {
      const s = new Set(prev);
      s.delete(rowId);
      return s;
    });
  }
}, []);

const loadPurchaseOrders = useCallback(async (f = filters, options = {}) => {
  const requestToken = options.requestToken ?? beginDashboardSearchSession();
  const ctrl = new AbortController();
  poAbortRef.current = ctrl;

  setPoLoading(true);
  try {
    const headers = { accessToken: localStorage.getItem("accessToken") };
    const params = {
      instanceUniqueId,
      clientRepId: f.clientRepId || undefined,
      orderRepId: f.orderRepId || undefined,
      productionRepId: f.productionRepId || undefined,
      clientIds: (f.clientIds || []).join(",") || undefined,
      supplierIds: (f.supplierIds || []).join(",") || undefined,
      shippingMethods: (f.shippingMethods || []).join(",") || undefined,
      proofStatus: (f.proofStatus || []).join(",") || undefined,
      productionRepStatus: (f.productionRepStatus || []).join(",") || undefined,
      supplierStage: expandStageSelections(f.supplierStage || []).join(",") || undefined,
      firm: f.firm === null ? undefined : !!f.firm,
      ...( (() => {
        const { ids, wantsNone } = resolveNextActionFilter(f.nextActionTypes || []);
        const p = {};
        if (ids.length) p.nextAction = ids.join(",");
        if (wantsNone) p.nextActionNone = 1;
        return p;
      })() ),
      dateType: f.dateType || undefined,
      dateQuick: f.dateQuick || undefined,
      dateFrom: f.dateFrom || undefined,
      dateTo: f.dateTo || undefined,
      sortBy,
      sortDir,
    };
    const res = await axios.get(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/purchase-order`,
      { params, headers, signal: ctrl.signal }
    );
    if (isStalePurchasingDashboardRequest({
      requestToken,
      activeToken: dashboardSearchTokenRef.current,
    })) {
      return;
    }
    const nextRows = res?.data?.purchaseOrders || res?.data?.data || res?.data || [];
    setPurchaseOrders(nextRows);
    setDashboardFetchMeta(
      res?.data?.meta || {
        page: 1,
        limit: rowsPerPage,
        total: nextRows.length,
        hasMore: false,
      }
    );

    if (isEmptyFilters(f)) {
      await fetchDbFilterOptions({ checkOnly: false });
    }
  } catch (e) {
    if (e.name !== "CanceledError") {
      console.error(e);
      toast.error(e?.response?.data?.message || "Could not fetch purchase orders.");
    }
  } finally {
    if (!isStalePurchasingDashboardRequest({
      requestToken,
      activeToken: dashboardSearchTokenRef.current,
    })) {
      setPoLoading(false);
    }
  }
}, [beginDashboardSearchSession, filters, instanceUniqueId, resolveNextActionFilter, rowsPerPage, sortBy, sortDir]);

const loadPurchaseOrdersPage = useCallback(async ({
  filters: nextFilters = applied,
  page = 1,
  append = false,
  limit = rowsPerPage,
  requestToken = dashboardSearchTokenRef.current,
} = {}) => {
  if (!infiniteDashboardScrollEnabled) {
    await loadPurchaseOrders(nextFilters);
    return;
  }

  const requestKey = `${page}:${limit}:${sortBy}:${sortDir}:${JSON.stringify(nextFilters)}`;
  if (dashboardRequestPagesRef.current.has(requestKey)) return;
  dashboardRequestPagesRef.current.add(requestKey);

  if (poAbortRef.current) poAbortRef.current.abort();
  const ctrl = new AbortController();
  poAbortRef.current = ctrl;

  setPoLoading(true);
  try {
    const headers = { accessToken: localStorage.getItem("accessToken") };
    const params = {
      instanceUniqueId,
      clientRepId: nextFilters.clientRepId || undefined,
      orderRepId: nextFilters.orderRepId || undefined,
      productionRepId: nextFilters.productionRepId || undefined,
      clientIds: (nextFilters.clientIds || []).join(",") || undefined,
      supplierIds: (nextFilters.supplierIds || []).join(",") || undefined,
      shippingMethods: (nextFilters.shippingMethods || []).join(",") || undefined,
      proofStatus: (nextFilters.proofStatus || []).join(",") || undefined,
      productionRepStatus: (nextFilters.productionRepStatus || []).join(",") || undefined,
      supplierStage: expandStageSelections(nextFilters.supplierStage || []).join(",") || undefined,
      firm: nextFilters.firm === null ? undefined : !!nextFilters.firm,
      ...( (() => {
        const { ids, wantsNone } = resolveNextActionFilter(nextFilters.nextActionTypes || []);
        const p = {};
        if (ids.length) p.nextAction = ids.join(",");
        if (wantsNone) p.nextActionNone = 1;
        return p;
      })() ),
      dateType: nextFilters.dateType || undefined,
      dateFrom: nextFilters.dateFrom || undefined,
      dateTo: nextFilters.dateTo || undefined,
      sortBy,
      sortDir,
      page,
      limit,
    };

    const res = await axios.get(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/purchase-order`,
      { params, headers, signal: ctrl.signal }
    );
    if (isStalePurchasingDashboardRequest({
      requestToken,
      activeToken: dashboardSearchTokenRef.current,
    })) {
      return;
    }
    const nextRows = res?.data?.purchaseOrders || res?.data?.data || res?.data || [];
    setDashboardFetchMeta(
      res?.data?.meta || {
        page,
        limit,
        total: nextRows.length,
        hasMore: false,
      }
    );
    setPurchaseOrders((prev) =>
      append ? dedupePurchaseOrdersById(prev, nextRows) : nextRows
    );
  } catch (e) {
    if (e.name !== "CanceledError") {
      console.error(e);
      toast.error(e?.response?.data?.message || "Could not fetch purchase orders.");
    }
  } finally {
    dashboardRequestPagesRef.current.delete(requestKey);
    if (!isStalePurchasingDashboardRequest({
      requestToken,
      activeToken: dashboardSearchTokenRef.current,
    })) {
      setPoLoading(false);
    }
  }
}, [
  applied,
  dashboardRequestPagesRef,
  infiniteDashboardScrollEnabled,
  instanceUniqueId,
  loadPurchaseOrders,
  resolveNextActionFilter,
  rowsPerPage,
  sortBy,
  sortDir,
]);

const runPurchaseOrderSearch = useCallback(async (nextFilters = filters) => {
  const requestToken = beginDashboardSearchSession();
  setApplied(nextFilters);
  setHasTriggeredSearch(true);
  setRefineMode(true);
  setLookupMode(false);
  setTablePage(0);

  if (infiniteDashboardScrollEnabled) {
    skipNextInfiniteReloadRef.current = true;
    await loadPurchaseOrdersPage({
      filters: nextFilters,
      page: 1,
      append: false,
      limit: rowsPerPage,
      requestToken,
    });
    return;
  }

  await loadPurchaseOrders(nextFilters, { requestToken });
}, [
  beginDashboardSearchSession,
  filters,
  infiniteDashboardScrollEnabled,
  loadPurchaseOrders,
  loadPurchaseOrdersPage,
  rowsPerPage,
]);


// Abort on unmount
useEffect(() => () => poAbortRef.current?.abort(), []);

// master list with labels and builders (reuses your renderers where possible)
const COLUMN_DEFS = {
  status: {
    label: "Status",
    build: () => ({
      field: "productionRepStatus",
      headerName: "Status",
      width: 140,
      sortable: true,
      renderCell: ({ row }) => {
        const saving = isRowSaving(row.id); // ← combines savingNaDate/savingStage/savingStatus
  
        return (
          <Box sx={{ position: "relative", width: "100%" }}>
            <Box
              sx={{
                pointerEvents: saving ? "none" : "auto",
                opacity: saving ? 0.7 : 1,
              }}
            >
              <StatusPill
                status={row.productionRepStatus}
                onClick={(e) => !saving && openStatusMenu(e, row)}
              />
            </Box>
  
            {saving && (
              <CircularProgress
                size={16}
                thickness={6}
                sx={{
                  position: "absolute",
                  top: "50%",
                  right: 6,
                  transform: "translateY(-50%)",
                }}
              />
            )}
          </Box>
        );
      },
    }),
  },  
  stage: {
    label: "Stage",
    build: () => ({
      field: "supplierStatus",
      headerName: "Stage",
      width: STAGE_MIN_COL_WIDTH,
      sortable: true,
      renderCell: ({ row }) => {
        const current = row.supplierStatus || "";
        const isSaving = savingStage.has(row.id);
        const productionControlled = row.productionStageControlled === true;
        const stagePalette = theme.palette[{
          Received: "info",
          "Production Scheduled": "primary",
          "In Progress": "warning",
          "Production Complete": "success",
        }[current]];
        const stageColor = stagePalette
          ? stagePalette[theme.palette.mode === "dark" ? "light" : "dark"]
          : theme.palette.text.secondary;
  
        const handleChange = async (e) => {
          if (productionControlled) return;
          const next = e.target.value;
          const prev = current;
  
          // optimistic update
          setPurchaseOrders(prevList =>
            prevList.map(po => (po.id === row.id ? { ...po, supplierStatus: next } : po))
          );
  
          // mark saving
          setSavingStage(prevSet => new Set(prevSet).add(row.id));
  
          try {
            await axios.patch(
              `${process.env.REACT_APP_NODEJS_SERVER_URL}/purchase-order/${row.id}`,
              { supplierStatus: next },
              { headers: { accessToken: localStorage.getItem("accessToken") } }
            );
            toast.success("Stage updated");
          } catch (e) {
            // revert on failure
            setPurchaseOrders(prevList =>
              prevList.map(po => (po.id === row.id ? {
                ...po, supplierStatus: prev,
                ...(e?.response?.data?.error === "PO_STAGE_CONTROLLED_BY_PRODUCTION" ? {
                  productionStageControlled: true,
                  productionStageControlReason: e.response.data.message,
                } : {}),
              } : po))
            );
            toast.error(e?.response?.data?.message || "Failed to save stage");
          } finally {
            setSavingStage(prevSet => {
                const s = new Set(prevSet);
                s.delete(row.id);
              return s;
            });
          }
        };
  
        return (
          <FormControl size="small" fullWidth disabled={isSaving || productionControlled} sx={{ minWidth: 0 }}>
            <Select
              value={current}
              onChange={handleChange}
              displayEmpty
              inputProps={{ "aria-label": `Stage for PO ${row.poNumber || row.id}`,
                "aria-describedby": productionControlled ? `production-stage-reason-${row.id}` : undefined }}
              renderValue={(v) => v || "N/A"}
              sx={{
                fontSize: "inherit",
                fontWeight: 600,
                lineHeight: 1.35,
                color: stageColor,
                bgcolor: alpha(stageColor, 0.08),
                border: `1px solid ${alpha(stageColor, 0.3)}`,
                borderRadius: 1.5,
                "&:hover": { borderColor: stageColor },
                "&.Mui-focused": { boxShadow: `0 0 0 2px ${alpha(stageColor, 0.16)}` },
                "& .MuiOutlinedInput-notchedOutline": { border: 0 },
                "& .MuiSelect-select": {
                  display: "flex",
                  alignItems: "center",
                  height: "auto",
                  minHeight: "2.7em",
                  boxSizing: "content-box",
                  padding: "6px 30px 6px 10px",
                  whiteSpace: "normal",
                  overflowWrap: "break-word",
                  textOverflow: "clip",
                },
                "& .MuiSelect-icon": { right: 6, color: "inherit" },
                "& .MuiSelect-select.Mui-disabled": { WebkitTextFillColor: stageColor },
              }}
            >
              {purchaseOrderStatusOptions.map(opt => (
                <MenuItem key={opt.id} value={opt.id}>{opt.name}</MenuItem>
              ))}
            </Select>
            {productionControlled && (
              <FormHelperText id={`production-stage-reason-${row.id}`} title={row.productionStageControlReason}
                sx={{ mx: 0, mt: 0.5, whiteSpace: "normal", lineHeight: 1.3, fontSize: "0.7rem" }}>
                Scheduled or active work: managed in Production
              </FormHelperText>
            )}
          </FormControl>
        );
      },
    }),
  },
  
  proofStatus: {
    label: "Proof Status",
    build: () => ({
      field: 'proofStatus',
      headerName: 'Proof',
      width: 260,
      valueGetter: (value, row) => {
        const ps = finalizeProofSummaryForUI(row || {});
        return ps.displayStatus === 'Not Required' ? '' : (ps.displayStatus || '');
      },
      renderCell: ({ row }) => {
        const ps = finalizeProofSummaryForUI(row);
        const shortLabelMap = { 'Pending Approval':'Pending','Proof Needed':'Needed','Not Required':'No Proof','Proof Complete':'Complete' };
        const labelFull = ps.displayStatus || 'Not Required';
        // If proof is not required, render a blank cell (no pill, no button)
        // 👇 For "Not Required", render a blank-but-truthy node
        if (labelFull === 'Not Required') {
          return <span style={{ display: 'inline-block', width: '100%' }} aria-hidden="true" />;
        }
        const label = shortLabelMap[labelFull] || labelFull;
        const colorMap = { 'Approved':'#16a34a','Complete':'#7c3aed','Rejected':'#dc2626','Pending':'#d97706','Uploaded':'#2563eb','Requested':'#6b7280','Needed':'#6b7280','No Proof':'#9ca3af' };
        const pillColor = colorMap[label] || '#6b7280';
        const pillBg = `${pillColor}22`;
        const showOrbs = labelFull !== 'Not Required';
        const pill = (
          <Box onClick={() => handleOpenProof(row)} sx={{ display:'flex', alignItems:'center', gap:1, color:pillColor, bgcolor:pillBg, px:1, py:0.25, borderRadius:1, fontSize:'0.8rem', fontWeight:600, lineHeight:1.4, minWidth:0, maxWidth:'100%', cursor:'pointer', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }} title="Open proof details">
            <InsertDriveFileIcon sx={{ fontSize: 16, flexShrink: 0 }} />
            <span>{label}</span>
            {showOrbs && <CompactApprovalOrbs proofs={row.proofs} onClick={() => handleOpenProof(row)} />}
          </Box>
        );
        return <Tooltip arrow placement="top" title={buildProofTooltip(ps)}>{pill}</Tooltip>;
      }
    })
  },
  proofCompletion: {
    label: "Proof Complete",
    build: () => ({
      field: "canMarkProofComplete",
      headerName: "Proof",
      width: 84,
      renderCell: ({ row }) => {
        const loading = savingProofCompletion.has(row.id);
        const noProof = isNoProofPurchaseOrder(row);
        const centerSx = {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        };

        if (noProof) {
          return <Box sx={centerSx} aria-hidden="true" />;
        }

        if (row.proofStatus === "Proof Complete") {
          return (
            <Tooltip arrow placement="top" title="Proofing complete">
              <Box sx={centerSx}>
                <CheckCircleIcon sx={{ color: "#16a34a", fontSize: 20 }} />
              </Box>
            </Tooltip>
          );
        }

        if (row.canMarkProofComplete === true) {
          return (
            <Tooltip arrow placement="top" title="Mark proofing complete">
              <Box sx={centerSx}>
                <span>
                  <IconButton
                    size="small"
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      handleMarkProofComplete(row);
                    }}
                    disabled={loading}
                    aria-label="Mark proofing complete"
                  >
                    {loading ? (
                      <CircularProgress size={16} />
                    ) : (
                      <CheckCircleIcon sx={{ color: "#15803d", fontSize: 20 }} />
                    )}
                  </IconButton>
                </span>
              </Box>
            </Tooltip>
          );
        }

        return (
          <Tooltip arrow placement="top" title="Proofs must be uploaded and fully approved first.">
            <Box sx={{ ...centerSx, opacity: 0.5 }}>
              <CancelIcon sx={{ fontSize: 20, color: "#6b7280" }} />
            </Box>
          </Tooltip>
        );
      },
    }),
  },
  client: {
    label: "Client",
    build: () => ({
      field: 'customer',
      headerName: 'Customer',
      width: 200,
      renderCell: ({ row }) =>
        row.customerId ? (
          <Link to={`/instance/elite-promo-marketing/sales/customers?openCustomer=${row.customerId}`} target="_blank" style={{ textDecoration:'none', color:'#1976d2' }}>
            {row.customer}
          </Link>
        ) : row.customer
    })
  },
  projectName: {
    label: "Project Name",
    build: (instanceUniqueId) => ({
      field: "projectName",
      headerName: "Project Name",
      width: 220,
      renderCell: ({ row }) => (
        row.orderId ? (
          <Link
            to={`/instance/${instanceUniqueId}/sales/orders/${row.orderId}/overview`}
            target="_blank"
            style={{ textDecoration: "none", color: "#1976d2" }}
          >
            {row.projectName || "—"}
          </Link>
        ) : (row.projectName || "—")
      ),
    }),
  },  
  projectNumber: {
    label: "Project #",
    build: () => ({
      field: 'orderId',
      headerName: 'Project #',
      width: 120,
      renderCell: ({ row }) => (
        <Link to={`/instance/elite-promo-marketing/sales/orders/${row.orderId}/overview`} target="_blank" style={{ textDecoration:'none', color:'#1976d2' }}>
          {row.orderId}
        </Link>
      )
    })
  },
  salesOrderNumber: {
    label: "Sales Order #",
    build: (instanceUniqueId) => ({
      field: "estimationId",
      headerName: "Sales Order #",
      width: 140,
      renderCell: ({ row }) => {
        const estId = row.estimationId;
        if (!estId) return "—";
        const documentRouteSegment =
          row?.documentType === "estimate" || row?.documentType === "estimation"
            ? "estimation"
            : "sales-order";
        return (
          <Link
            to={`/instance/${instanceUniqueId}/sales/orders/${row.orderId}/${documentRouteSegment}/${estId}`}
            target="_blank"
            style={{ textDecoration: "none", color: "#1976d2" }}
          >
            {estId}
          </Link>
        );
      },
    }),
  },  
  /*poTotal: {
    label: "PO Total",
    build: () => ({
      field: 'total',
      headerName: 'PO Total',
      width: 120,
      valueGetter: (value, row) => (row?.total != null ? `$${row.total.toFixed(2)}` : 'N/A'),
    })
  },
  report: {
    label: "Report",
    build: () => ({
      field: 'report',
      headerName: '',
      width: 56,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: ({ row }) => (
        <Tooltip title="Open latest report for this PO" arrow>
          <IconButton
            size="small"
            onClick={() => handleGetRecentReportForRow(row)}
          >
            <LaunchIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    }),
  },*/
  clientRep: {
    label: "Client Rep",
    build: () => ({
      field: 'clientRep',
      headerName: 'Client Rep',
      width: 220,
      valueGetter: (value, row) => row?.clientRepName || '—',
      renderCell: ({ row }) => {
        const name = row?.clientRepName || '—';
        if (!name || name === '—') return <span>—</span>;

        const avatarSrc = normalizeAvatarUrl(
          row?.clientRepAvatar ||
          row?.clientRepObj?.avatarUrl ||
          row?.clientRepObj?.profilePicture ||
          row?.clientRepObj?.avatar ||
          row?.clientRepObj?.photoUrl ||
          row?.clientRepDetails?.avatarUrl ||
          row?.clientRepDetails?.profilePicture ||
          row?.clientRepDetails?.avatar ||
          row?.clientRepDetails?.photoUrl ||
          null
        );
        const title = row?.clientRepFallbackRole === "administrator"
          ? `${name} — administrator fallback`
          : name;

        return (
          <Tooltip title={title} arrow>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
              <Avatar
                src={avatarSrc || undefined}
                sx={{ width: 32, height: 32, fontSize: 12, flexShrink: 0 }}
              >
                {getInitials(name)}
              </Avatar>
              <Box component="span" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {name}
              </Box>
            </Stack>
          </Tooltip>
        );
      },
    })
  },
  orderRep: {
    label: "Order Rep",
    build: () => ({
      field: 'orderRep',
      headerName: 'Order Rep',
      width: 200,
      valueGetter: (value, row) => row?.orderRepName || '—',
    })
  },
  productionRep: {
    label: "Purchaser",
    build: () => ({
      field: 'productionRep',
      headerName: 'Rep',
      width: 220,
      renderCell: ({ row }) => {
        const reps = row.assignedTo || [];
        if (!reps.length) return <span>—</span>;
        return (
          <Stack direction="row" spacing={1} alignItems="center">
            {reps.map(r => (
              <Stack key={r.id} direction="row" spacing={1} alignItems="center">
                <Avatar src={r.profilePicture || undefined} sx={{ width:37, height:37, fontSize:12 }}>
                  {`${(r.first_name||'')[0]||''}${(r.last_name||'')[0]||''}`.toUpperCase()}
                </Avatar>
                <span>{`${r.first_name || ''} ${r.last_name || ''}`.trim()}</span>
              </Stack>
            ))}
          </Stack>
        );
      }
    })
  },
  nextActionType: {
    label: "Next Action Type",
    build: () => ({
      field: 'nextActionType',
      headerName: 'Next Action',
      width: 180,
      valueGetter: (value, row) => row?.nextActionLabel || '—',
    })
  },  
  nextActionDate: {
    label: "Next Action Date",
    build: () => ({
      field: "nextActionDate",
      headerName: "NA Date",
      width: 170,
      sortable: true,
      renderCell: ({ row }) => {
        const baseYmd = asYmd(row.nextActionDate);        // ✅ robust base
        const isSaving = savingNaDate.has(row.id);
        const draftVal = getDraft(row.id);
        const value = draftVal != null ? draftVal : baseYmd;
  
        const commit = async (finalYmd) => {
          // no change → nothing to do
          if ((finalYmd || "") === (baseYmd || "")) {
            setDraft(row.id, null);
            return;
          }
          // guard against partial input like "2025-" from the native picker
          if (finalYmd && !/^\d{4}-\d{2}-\d{2}$/.test(finalYmd)) return;
  
          await handleNextActionDateChange(row, finalYmd || "");
          setDraft(row.id, null);
        };
  
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
            <TextField
              type="date"
              size="small"
              fullWidth
              value={value}
              disabled={isSaving}
              // ✅ commit immediately so picker selections always stick
              onChange={(e) => {
                const v = e.target.value;
                setDraft(row.id, v);
                commit(v);
              }}
              // still keep these as backups
              onBlur={(e) => commit(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") commit(e.currentTarget.value);
                if (e.key === "Escape") setDraft(row.id, null);
              }}
              inputProps={{ "aria-label": "Next Action Date" }}
            />
            {isSaving && <CircularProgress size={16} thickness={6} />}
          </Box>
        );
      },
    }),
  },
  createdAt: {
    label: "Creation Date",
    build: () => ({
      field: "createdAt",
      headerName: "Creation Date",
      width: 150,
      sortable: true,
      renderCell: ({ row }) => {
        const createdAt = getDateSortValue(row.createdAt || row.poCreated);
        return createdAt
          ? new Date(createdAt).toLocaleDateString()
          : "N/A";
      },
    }),
  },
  inHandsDate: {
    label: "In Hands Date",
    build: () => ({
      field: 'inHandsDate',
      headerName: 'IH Date',
      width: 130,
      renderCell: ({ row }) => {
        const ihd = resolveDashboardPoInHandsDate(row);
        const meaningLabel = getDashboardPoInHandsMeaningLabel(row);
        return (
          <Tooltip title={meaningLabel} arrow placement="top">
            <Box sx={{ backgroundColor:'#EEE', borderRadius:'4px', px:1, py:0.5, textAlign:'center', width:'100%' }}>
              <Box sx={{ fontSize:'0.875rem' }}>{formatDashboardPoIhd(ihd)}</Box>
            </Box>
          </Tooltip>
        );
      }
    })
  },
  supplier: {
    label: "Supplier",
    build: () => ({
      field: 'supplier',
      headerName: 'Supplier',
      width: 200,
      valueGetter: (value, row) => row?.supplier || 'N/A',
    })
  },
  costsConfirmed: {
    label: "Costs Confirmed",
    build: () => ({
      field: "costsConfirmed",
      headerName: "Costs Confirmed",
      width: 150,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: ({ row }) => (
        <Tooltip title="Internal human review only. Does not affect PO generation, approvals, or financial calculations." arrow>
          <span>
            <Checkbox
              size="small"
              checked={row.costsConfirmed === true}
              disabled={savingCostsConfirmed.has(row.id)}
              inputProps={{ "aria-label": `Costs confirmed for PO ${row.poNumber || row.id}` }}
              onClick={(event) => event.stopPropagation()}
              onDoubleClick={(event) => event.stopPropagation()}
              onChange={(event) => {
                event.stopPropagation();
                handleCostsConfirmedChange(row, event.target.checked);
              }}
            />
          </span>
        </Tooltip>
      ),
    }),
  },
  poNumber: {
    label: "PO #",
    build: () => ({
      field: "poNumber",
      headerName: "PO #",
      width: 120,
      renderCell: ({ row }) => {
        const poId = row.id; // numeric unique id from your data
        const label = row.poNumber || (poId != null ? String(poId) : "—");
        if (!poId) return label || "—";
        return (
          <a
            href={`/generated-purchase-order/${poId}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "#1976d2" }}
          >
            {label}
          </a>
        );
      },
    }),
  },
  
  
};

// default visible set (tweak to your taste)
const DEFAULT_VISIBLE = [
  "supplier","poNumber","costsConfirmed","projectNumber","status","stage","proofStatus","proofCompletion",
  "client","productionRep","createdAt","nextActionDate","inHandsDate","poTotal","report"
];

// UI state
const [visibleCols, setVisibleCols] = useState(DEFAULT_VISIBLE);
const [columnOrder, setColumnOrder] = useState([]);
const [hoveredColumnId, setHoveredColumnId] = useState(null);
const [colMenuEl, setColMenuEl] = useState(null);
const openColMenu = Boolean(colMenuEl);
const columnsStorageKey = (id) => `production-dashboard.columns.${id}`;
const normalizeVisibleColsPreference = (value) => {
  const source = Array.isArray(value) ? value : DEFAULT_VISIBLE;
  const valid = source.filter((key) => COLUMN_DEFS[key]);
  return valid.length ? valid : DEFAULT_VISIBLE;
};
const getDefaultColumnOrder = useCallback(() => [
  ...DEFAULT_VISIBLE,
  ...Object.keys(COLUMN_DEFS).filter((key) => !DEFAULT_VISIBLE.includes(key)),
], []);
const normalizeColumnOrderPreference = useCallback((value) => {
  const knownIds = Object.keys(COLUMN_DEFS);
  const defaultOrder = getDefaultColumnOrder();
  const source = Array.isArray(value) ? value : [];
  const deduped = [];
  source.forEach((key) => {
    if (knownIds.includes(key) && !deduped.includes(key)) deduped.push(key);
  });
  const baseOrder = deduped.length ? deduped : defaultOrder;
  return [
    ...baseOrder.filter((key) => knownIds.includes(key)),
    ...defaultOrder.filter((key) => !baseOrder.includes(key)),
  ];
}, [getDefaultColumnOrder]);

// load/save preferences per user + instance
useEffect(() => {
  const savedPrefs = safeReadDashboardPrefs(DASHBOARD_PREFS_LS_KEY);
  const legacyWidth = localStorage.getItem(COL_WIDTH_LS_KEY);
  const legacyColumns = (() => {
    try {
      const raw = localStorage.getItem(columnsStorageKey(instanceUniqueId));
      return raw ? JSON.parse(raw) : null;
    } catch (_err) {
      return null;
    }
  })();

  setColWidth(clampColWidth(savedPrefs?.colWidth ?? legacyWidth ?? DEFAULT_COL_WIDTH));
  setDensity(sanitizeDensityPreference(savedPrefs?.density));
  setVisibleCols(normalizeVisibleColsPreference(savedPrefs?.visibleCols ?? legacyColumns));
  skipNextDashboardPrefsWriteRef.current = true;
}, [DASHBOARD_PREFS_LS_KEY, COL_WIDTH_LS_KEY, instanceUniqueId]);

useEffect(() => {
  if (skipNextDashboardPrefsWriteRef.current) {
    skipNextDashboardPrefsWriteRef.current = false;
    return;
  }

  safeWriteDashboardPrefs(DASHBOARD_PREFS_LS_KEY, {
    colWidth: clampColWidth(colWidth),
    density: sanitizeDensityPreference(density),
    visibleCols: normalizeVisibleColsPreference(visibleCols),
  });
}, [DASHBOARD_PREFS_LS_KEY, colWidth, density, visibleCols]);

useEffect(() => {
  let nextOrder = getDefaultColumnOrder();
  try {
    const raw = localStorage.getItem(COLUMN_ORDER_LS_KEY);
    if (raw) {
      nextOrder = normalizeColumnOrderPreference(JSON.parse(raw));
    }
  } catch (_err) {
    nextOrder = getDefaultColumnOrder();
  }
  skipNextColumnOrderWriteRef.current = true;
  setColumnOrder(nextOrder);
}, [COLUMN_ORDER_LS_KEY, getDefaultColumnOrder, normalizeColumnOrderPreference]);

useEffect(() => {
  if (skipNextColumnOrderWriteRef.current) {
    skipNextColumnOrderWriteRef.current = false;
    return;
  }
  try {
    localStorage.setItem(COLUMN_ORDER_LS_KEY, JSON.stringify(normalizeColumnOrderPreference(columnOrder)));
  } catch (_err) {}
}, [COLUMN_ORDER_LS_KEY, columnOrder, normalizeColumnOrderPreference]);

const toggleCol = (key) =>
  setVisibleCols((prev) =>
    prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
  );

const selectAllCols = () => setVisibleCols(Object.keys(COLUMN_DEFS));
const clearAllCols  = () => setVisibleCols([]);

/* */

// --- helpers: merge the row with the full PO, only filling gaps ---
const getFullPOById = React.useCallback(
  (id) => (purchaseOrders || []).find(p => String(p?.id) === String(id)) || null,
  [purchaseOrders]
);

// treat empty string and empty arrays as "missing"
const _isMissing = (v) =>
  v == null || v === "" || (Array.isArray(v) && v.length === 0);

// fills missing top-level fields from `full`, shallowly;
// also lightly merges nested salesOrder
const mergeMissingFromFull = (row, full) => {
  if (!full) return row || {};
  const out = { ...(row || {}) };

  // fill missing top-level fields
  Object.keys(full).forEach((k) => {
    if (_isMissing(out[k])) out[k] = full[k];
  });

  // make sure clientEmail is present (common need for the popup)
  if (_isMissing(out.clientEmail)) {
    out.clientEmail = full.clientEmail || full?.salesOrder?.clientEmail || null;
  }

  // lightly merge nested salesOrder
  if (full.salesOrder || out.salesOrder) {
    out.salesOrder = { ...(full.salesOrder || {}), ...(out.salesOrder || {}) };
    // ensure salesOrder.clientEmail too
    if (_isMissing(out.salesOrder.clientEmail)) {
      out.salesOrder.clientEmail = full?.salesOrder?.clientEmail || full?.clientEmail || null;
    }
  }

  return out;
};


  // replace your handleOpenProof with:
  const handleOpenProof = (po) => {
    // 🔎 grab the fully-enriched PO from state and fill any gaps on the row
    const full = getFullPOById(po?.id);
    const poFilled = mergeMissingFromFull(po, full);
  
    const initialNotes = normalizeCustomerNotes(
      poFilled.customerNotes || [],
      allUsers,
      ACTION_META
    );
  
    // keep your existing shape; just use the filled object
    setSelectedPO({ ...poFilled, initialNotes });
    setProofInitialTab("proofing");
    setProofOpen(true);
  
    // optional: quick debug
    // console.log("[clientEmail] handleOpenProof",
    //   { id: poFilled.id, poNumber: poFilled.poNumber, clientEmail: poFilled.clientEmail,
    //     soClientEmail: poFilled?.salesOrder?.clientEmail });
  };
  

  // NEW: open on Overview when the row-hover info icon is clicked
  const handleOpenOverview = (po) => {
    const full = getFullPOById(po?.id);
    const poFilled = mergeMissingFromFull(po, full);
    const initialNotes = normalizeCustomerNotes(poFilled.customerNotes || [], allUsers, ACTION_META);
    setSelectedPO({ ...poFilled, initialNotes });
    setProofInitialTab("overview");
    setProofOpen(true);
  };
  

  // 2) Fetch all users for avatars
  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/byinstanceUniqueId/${instanceUniqueId}`,
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      )
      .then(res => setAllUsers(res.data.listOfUsers || []))
      .catch(console.error);
  }, [instanceUniqueId]);

// helpers
const asArr = (v) => Array.isArray(v) ? v : (v ? [v] : []);
const hasToken = (arr, tok) => asArr(arr).some(x => String(x).toLowerCase().includes(tok));

const deriveRoles = (u, { fromServerReps = false } = {}) => {
  const raw = [
    ...(asArr(u.roles)),
    ...(asArr(u.role)),
    ...(asArr(u.tags)),
    ...(asArr(u.groups)),
    ...(asArr(u.position)),
    ...(asArr(u.title)),
  ].map(x => String(x).toLowerCase());

  const roles = new Set();

  // Production/purchasing
  if (fromServerReps || hasToken(raw, 'purchasing') || hasToken(raw, 'production')) {
    roles.add('purchasing-rep');
  }
  // Order reps
  if (hasToken(raw, 'order')) roles.add('order-rep');

  // Client/account/sales reps
  if (hasToken(raw, 'client') || hasToken(raw, 'account') || hasToken(raw, 'sales')) {
    roles.add('client-rep');
  }

  return Array.from(roles);
};

const buildRepDirectory = (purchaseOrders, allUsers, serverReps) => {
  const byId = new Map();

  const mergeRoles = (...arrs) =>
    Array.from(new Set(arrs.flat().filter(Boolean)));

  const put = (u, source, extraRoles = []) => {
    if (!u || u.id == null) return;
    const id = String(u.id);
    const first_name = u.first_name || u.firstName || "";
    const last_name  = u.last_name  || u.lastName  || "";
    const email      = u.email || "";
    const profilePicture =
      u.profilePicture || u.avatar || u.photoUrl || null;

    // roles from tokens (your existing inference)
    const tokenRoles = deriveRoles(u, { fromServerReps: source === 'server' });

    const prev = byId.get(id) || {};
    const fullName = `${first_name} ${last_name}`.trim();
    const name = u.name || fullName || email || `User #${id}`;

    byId.set(id, {
      id,
      first_name: first_name || prev.first_name || "",
      last_name:  last_name  || prev.last_name  || "",
      email:      email      || prev.email      || "",
      profilePicture: profilePicture || prev.profilePicture || null,
      name,
      label: name,
      roles: mergeRoles(prev.roles || [], tokenRoles, extraRoles),
    });
  };

  // seed: server list + org list (no explicit role hints here)
  (serverReps || []).forEach(u => put(u, 'server'));
  (allUsers   || []).forEach(u => put(u, 'users'));

  // tag roles by where they appear on POs/SOs
  (purchaseOrders || []).forEach(po => {
    // Purchasing (assigned/production)
    if (po.productionRepDetails) put(po.productionRepDetails, 'po', ['purchasing-rep']);
    (po.assignedTo || []).forEach(u => put(u, 'po', ['purchasing-rep']));

    // Client and Order reps at the PO level
    (po.clientRepDetails || []).forEach(u => put(u, 'po', ['client-rep']));
    (po.orderRepDetails  || []).forEach(u => put(u, 'po', ['order-rep']));

    // Sales Order level reps
    const so = po.salesOrder || {};
    if (so.clientRep) put(so.clientRep, 'so', ['client-rep']);
    if (so.orderRep)  put(so.orderRep,  'so', ['order-rep']);
  });

  return Array.from(byId.values())
    .sort((a,b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
};


// make a deduped, mention-ready directory for @mentions
const mentionDirectory = useMemo(() => {
  const byId = new Map();

  const push = (u) => {
    if (!u || u.id == null) return;
    const id = String(u.id);
    const first = u.first_name || u.firstName || "";
    const last  = u.last_name  || u.lastName  || "";
    const name  = `${first} ${last}`.trim() || u.email || `User #${id}`;
    const avatarRaw = u.profilePicture || u.avatar || u.photoUrl || null;

    // some rows store profilePicture as a JSON string array — sanitize
    let avatar = null;
    try {
      if (typeof avatarRaw === "string" && avatarRaw.trim().startsWith("[")) {
        const arr = JSON.parse(avatarRaw);
        avatar = Array.isArray(arr) ? (arr.find(x => x.selected)?.url || arr[0]?.url || null) : null;
      } else {
        avatar = avatarRaw;
      }
    } catch { avatar = null; }

    byId.set(id, {
      id,                       // MUST be a string
      display: name,            // react-mentions wants {id, display}
      email: u.email || "",
      avatar: normalizeAvatarUrl(avatar),
      role: u.role || "",
      // extra searchable text (optional)
      _search: `${name} ${u.email || ""} ${u.role || ""}`.toLowerCase()
    });
  };

  (allUsers || []).forEach(push);
  // you may also want to include serverReps/repOptions if they can appear
  (serverReps || []).forEach(push);

  return Array.from(byId.values());
}, [allUsers, serverReps]);


// keep your cache writes as-is; repOptions now include roles[]
useEffect(() => {
  const unified = buildRepDirectory(purchaseOrders, allUsers, serverReps);

  
  setRepOptions(unified);
  writeRepsToCache(unified);
}, [purchaseOrders, allUsers, serverReps]);

// Double-click behavior: if you double-click the Proof cell, open Proofing.
// Otherwise, open the Overview tab for that PO.
const handleCellDoubleClick = useCallback((params) => {
  const row = params?.row;
  if (!row || row.rowType !== "PO") return;

  if (params.field === "proofStatus") {
    handleOpenProof(row);
  } else {
    handleOpenOverview(row);
  }
}, [handleOpenProof, handleOpenOverview]);

// rebuild your megaRows
// ⬇️ replace your megaRows useMemo with this version
const megaRows = useMemo(() => {
  // Build a rep index (id -> user object)
  const repIndex = new Map();
  const asUserArray = (value) => (Array.isArray(value) ? value : (value ? [value] : []));
  const indexUser = (u, source) => {
    const rawId = u?.id ?? u?.userId ?? u?.repId ?? u?.value;
    if (!u || rawId == null) return;
    const id = String(rawId);
    const existing = repIndex.get(id) || {};
    repIndex.set(id, {
      ...existing,
      ...u,
      id,
      first_name: u.first_name || u.firstName || existing.first_name || existing.firstName || "",
      last_name:  u.last_name  || u.lastName  || existing.last_name  || existing.lastName  || "",
      email:      u.email      || existing.email || "",
      role:       u.role || u.userRole || u.type || existing.role || existing.userRole || "",
      profilePicture: u.profilePicture || existing.profilePicture || null,
      avatar: u.avatar || existing.avatar || null,
      photoUrl: u.photoUrl || existing.photoUrl || null,
      avatarUrl: u.avatarUrl || existing.avatarUrl || null,
      source: source || existing.source,
    });
  };

  (serverReps || []).forEach(u => indexUser(u, "server"));
  (allUsers   || []).forEach(u => indexUser(u, "users"));

  // If your API bundles rep details on the PO, index those too
  (purchaseOrders || []).forEach(po => {
    if (po.productionRepDetails) indexUser(po.productionRepDetails, "po");
    asUserArray(po.clientRepDetails).forEach(u => indexUser(u, "po"));
    asUserArray(po.orderRepDetails).forEach(u => indexUser(u, "po"));
  });
  

  // Group by SO
  const bySO = purchaseOrders.reduce((acc, po) => {
    (acc[po.salesOrderId] = acc[po.salesOrderId] || []).push(po);
    return acc;
  }, {});


// ⬇️ NEW: also index possible order/client reps on SO/PO
(purchaseOrders || []).forEach(po => {
  const so = po.salesOrder || {};
  // Sales Order-level reps (various possible shapes)
  if (so.clientRep) indexUser(so.clientRep, "so");
  if (so.orderRep)  indexUser(so.orderRep,  "so");

  // PO-level reps (if present)
  asUserArray(po.clientRepDetails).forEach(u => indexUser(u, "po"));
  asUserArray(po.orderRepDetails).forEach(u => indexUser(u, "po"));
});

const getNextActionLabel = (v) => {
  if (!v) return "";
  const s = String(v).trim();
  return nextActionLabelById[s] || s;
};

  const rows = [];

  Object.entries(bySO).forEach(([orderId, pos]) => {
    const so = pos[0].salesOrder || {
      estimationId: null,
      inhandsDate:  null,
      status:       null,
      customerId:   null,
      customerName: '—'
    };

    rows.push({
      rowType: 'SO',
      id: `SO-${orderId}`,
      orderId,
      customer: so.customerName,
      customerId: so.customerId,
      inHandsDate: so.inhandsDate,
      orderStatus: so.status,
      estimationId: so.estimationId,
    });

    pos.forEach(po => {
      const lineTotal = (po.items || []).reduce(
        (sum, i) => sum + (i.prices?.ClientPrice || 0),
        0
      );

      const repId  = po.productionRep; // number or null
      const repObj = po.productionRepDetails || repIndex.get(String(repId)) || null;
      const assignedTo = repObj ? [repObj] : [];

      const naRaw   = po.nextAction ?? po.nextActionType ?? "";
      const naLabel = getNextActionLabel(naRaw);

const {
  clientRepObj,
  clientRepDetails: resolvedClientRepDetails,
  clientRepId: resolvedClientRepId,
  clientRepIds: resolvedClientRepIds,
  clientRepName: resolvedClientRepName,
  clientRepAvatar: resolvedClientRepAvatar,
  clientRepFallbackRole,
  clientRepFallbackSource,
  orderRepObj,
  orderRepDetails: resolvedOrderRepDetails,
  orderRepId: resolvedOrderRepId,
  orderRepIds: resolvedOrderRepIds,
  orderRepName: resolvedOrderRepName,
  orderRepAvatar: resolvedOrderRepAvatar,
} = resolvePurchasingDashboardReps({
  po,
  so: pos[0]?.salesOrder || {},
  repIndex,
  normalizeAvatarUrl,
});

    const projectNameDerived =
    so?.ProjectName               // ← Order.ProjectName (canonical)
    ?? so?.projectName            // safety for any alt casing
    ?? so?.project_name
    ?? po?.projectName            // last-ditch PO fallbacks (if you ever store it there)
    ?? po?.project_name
    ?? null;

      rows.push({
        rowType: 'PO',
        id: po.id,
        projectName: projectNameDerived,
        orderId: po.orderId,
        estimationId: so.estimationId,
        customer: so.customerName,
        customerId: so.customerId,
        supplier: po.supplier?.Name || po.supplierInfo?.supplierName,
        poNumber: po.poNumber,
        costsConfirmed: po.costsConfirmed === true || po.costsConfirmed === 1,
        supplierStatus: po.supplierStatus,
        productionRepStatus: po.productionRepStatus,
        proofs: po.proofs,
        proofStatus: po.proofStatus,
        proofRequired: !!po.proofRequired,
        proofSummary: po.proofSummary,
        canMarkProofComplete: po.canMarkProofComplete === true,
        allProofsUploaded: !!po.allProofsUploaded, 
        total: lineTotal,
        createdAt: po.createdAt || null,
        inHandsDate: getAuthoritativeDashboardPoInHandsDate(po),
        inhandsDateSource: po.inhandsDateSource || "missing",
        inhandsDateMeaning: po.inhandsDateMeaning || "unknown",
        nextActionLabel: naLabel,
        nextActionDate: po.nextActionDate || po.naDate || null,
        nextActionType: po.nextActionType || po.nextAction || null,   // ← textual action
        projectedShipDate:
        po.projectedShipDate || po.projShipDate ||
        po.shipping?.projectedShipDate || null,        
        poCreated: po.createdAt,
        dateShipped:       po.dateShipped || po.shippedAt || po.shipping?.dateShipped || null,
        shippedAt:         po.shippedAt || null, // keep if you want both
        shippingCostCents: po.shippingCostCents ?? po.shipping?.costCents ?? null,
        shippingCost:      po.shippingCost ?? po.shipping?.cost ?? null,
        trackingNumbers:   po.trackingNumbers ?? po.shipping?.trackingNumbers ?? null,
        shippingMethod:    po.shippingMethod ?? po.shipping?.method ?? null,
        carrier:           po.carrier ?? po.shipping?.carrier ?? null,
        productionRepId: repId ?? null,
        assignedTo, 
        clientRepIds: resolvedClientRepIds,
        orderRepIds:  resolvedOrderRepIds,
        clientRepId: resolvedClientRepId,
        orderRepId:  resolvedOrderRepId,
        clientRepName: resolvedClientRepName,
        orderRepName: resolvedOrderRepName,
        clientRepObj,
        orderRepObj,
        clientRepDetails: resolvedClientRepDetails,
        orderRepDetails: resolvedOrderRepDetails,
        clientRepAvatar: resolvedClientRepAvatar,
        orderRepAvatar: resolvedOrderRepAvatar,
        clientRepFallbackRole,
        clientRepFallbackSource,
        clientEmail: po.clientEmail || po.salesOrder?.clientEmail || null,
        poUpdated: po.updatedAt,
        customerNotes: po.customerNotes || [],
        firm: Boolean(po?.supplierInfo?.firm ?? po?.firm ?? false),
      });
    });
  });

  return rows;
}, [purchaseOrders, serverReps, allUsers]);

// After any PO fetch, merge newly-seen options into our DB lists, then save cache.
useEffect(() => {
  // suppliers from rows
  const rowSuppliers = uniq(
    (purchaseOrders || [])
      .map(po => po?.supplier?.Name || po?.supplierInfo?.supplierName || po?.supplier || null)
  );

  // clients from rows
  const rowClients = (() => {
    const pairs = (purchaseOrders || []).map(po => ({
      id: po?.salesOrder?.customerId ?? po?.customerId ?? null,
      name: po?.salesOrder?.customerName ?? po?.customer ?? ""
    }));
    return pairs.filter(p => p.id != null && p.name);
  })();

  // shipping methods from rows (if you store them on PO)
  const rowShipping = uniq((purchaseOrders || []).map(po => po?.shippingMethod).filter(Boolean));

  // merge to state
  setDbSupplierOptions(prev => union(prev, rowSuppliers));
  setDbClientOptions(prev => unionClients(prev, rowClients));
  setDbShippingOptions(prev => union(prev, rowShipping));
}, [purchaseOrders]);

useEffect(() => {
  // keep cache in sync whenever any list changes
  writeFiltersCache({
    suppliers: dbSupplierOptions,
    clients:   dbClientOptions,
    shipping:  dbShippingOptions,
    version:   filtersVersion || Date.now()
  });
}, [dbSupplierOptions, dbClientOptions, dbShippingOptions, filtersVersion]);

// Build role-specific option lists from what the backend sent us
const {
  clientRepOptions,
  orderRepOptions,
  productionRepOptions,
} = useMemo(() => {
  // 1) Collect ids from the POs we have in memory
  const clientIds = new Set();
  const orderIds  = new Set();
  const prodIds   = new Set();

  (purchaseOrders || []).forEach(po => {
    // client/order reps come from arrays the backend added
    (po.clientRepIds || []).forEach(id => clientIds.add(String(id)));
    (po.orderRepIds  || []).forEach(id => orderIds.add(String(id)));

    // production rep can be number, and/or detailed object
    if (po.productionRep != null) prodIds.add(String(po.productionRep));
    if (po.productionRepDetails?.id != null) prodIds.add(String(po.productionRepDetails.id));
    // if your POs ever carry assignedTo, include those
    (po.assignedTo || []).forEach(u => u?.id != null && prodIds.add(String(u.id)));
  });

  // 2) Make a unified lookup of users by id (server reps + all users + any PO-provided details)
  const byId = new Map();
  const put = (u) => {
    if (!u || u.id == null) return;
    const id = String(u.id);
    const existing = byId.get(id) || {};
    byId.set(id, {
      id,
      first_name: u.first_name || u.firstName || existing.first_name || "",
      last_name:  u.last_name  || u.lastName  || existing.last_name  || "",
      email:      u.email      || existing.email || "",
      profilePicture: u.profilePicture || existing.profilePicture || null,
      label: `${(u.first_name || u.firstName || "").trim()} ${(u.last_name || u.lastName || "").trim()}`.trim() || (u.email || ""),
    });
  };

  (serverReps || []).forEach(put);
  (allUsers   || []).forEach(put);
  (purchaseOrders || []).forEach(po => {
    (po.productionRepDetails ? [po.productionRepDetails] : []).forEach(put);
    (po.clientRepDetails || []).forEach(put);
    (po.orderRepDetails  || []).forEach(put);
    (po.assignedTo       || []).forEach(put);
  });

  // 3) Turn the id sets into sorted option arrays
  const toOptions = (idSet) =>
    Array.from(idSet)
      .map(id => byId.get(String(id)))
      .filter(Boolean)
      .sort((a,b) => a.label.localeCompare(b.label, undefined, { sensitivity: "base" }));

  return {
    clientRepOptions: toOptions(clientIds),
    orderRepOptions:  toOptions(orderIds),
    productionRepOptions: toOptions(prodIds),
  };
}, [purchaseOrders, allUsers, serverReps]);


  
const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
const [activeTab, setActiveTab]  = useState("all"); // "all" | "inProgress" | "problem" | "overdue"



const filteredRows = useMemo(() => {
  const rows = megaRows.filter(r => r.rowType === 'PO');

  // Use live UI filters when refineMode is ON, otherwise use the last "applied" (server) filters
  // const criteria = refineMode ? filters : applied;

  const criteria = infiniteDashboardScrollEnabled ? applied : filters;

  const dateField = criteria.dateType || 'nextActionDate';

  // New quick-preset bounds
  const derived = deriveDateBounds(criteria);
  let mode = derived.mode;
  let fromTs = derived.from ? derived.from.getTime() : null;
  let toTs   = derived.to   ? derived.to.getTime()   : null;

  // Legacy fallback/override: if dateFrom/dateTo exist in criteria, honor them
  if (criteria.dateFrom || criteria.dateTo) {
    mode   = "range";
    fromTs = criteria.dateFrom ? new Date(criteria.dateFrom).getTime() : null;
    toTs   = criteria.dateTo   ? new Date(criteria.dateTo).getTime()   : null;
  }



  const match = (row) => {


  if (activeTab === "inProgress") {
    const stages = PURCHASE_ORDER_IN_PROGRESS_STAGES;
    if (!stages.includes(row.supplierStatus)) return false;
  }

  // if (activeTab === "problem") {
  //   if ((row.productionRepStatus || "").toLowerCase() !== "problem") return false;
  // }

//   if (activeTab === "problem") {
//   if (row.productionRepStatus !== "Problem") return false;
// }

if (activeTab === "problem") {
  if (!["Problem"].includes(row.productionRepStatus)) return false;
}

  if (!matchesPurchasingDashboardOverdueRow({ row, criteria, activeTab })) return false;



    // production rep
    if (criteria.productionRepId) {
      const reps = row.assignedTo || [];
      if (!reps.some(r => String(r.id) === String(criteria.productionRepId))) return false;
    }

    // clients (IDs)
    if (criteria.clientIds?.length) {
      if (!criteria.clientIds.includes(String(row.customerId))) return false;
    }

    // Client Rep (membership)
    if (criteria.clientRepId) {
      const ids = (row.clientRepIds || []).map(String);
      if (!ids.includes(String(criteria.clientRepId))) return false;
    }

    // Order Rep (membership)
    if (criteria.orderRepId) {
      const ids = (row.orderRepIds || []).map(String);
      if (!ids.includes(String(criteria.orderRepId))) return false;
    }

    // suppliers (names)
    if (criteria.supplierIds?.length) {
      if (!criteria.supplierIds.includes(row.supplier)) return false;
    }

    // shipping methods
    if (criteria.shippingMethods?.length) {
      if (!criteria.shippingMethods.includes(row.shippingMethod)) return false;
    }

    // proof status
    if (criteria.proofStatus?.length) {
      const ps = getDashboardProofFilterStatus(row);
      if (!criteria.proofStatus.includes(ps)) return false;
    }

    // Status pill
    if (criteria.productionRepStatus?.length) {
      if (!criteria.productionRepStatus.includes(row.productionRepStatus || 'N/A')) return false;
    }

    // Stage
    if (criteria.supplierStage?.length) {
      const allow = new Set(expandStageSelections(criteria.supplierStage));
      if (!allow.has(row.supplierStatus || '')) return false;
    }

    // Firm
    if (criteria.firm !== null && typeof row.firm !== 'undefined') {
      if (Boolean(row.firm) !== Boolean(criteria.firm)) return false;
    }

    // Next Action type(s)
    if (criteria.nextActionTypes?.length) {
      const { ids: wantIds, wantsNone } = resolveNextActionFilter(criteria.nextActionTypes);
      const rowId = row.nextActionId
        ?? (normalizeNextAction(row.nextActionType).id) // in case only label was set
        ?? null;
    
      if (!rowId) {
        if (!wantsNone) return false;
      } else {
        if (!wantIds.length) return false;     // wanting only "None set"
        if (!wantIds.includes(rowId)) return false;
      }
    }

    // date logic (quick preset + legacy override)
    const raw = row[dateField];

    if (mode === "noDate") {
      return !raw;
    }

    if (mode === "range") {
      const ts = raw ? new Date(raw).getTime() : null;
      if (!ts) return false;
      if (fromTs != null && ts < fromTs) return false;
      if (toTs   != null && ts > toTs)   return false;
    }

    return true;
  };

  return rows.filter(match);
}, [megaRows, applied, filters, refineMode, activeTab, infiniteDashboardScrollEnabled]);



 



// keep the last non-empty rows so the table doesn't flash blank while loading
const lastGoodRowsRef = useRef([]);
useEffect(() => {
  if (filteredRows.length) lastGoodRowsRef.current = filteredRows;
}, [filteredRows]);

// use these for the DataTable to avoid flicked
// const rowsForTable = (poLoading ? lastGoodRowsRef.current : filteredRows);

// const rowsForTable = (poLoading && lastGoodRowsRef.current.length > 0)
//   ? lastGoodRowsRef.current
//   : filteredRows;


const rowsForTable = !hasTriggeredSearch
  ? []
  : (poLoading && lastGoodRowsRef.current.length > 0)
    ? lastGoodRowsRef.current
    : filteredRows;


const isBusy =
   poLoading ||
   reportLoading ||
   savingNaDate.size > 0 ||
   savingStage.size > 0 ||
   savingStatus.size > 0;

const isAppendingInfiniteRows =
  infiniteDashboardScrollEnabled &&
  poLoading &&
  rowsForTable.length > 0;
const overlayVisible = isBusy && hasTriggeredSearch && !isAppendingInfiniteRows;
const dimTable = isBusy && rowsForTable.length > 0;

const handleGenerateReportFromCurrentResults = useCallback(async () => {
  setReportLoading(true);
  try {
    const headers = { accessToken: localStorage.getItem("accessToken") };
    const poIds = filteredRows.map(r => r.id);
    if (!poIds.length) { toast("No rows to generate a report from."); return; }

    const body = {
      instanceUniqueId,
      poIds,                                     // ← server can build the report off these exact rows
      hardFilters:   buildReportParams(applied), // what hit the server
      refineFilters: buildReportParams(filters), // what the user refined locally
      source: "production-dashboard"
    };

    let res;
    try {
      // Preferred: an endpoint that always builds a new report
      res = await axios.post(`${REPORTS_API}/generate`, body, { headers });
    } catch {
      // Fallback: some backends accept payload on get-report
      res = await axios.post(`${REPORTS_API}/get-report`, body, { headers });
    }

    const rpt = res?.data?.report || res?.data?.data || res?.data || null;
    if (!rpt) { toast("The server didn’t return a report."); return; }

    setLastReport(rpt);
    setGeneratedOnce(true);       // ← flip copy after first generation
    openReportUrl(rpt);
  } catch (e) {
    console.error(e);
    toast.error(e?.response?.data?.message || "Could not generate the report.");
  } finally {
    setReportLoading(false);
  }
}, [filteredRows, applied, filters, instanceUniqueId]);


// helpers & options (UNDER megaRows)
const uniqueFrom = (arr) => Array.from(new Set(arr.filter(Boolean))).sort((a,b)=>`${a}`.localeCompare(`${b}`));

// The filters that actually produced the current table
const effectiveFilters = useMemo(
  () => (refineMode ? filters : applied),
  [refineMode, filters, applied]
);

// Supplier options: DB first, plus anything derived from current rows
const supplierOptions = useMemo(() => {
  const fromRows = uniq(megaRows.filter(r => r.rowType === 'PO').map(r => r.supplier));
  return union(dbSupplierOptions, fromRows);
}, [dbSupplierOptions, megaRows]);

// Client options: DB first (id/name), plus anything derived from current rows
const clientOptions = useMemo(() => {
  const pairsFromRows = megaRows
    .filter(r => r.rowType === 'PO')
    .map(r => ({ id: r.customerId, name: r.customer }))
    .filter(p => p.id != null && p.name);
  return unionClients(dbClientOptions, pairsFromRows);
}, [dbClientOptions, megaRows]);

// Shipping options: DB first, plus anything from rows
const shippingOptions = useMemo(() => {
  const fromRows = uniq(
    megaRows.filter(r => r.rowType === 'PO').map(r => r.shippingMethod).filter(Boolean)
  );
  return union(dbShippingOptions, fromRows);
}, [dbShippingOptions, megaRows]);


useEffect(() => {
  const normalize = s => (s || '').trim().toLowerCase();
  const toArr = v => (Array.isArray(v) ? v : (typeof v === 'string' ? (() => { try { return JSON.parse(v) } catch { return [] } })() : []));
  const offenders = purchaseOrders
    .map(po => {
      const sum = summarizeProofsClient(po); // client summary w/ hard override
      const proofs = toArr(po.proofs);
      return {
        id: po.id,
        poNumber: po.poNumber,
        dbStatus: po.proofStatus,
        proofRequired: !!po.proofRequired,
        proofsCount: proofs.length,
        uploaded: proofs.filter(p => p?.filePath).length,
        displayStatus: sum.displayStatus,
        _sum: sum,
        _po: po,
      };
    })
    // “Bad” = DB says No Proof, but anything would still show a proof-y state
    .filter(r =>
      normalize(r.dbStatus) === 'no proof' &&
      (
        r.proofsCount > 0 ||
        r.displayStatus !== 'Not Required' ||
        r.proofRequired === true
      )
    );

  if (offenders.length) {
    console.groupCollapsed(`⚠️ POs with "No Proof" but still showing proof UI: ${offenders.length}`);
    console.table(offenders.map(({ id, poNumber, dbStatus, proofRequired, proofsCount, uploaded, displayStatus }) =>
      ({ id, poNumber, dbStatus, proofRequired, proofsCount, uploaded, displayStatus })
    ));
    console.groupEnd();
    // If you need the raw objects:
    // console.log('Offenders raw:', offenders);
  } else {
    console.info('✅ No mismatches found for "No Proof".');
  }
}, [purchaseOrders]);


// pull canonical production reps from server
useEffect(() => {
  let cancelled = false;
  (async () => {
    try {
      setRepOptionsLoading(true);
      const reps = await fetchProductionReps("elite-promo-marketing"); // ← Node server call (as before)
      if (!cancelled) setServerReps(reps);
    } catch (e) {
      console.error("Failed to fetch production reps:", e);
    } finally {
      if (!cancelled) setRepOptionsLoading(false);
    }
  })();
  return () => { cancelled = true; };
}, [instanceUniqueId]);
// ── Style options: base column width slider ───────────────────────────────
const DEFAULT_BASE_COL_WIDTH = 140; // treat your current widths as "140" baseline
const DEFAULT_WIDTH_LS_KEY = "default_col_width";
const [baseColWidth, setBaseColWidth] = useState(DEFAULT_BASE_COL_WIDTH);
const [styleMenuEl, setStyleMenuEl] = useState(null);
const openStyleMenu = Boolean(styleMenuEl);

// load saved width (global)
useEffect(() => {
  const raw = localStorage.getItem(DEFAULT_WIDTH_LS_KEY);
  const n = raw != null ? parseInt(raw, 10) : NaN;
  if (!Number.isNaN(n)) setBaseColWidth(n);
}, []);

// persist on change
useEffect(() => {
  localStorage.setItem(DEFAULT_WIDTH_LS_KEY, String(baseColWidth));
}, [baseColWidth]);

// scale helper preserves your relative widths
const scaleWidth = useCallback(
  (w) => {
    if (typeof w !== "number") return w;
    return Math.round((w * baseColWidth) / DEFAULT_BASE_COL_WIDTH);
  },
  [baseColWidth]
);

// right after the pageRef + CSS var effect


// unify options from server + users + POs
useEffect(() => {
     const unified = buildRepDirectory(purchaseOrders, allUsers, serverReps);
     setRepOptions(unified);
     writeRepsToCache(unified);
}, [purchaseOrders, allUsers, serverReps]);

const ALL_KEYS_IN_ORDER = [
  ...DEFAULT_VISIBLE,
  ...Object.keys(COLUMN_DEFS).filter(k => !DEFAULT_VISIBLE.includes(k))
];
const orderedVisibleColIds = useMemo(() => {
  const visibleSet = new Set(visibleCols.filter((key) => COLUMN_DEFS[key]));
  return normalizeColumnOrderPreference(columnOrder).filter((key) => visibleSet.has(key));
}, [columnOrder, normalizeColumnOrderPreference, visibleCols]);
const moveVisibleColumn = useCallback((columnId, direction) => {
  const index = orderedVisibleColIds.indexOf(columnId);
  if (index < 0) return;

  const nextIndex = direction === "left" ? index - 1 : index + 1;
  if (nextIndex < 0 || nextIndex >= orderedVisibleColIds.length) return;

  const nextVisibleIds = [...orderedVisibleColIds];
  [nextVisibleIds[index], nextVisibleIds[nextIndex]] = [nextVisibleIds[nextIndex], nextVisibleIds[index]];

  setColumnOrder((prev) => {
    const normalizedPrev = normalizeColumnOrderPreference(prev);
    const hiddenIdsInCurrentOrder = normalizedPrev.filter((id) => (
      ALL_KEYS_IN_ORDER.includes(id) && !nextVisibleIds.includes(id)
    ));
    return normalizeColumnOrderPreference([...nextVisibleIds, ...hiddenIdsInCurrentOrder]);
  });
}, [orderedVisibleColIds, normalizeColumnOrderPreference]);
const resetColumnOrder = useCallback(() => {
  try {
    localStorage.removeItem(COLUMN_ORDER_LS_KEY);
  } catch (_err) {}
  setColumnOrder(getDefaultColumnOrder());
}, [COLUMN_ORDER_LS_KEY, getDefaultColumnOrder]);
const megaColumns = useMemo(() => {
  return orderedVisibleColIds
    .map((key) => COLUMN_DEFS[key])
    .filter(Boolean)
    .map((def) => {
      const built = def.build(instanceUniqueId);
      return typeof built.width === "number"
        ? { ...built, width: scaleWidth(built.width) }
        : built;
    });
}, [orderedVisibleColIds, scaleWidth, instanceUniqueId]);

  /* Purchasing Reports */

  const [reportsOpen, setReportsOpen] = useState(false);

  const [pinnedDefs, setPinnedDefs] = useState([]);

// Determine if a def is pinned (works with old/new shapes)
const isPinnedDef = (def) =>
  Boolean(
    def?.config_json?.pinned ??
    def?.config?.pinned ??
    def?.config_json?.ui?.pinned ??
    def?.config?.ui?.pinned ??
    false
  );

  // Quick-select pinned reports
  const [pinnedReports, setPinnedReports] = useState([]);
  const [selectedPinnedReportId, setSelectedPinnedReportId] = useState(null);

  // Apply a pinned report to the UI (sets filters  reloads table)
   const applyReportToUi = useCallback(({ filters: f, visibleCols: cols }) => {
       if (f) {
         setLookupMode(false);
         setFilters(f);
         setApplied(f);
         setHasTriggeredSearch(true);  // ✅ show table
         setRefineMode(true);          // ✅ afterwards, refine locally
         loadPurchaseOrders(f);        // hit server with those filters
       }
       if (cols) setVisibleCols(cols);
     }, [loadPurchaseOrders]);
    
     const applyPinnedReport = useCallback((def) => {
       const { filters: nextFilters, visibleCols } = readPurchasingReportConfig(def);
       if (!nextFilters) {
         toast("This report doesn’t have filters saved yet.");
         return;
       }
       applyReportToUi({ filters: nextFilters, visibleCols });
       setFilters(nextFilters);
       setApplied(nextFilters);
       setHasTriggeredSearch(true);   // ✅ key line
       setRefineMode(true);           // ✅ (nice to have)
       setFilterTab("SEARCH");
       setSelectedPinnedReportId(def.id);
       toast.success(`Applied “${def.name || "Untitled"}”`);
     }, [applyReportToUi]);


  const refreshPinnedReports = useCallback(async () => {
    try {
      const defs = await listPurchasingReportDefinitions(instanceUniqueId, { limit: 200 });
      setPinnedReports((defs || []).filter(isPinnedDef));
    } catch (e) {
      console.error(e);
    }
  }, [instanceUniqueId]);

  useEffect(() => {
    refreshPinnedReports();
  }, [refreshPinnedReports]);

  const loadPinnedDefs = useCallback(async () => {
    try {
      const data = await listPurchasingReportDefinitions(instanceUniqueId, { limit: 200 });
      const arr = (Array.isArray(data) ? data : []).filter(d => readPurchasingReportConfig(d).pinned);
      arr.sort((a,b) => (a.name||"").localeCompare(b.name||"", undefined, { sensitivity: "base" }));
      setPinnedDefs(arr);
    } catch (e) {
      console.error("Could not load pinned reports:", e);
    }
  }, [instanceUniqueId]);

  useEffect(() => { loadPinnedDefs(); }, [loadPinnedDefs]);
  // When closing the reports drawer, refresh in case pins changed there
  useEffect(() => { if (!reportsOpen) refreshPinnedReports(); }, [reportsOpen, refreshPinnedReports]);

  const activePinnedReportId = useMemo(() => {
    const selectedReport = pinnedReports.find(
      (definition) => String(definition.id) === String(selectedPinnedReportId)
    );
    return selectedReport && doesPinnedReportMatchState(selectedReport, applied, visibleCols)
      ? selectedReport.id
      : null;
  }, [applied, pinnedReports, selectedPinnedReportId, visibleCols]);

const handleHeaderReorder = useCallback((fromField, toField, after) => {
  // Map DataGrid field -> your COLUMN_DEFS key
  const fieldToKey = new Map(
    Object.entries(COLUMN_DEFS).map(([k, def]) => [def.build(instanceUniqueId).field, k])
  );

  const fromKey = fieldToKey.get(fromField);
  const toKey   = fieldToKey.get(toField);
  if (!fromKey || !toKey || fromKey === toKey) return;

  setVisibleCols((prev) => {
    const next = prev.filter(k => k !== fromKey);
    const toIdx = next.indexOf(toKey);
    const insertAt = toIdx < 0 ? next.length : (after ? toIdx + 1 : toIdx);
    next.splice(insertAt, 0, fromKey);
    return [...next];
  });
}, []);

const cols = megaColumns.map(c => ({ ...c, align: 'center' })); // page-only

const searchBtnLabel = poLoading
  ? "Searching…"
  : (hasTriggeredSearch || generatedOnce)
    ? "New search"
    : "Get report";

// IDs seen in the current result set (for sorting)
const seenIds = useMemo(() => {
  const client = new Set(), order = new Set(), prod = new Set();
  (purchaseOrders || []).forEach(po => {
    (po.clientRepIds || []).forEach(id => client.add(String(id)));
    (po.orderRepIds  || []).forEach(id => order.add(String(id)));
    if (po.productionRep != null) prod.add(String(po.productionRep));
    (po.assignedTo || []).forEach(u => u?.id != null && prod.add(String(u.id)));
  });
  return { client, order, prod };
}, [purchaseOrders]);

const getRepById = (id) =>
  id == null ? null : (repOptions.find(o => String(o.id) === String(id)) || null);

const roleOptions = (role, { bump = new Set(), selectedId = null } = {}) => {
  // 1) global, role-scoped
  const base = repOptions.filter(o => (o.roles || []).includes(role));

  // 2) sticky selected
  const sel = getRepById(selectedId);
  const exists = sel && base.some(o => String(o.id) === String(sel.id));
  const withSel = !sel || exists ? base : [sel, ...base];

  // 3) sort: “seen in current results” first, then alpha
  return withSel.slice().sort((a, b) => {
    const as = bump.has(String(a.id)) ? 1 : 0;
    const bs = bump.has(String(b.id)) ? 1 : 0;
    return bs - as || a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });
  });
};

// FINAL UI lists (stable, cached, role-scoped)
const clientRepOptionsUI     = roleOptions('client-rep',     { bump: seenIds.client, selectedId: filters.clientRepId });
const orderRepOptionsUI      = roleOptions('order-rep',      { bump: seenIds.order,  selectedId: filters.orderRepId });
const productionRepOptionsUI = roleOptions('purchasing-rep', { bump: seenIds.prod,   selectedId: filters.productionRepId });


const recipientDirectory = useMemo(() => {
  const fromPO = (purchaseOrders || []).flatMap(po => [
    po.productionRepDetails,
    ...(po.clientRepDetails || []),
    ...(po.orderRepDetails  || []),
    ...(po.assignedTo       || []),
  ]).filter(Boolean);

  return [
    ...allUsers,        // org users
    ...serverReps,      // canonical purchasing reps
    ...fromPO,          // any detailed reps attached to current POs
  ];
}, [allUsers, serverReps, purchaseOrders]);




const handleSort = (colId) => {
  if (sortBy === colId) {
    setSortDir((prev) => (prev === "asc" ? "desc" : "asc"));
  } else {
    setSortBy(colId);
    setSortDir("asc");
  }
};
 
const SortIcon = ({ colId }) => {
  if (sortBy !== colId) return <UnfoldMoreIcon sx={{ fontSize: 14, opacity: 0.4 }} />;
  return sortDir === "asc"
    ? <ArrowUpwardIcon  sx={{ fontSize: 14 }} />
    : <ArrowDownwardIcon sx={{ fontSize: 14 }} />;
};
 
const EXPORT_COLS_PO = Object.freeze([
  { id: "poNumber",      label: "PO #" },
  { id: "supplier",      label: "Supplier" },
  { id: "supplierStatus",label: "Stage" },
  { id: "productionRepStatus", label: "Status" },
  { id: "nextActionDate",label: "Next Action Date" },
  { id: "inHandsDate",   label: "In-Hands Date" },
]);

const getExportValPO = (po, id) => {
  switch (id) {
    case "poNumber":       return po.poNumber ?? "";
    case "supplier":       return po.supplier?.name ?? po.supplierName ?? "";
    case "supplierStatus": return po.supplierStatus ?? "";
    case "productionRepStatus": return po.productionRepStatus ?? "";
    case "nextActionDate": return po.nextActionDate
      ? new Date(po.nextActionDate).toLocaleDateString("en-CA") : "";
    case "inHandsDate": {
      const ihd = resolveDashboardPoInHandsDate(po);
      const formatted = formatDashboardPoIhd(ihd);
      return formatted === "N/A" ? "" : formatted;
    }
    default:               return "";
  }
};

const exportCSV = () => {
  const rows = [EXPORT_COLS_PO.map(c => c.label).join(",")];
  displayedPurchaseOrders.forEach(po => {
    rows.push(EXPORT_COLS_PO.map(c => `"${String(getExportValPO(po, c.id)).replace(/"/g,'""')}"`).join(","));
  });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([rows.join("\n")], { type: "text/csv;charset=utf-8;" }));
  a.download = `production_${new Date().toISOString().split("T")[0]}.csv`;
  a.click();
  showSnackbar("CSV exported");
};

const exportPDF = () => {
  const doc = new jsPDF({ orientation: "landscape" });
  doc.setFontSize(14);
  doc.text("Production Dashboard Export", 14, 15);
  doc.setFontSize(9);
  doc.text(`Generated: ${new Date().toLocaleString()}   Total: ${displayedPurchaseOrders.length}`, 14, 22);
  autoTable(doc, {
    head: [EXPORT_COLS_PO.map(c => c.label)],
    body: displayedPurchaseOrders.map(po => EXPORT_COLS_PO.map(c => getExportValPO(po, c.id))),
    startY: 28,
    styles: { fontSize: 7, cellPadding: 1.5 },
    headStyles: { fillColor: [30, 41, 59], textColor: [255, 255, 255], fontStyle: "bold" },
    alternateRowStyles: { fillColor: [248, 250, 252] },
  });
  doc.save(`production_${new Date().toISOString().split("T")[0]}.pdf`);
  showSnackbar("PDF exported");
};

const exportExcel = () => {
  const rows = [EXPORT_COLS_PO.map(c => c.label).join("\t")];
  displayedPurchaseOrders.forEach(po => {
    rows.push(EXPORT_COLS_PO.map(c => getExportValPO(po, c.id)).join("\t"));
  });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(
    new Blob([rows.join("\n")], { type: "application/vnd.ms-excel" })
  );
  a.download = `production_${new Date().toISOString().split("T")[0]}.xls`;
  a.click();
  showSnackbar("Excel exported successfully");
};


const visibleColDefs = orderedVisibleColIds
  .filter(k => COLUMN_DEFS[k])
  .map(k => ({ id: k, ...COLUMN_DEFS[k] }));

const visibleTableWidth = visibleColDefs.reduce(
  (total, col) => total + (col.id === "stage" ? Math.max(colWidth, STAGE_MIN_COL_WIDTH) : colWidth),
  0
);

const columnWidthSx = (columnId) => ({
  width: `${((columnId === "stage" ? Math.max(colWidth, STAGE_MIN_COL_WIDTH) : colWidth) / Math.max(visibleTableWidth, 1)) * 100}%`,
  minWidth: columnId === "stage" ? Math.max(colWidth, STAGE_MIN_COL_WIDTH) : colWidth,
  maxWidth: "none",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  boxSizing: "border-box",
});

  const advancedFilterCount = [
    ...(filters.supplierStage||[]), ...(filters.productionRepStatus||[]),
    ...(filters.proofStatus||[]),   ...(filters.supplierIds||[]),
    ...(filters.clientIds||[]),     ...(filters.shippingMethods||[]),
    ...(filters.nextActionTypes||[]),
    filters.clientRepId?1:0, filters.orderRepId?1:0, filters.productionRepId?1:0,
    filters.firm!==null?1:0,
    filters.dateQuick&&filters.dateQuick!=="any"?1:0,
    filters.dateFrom?1:0, filters.dateTo?1:0,
  ].filter(a => a?.length>0||a===1).length;


 
const chipSx = (color) => {
  const map = {
    blue:   { bg: "#eff6ff", text: "#1d4ed8", border: "#bfdbfe" },
    green:  { bg: "#f0fdf4", text: "#15803d", border: "#bbf7d0" },
    orange: { bg: "#fff7ed", text: "#c2410c", border: "#fed7aa" },
    red:    { bg: "#fef2f2", text: "#b91c1c", border: "#fecaca" },
    purple: { bg: "#faf5ff", text: "#7c3aed", border: "#ddd6fe" },
    gray:   { bg: "#f1f5f9", text: "#475569", border: "#e2e8f0" },
  };
  const c = map[color] ?? map.gray;
  return {
    backgroundColor: c.bg,
    color: c.text,
    border: `1px solid ${c.border}`,
    fontWeight: 500,
    fontSize: "0.75rem",
    height: 26,
    borderRadius: "6px",
    cursor: "pointer",
    "&:hover": { opacity: 0.85 },
  };
};
 
 
const stats = useMemo(() => ({
  total:     filteredRows.length,
  problem:   filteredRows.filter(r => (r.productionRepStatus || "").toLowerCase() === "problem").length,
  followUp:  filteredRows.filter(r => (r.productionRepStatus || "").toLowerCase() === "follow up").length,
  overdue:   filteredRows.filter(r => matchesPurchasingDashboardOverdueRow({
    row: r,
    activeTab: "overdue",
    criteria: { ...filters, dateQuick: "overdue", dateFrom: "", dateTo: "" },
  })).length,
  inProgress: filteredRows.filter(r => {
    const s = (r.supplierStatus || r.supplierStage || "").toLowerCase();
    return PURCHASE_ORDER_IN_PROGRESS_STAGES.map((status) => status.toLowerCase()).includes(s);
  }).length,
}), [filteredRows, filters]);

 
const hasFilters = (
  (filters.supplierStage?.length > 0) ||
  (filters.productionRepStatus?.length > 0) ||
  (filters.proofStatus?.length > 0) ||
  (filters.supplierIds?.length > 0) ||
  filters.clientRepId || filters.productionRepId ||
  (filters.dateQuick && filters.dateQuick !== "any") ||
  filters.dateFrom || filters.dateTo
);


const tabFilteredRows = useMemo(() => {
  if (activeTab === "all") return rowsForTable;
  if (activeTab === "problem")    return rowsForTable.filter(r => (r.productionRepStatus || "").toLowerCase() === "problem");
  if (activeTab === "inProgress") return rowsForTable.filter(r => PURCHASE_ORDER_IN_PROGRESS_STAGES.map((status) => status.toLowerCase()).includes((r.supplierStatus || r.supplierStage || "").toLowerCase()));
  if (activeTab === "overdue")    return rowsForTable.filter(r => matchesPurchasingDashboardOverdueRow({
    row: r,
    activeTab: "overdue",
    criteria: { ...filters, dateQuick: "overdue", dateFrom: "", dateTo: "" },
  }));
  if (activeTab === "followUp")   return rowsForTable.filter(r => (r.productionRepStatus || "").toLowerCase() === "follow up");
  return rowsForTable;
}, [rowsForTable, activeTab, filters]);

const displayedPurchaseOrders = useMemo(() => {
  const result = [...tabFilteredRows];

  result.sort((a, b) => {
    let aValue;
    let bValue;

    if (sortBy === "createdAt") {
      aValue = getDateSortValue(a.createdAt || a.poCreated);
      bValue = getDateSortValue(b.createdAt || b.poCreated);
    } else if (sortBy === "nextActionDate") {
      aValue = getDateSortValue(a.nextActionDate);
      bValue = getDateSortValue(b.nextActionDate);
    } else if (sortBy === "supplierStatus") {
      aValue = PURCHASE_ORDER_STATUS_RANK[a.supplierStatus] ?? Number.MAX_SAFE_INTEGER;
      bValue = PURCHASE_ORDER_STATUS_RANK[b.supplierStatus] ?? Number.MAX_SAFE_INTEGER;
    } else {
      const sortField = COLUMN_DEFS[sortBy]?.build?.(instanceUniqueId)?.field || sortBy;
      aValue = a?.[sortField] ?? null;
      bValue = b?.[sortField] ?? null;

      if (typeof aValue === "string") aValue = aValue.toLowerCase();
      if (typeof bValue === "string") bValue = bValue.toLowerCase();
    }

    return compareNullableValues(aValue, bValue, sortDir);
  });

  return result;
}, [tabFilteredRows, sortBy, sortDir, instanceUniqueId]);





const labelStyle = {
  fontWeight: 600,
  color: C.textMuted,
  fontSize: "0.70rem",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  mb: 0.5,
  display: "block",
};

const inputSx = (active) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    fontSize: "0.875rem",
    backgroundColor: active ? C.paperBg : C.subtleBg,
    "& fieldset": { borderColor: active ? "#3b82f6" : C.border },
    "&:hover fieldset": { borderColor: active ? "#2563eb" : C.textMuted },
    "&.Mui-focused fieldset": { borderColor: "#3b82f6" },
    "&.Mui-focused": { backgroundColor: C.paperBg },
  },
});

const RESET_FILTERS = useMemo(() => ({ clientRepId:null, orderRepId:null, productionRepId:null, supplierIds:[], clientIds:[], shippingMethods:[], proofStatus:[], productionRepStatus:[], supplierStage:[], firm:null, nextActionTypes:[], dateType:"nextActionDate", dateQuick:"any", dateCustom:"", dateFrom:"", dateTo:"" }), []);

const handleClearDashboard = useCallback(() => {
  dashboardSearchTokenRef.current += 1;
  poAbortRef.current?.abort();
  setLookupInputs({ purchaseOrder:"", salesOrder:"", projectNumber:"" });
  setFilters(RESET_FILTERS);
  setApplied(RESET_FILTERS);
  setHasTriggeredSearch(false);
  setRefineMode(false);
  setLookupMode(false);
  setActiveTab("all");
  setTablePage(0);
  setGeneratedOnce(false);
  setPurchaseOrders([]);
  setDashboardFetchMeta(DEFAULT_PURCHASING_DASHBOARD_META);
  dashboardRequestPagesRef.current.clear();
  setLastReport(null);
}, [RESET_FILTERS]);



useEffect(() => { 
  if (!infiniteDashboardScrollEnabled) {
    setApplied(filters);
  }
}, [filters, infiniteDashboardScrollEnabled]);

useEffect(() => {
  if (!isPurchasingDashboardRoute || !instanceUniqueId) return;

  let active = true;
  setPurchasingDashboardSettingsLoading(true);
  fetchOperationsManagementSettings(instanceUniqueId)
    .then((response) => {
      if (!active) return;
      setPurchasingDashboardSettings({
        ...DEFAULT_PURCHASING_DASHBOARD_SETTINGS,
        ...(response?.settings?.purchasing || {}),
      });
    })
    .catch(() => {
      if (!active) return;
      setPurchasingDashboardSettings(DEFAULT_PURCHASING_DASHBOARD_SETTINGS);
    })
    .finally(() => {
      if (!active) return;
      setPurchasingDashboardSettingsLoading(false);
    });

  return () => {
    active = false;
  };
}, [instanceUniqueId, isPurchasingDashboardRoute]);

useEffect(() => {
  if (
    lookupMode ||
    !infiniteDashboardScrollEnabled ||
    purchasingDashboardSettingsLoading ||
    !hasTriggeredSearch
  ) {
    return;
  }

  if (skipNextInfiniteReloadRef.current) {
    skipNextInfiniteReloadRef.current = false;
    return;
  }

  loadPurchaseOrdersPage({
    filters: applied,
    page: 1,
    append: false,
    limit: rowsPerPage,
  });
}, [
  applied,
  hasTriggeredSearch,
  infiniteDashboardScrollEnabled,
  lookupMode,
  loadPurchaseOrdersPage,
  purchasingDashboardSettingsLoading,
  rowsPerPage,
  sortBy,
  sortDir,
]);

useEffect(() => {
  if (shouldBlockPurchasingInfiniteScroll({
    lookupMode,
    infiniteDashboardScrollEnabled,
    purchasingDashboardSettingsLoading,
    hasTriggeredSearch,
    poLoading,
    hasMore: dashboardFetchMeta.hasMore,
  })) {
    return;
  }

  const node = infiniteSentinelRef.current;
  if (!node) return;

  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries[0]?.isIntersecting) return;
      loadPurchaseOrdersPage({
        filters: applied,
        page: (dashboardFetchMeta.page || 1) + 1,
        append: true,
        limit: rowsPerPage,
      });
    },
    { root: null, rootMargin: "320px 0px", threshold: 0.1 }
  );

  observer.observe(node);
  return () => observer.disconnect();
}, [
  applied,
  dashboardFetchMeta.hasMore,
  dashboardFetchMeta.page,
  hasTriggeredSearch,
  infiniteDashboardScrollEnabled,
  lookupMode,
  loadPurchaseOrdersPage,
  poLoading,
  purchasingDashboardSettingsLoading,
  rowsPerPage,
]);


useEffect(() => {
  if (activeTab === "all") {
    setFilters(prev => ({
      ...prev,
      supplierStage: [],
      productionRepStatus: [],
      dateQuick: "any",
    }));
  }

  if (activeTab === "inProgress") {
    setFilters(prev => ({
      ...prev,
      supplierStage: [...PURCHASE_ORDER_IN_PROGRESS_STAGES],
    }));
  }

  if (activeTab === "problem") {
    setFilters(prev => ({
      ...prev,
      productionRepStatus: ["Problem"],
    }));
  }

  if (activeTab === "overdue") {
    setFilters(prev => ({
      ...prev,
      dateQuick: "overdue",
    }));
  }
}, [activeTab]);

return (
    <div ref={pageRef} className="instance-dashboard instance-dashboard-inner-full-screen production-dashboard">
      <InstanceLeftSidebar />
      <div className="rightSide">
 
        {/* Fullscreen toggle floating */}
        {/*<Tooltip title={isFullscreen ? "Exit full screen" : "Full screen"} arrow>
          <IconButton size="small" onClick={() => setIsFullscreen(v => !v)} sx={{ position:"fixed", right:16, top:16, zIndex:1300, bgcolor:C.paperBg, boxShadow:2, "&:hover":{bgcolor:C.subtleBg} }}>
            {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </IconButton>
        </Tooltip>*/}
 
        {/* Pinned Report quick-select bar */}
        <PinnedReportQuickSelect
          reports={pinnedReports}
          activeReportId={activePinnedReportId}
          onSelect={applyPinnedReport}
          textMuted={C.textMuted}
        />
 
        
        <UITableShell
          customLayout
          paperSx={{
            flex: 1,
            borderRadius: '10px',
            border: '1px solid',
            borderColor: 'divider',
            borderTop: '3px solid',
            borderTopColor: 'primary.main',
            minHeight: 0,
            boxShadow: '0 1px 3px 0 rgba(0,0,0,0.07), 0 1px 2px -1px rgba(0,0,0,0.07)',

            mx: 2,   // 16px LEFT + RIGHT outside the card
            mb: 2,   // 16px bottom
            mt: pinnedReports.length ? 0.5 : 2,

            overflow: 'hidden',
          }}
        >
 
 
          <Box sx={{ display:"flex", alignItems:"center", gap:1, px:2, py:1.25, borderBottom:`1px solid ${C.border}`, flexWrap:"wrap", bgcolor:C.paperBg }}>
 
            {/* Legacy Purchasing status quick-filter strip is intentionally hidden because it is no longer needed in the dashboard UI. */}
 
            {/* Stat chips */}
            <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap sx={{ flex:1 }}>
              <Chip label={`Total: ${stats.total}`}           size="small" onClick={() => setActiveTab("all")}        sx={chipSx("blue")}   variant="outlined" />
              {stats.problem    > 0 && <Chip label={`Problem: ${stats.problem}`}       size="small" onClick={() => setActiveTab("problem")}    sx={chipSx("red")}    variant="outlined" />}
              {stats.followUp   > 0 && <Chip label={`Follow Up: ${stats.followUp}`}   size="small" onClick={() => setActiveTab("followUp")}   sx={chipSx("orange")} variant="outlined" />}
              {stats.overdue    > 0 && <Chip label={`Overdue: ${stats.overdue}`}       size="small" onClick={() => setActiveTab("overdue")}    sx={chipSx("red")}    variant="outlined" />}
              {stats.inProgress > 0 && <Chip label={`In Progress: ${stats.inProgress}`} size="small" onClick={() => setActiveTab("inProgress")} sx={chipSx("purple")} variant="outlined" />}
            </Stack>
 
            {/* Action buttons */}
            <Stack direction="row" spacing={0.5} flexShrink={0} alignItems="center">
 
              {/* Refresh */}
              <Tooltip title="Refresh data">
                <IconButton size="small" onClick={() => { runPurchaseOrderSearch(filters); }} disabled={poLoading}>
                  <RefreshIcon sx={{ fontSize:18 }} />
                </IconButton>
              </Tooltip>

              {/* Clear */}
              <Tooltip title="Clear search and table">
                <span>
                  <IconButton
                    size="small"
                    aria-label="Clear search and table"
                    onClick={handleClearDashboard}
                    disabled={poLoading && !hasTriggeredSearch}
                  >
                    <ClearIcon sx={{ fontSize:18 }} />
                  </IconButton>
                </span>
              </Tooltip>
 
              {/* Reports */}
              <Tooltip title="Open reports">
                <IconButton size="small" onClick={() => setReportsOpen(true)}>
                  <HistoryIcon sx={{ fontSize:18 }} />
                </IconButton>
              </Tooltip>
 
              {/* Choose Columns */}
              <Tooltip title="Choose columns">
                <IconButton size="small" onClick={e => setColumnMenuAnchor(e.currentTarget)}>
                  <ViewColumnIcon sx={{ fontSize:18 }} />
                </IconButton>
              </Tooltip>
              <Menu anchorEl={columnMenuAnchor} open={Boolean(columnMenuAnchor)} onClose={() => setColumnMenuAnchor(null)} slotProps={{ paper:{ sx:{ p:1, minWidth:220 } } }}>
                <Box sx={{ display:"flex", justifyContent:"space-between", px:1, pb:0.5 }}>
                  <Typography variant="subtitle2" fontWeight={700}>Columns</Typography>
                  <Box sx={{ display:"flex", gap:1 }}>
                    <Typography variant="caption" sx={{ cursor:"pointer", color:"primary.main" }} onClick={selectAllCols}>All</Typography>
                    <Typography variant="caption" sx={{ cursor:"pointer", color:"text.secondary" }} onClick={clearAllCols}>None</Typography>
                  </Box>
                </Box>
                <FormGroup sx={{ px:1, maxHeight:320, overflow:"auto" }}>
                  {Object.entries(COLUMN_DEFS).map(([key, def]) => (
                    <FormControlLabel key={key}
                      control={<Checkbox size="small" checked={visibleCols.includes(key)} onChange={() => toggleCol(key)} />}
                      label={<Typography variant="body2">{def.label}</Typography>}
                    />
                  ))}
                </FormGroup>
              </Menu>
 
              {/* Style density + col width */}
              <Tooltip title="Style options">
                <IconButton size="small" onClick={e => setStyleMenuAnchor(e.currentTarget)}>
                  <SettingsIcon sx={{ fontSize:18 }} />
                </IconButton>
              </Tooltip>
              <Menu anchorEl={styleMenuAnchor} open={Boolean(styleMenuAnchor)} onClose={() => setStyleMenuAnchor(null)} slotProps={{ paper:{ sx:{ p:1.5, minWidth:260 } } }}>
                <Typography variant="subtitle2" fontWeight={700} sx={{ mb:1 }}>Style options</Typography>
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mb:0.5 }}>Row density</Typography>
                <Stack direction="row" spacing={0.75} sx={{ mb:1.5 }}>
                  {["compact","comfortable","spacious"].map(d => (
                    <Chip key={d} label={d.charAt(0).toUpperCase()+d.slice(1)} size="small" clickable
                      onClick={() => setDensity(d)}
                      sx={{ borderRadius:"6px", fontSize:"0.74rem", fontWeight:600, bgcolor:density===d?"#1e293b":"transparent", color:density===d?"#fff":"text.secondary", border:`1px solid ${density===d?"#1e293b":C.border}` }} />
                  ))}
                </Stack>
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mb:0.5 }}>Column width: <b>{colWidth}px</b></Typography>
                <Slider value={colWidth} min={MIN_COL_WIDTH} max={MAX_COL_WIDTH} step={5} onChange={(_, v) => setColWidth(clampColWidth(Array.isArray(v) ? v[0] : v))} sx={{ color:"#1e293b" }} />
                <Box sx={{ display:"flex", justifyContent:"space-between", mt:1 }}>
                  <Button size="small" onClick={() => setColWidth(DEFAULT_COL_WIDTH)} sx={{ textTransform:"none", color:"text.secondary" }}>Reset width</Button>
                  <Button size="small" onClick={resetColumnOrder} sx={{ textTransform:"none", color:"text.secondary" }}>Reset column order</Button>
                  <Button size="small" onClick={() => setStyleMenuAnchor(null)} sx={{ textTransform:"none" }}>Close</Button>
                </Box>
              </Menu>
 
              {/* Export */}
              <Tooltip title="Export">
                <IconButton size="small" onClick={e => setExportAnchorEl(e.currentTarget)}>
                  <DownloadIcon sx={{ fontSize:18 }} />
                </IconButton>
              </Tooltip>
              <Menu anchorEl={exportAnchorEl} open={Boolean(exportAnchorEl)} onClose={() => setExportAnchorEl(null)} slotProps={{ paper:{ sx:{ minWidth:190, borderRadius:2 } } }}>
                <Typography variant="overline" sx={{ px:2, pt:1.25, pb:0.5, display:"block", color:"text.disabled" }}>Export as</Typography>
                <Divider sx={{ mb:0.5 }} />
                <MenuItem onClick={() => { exportCSV();   setExportAnchorEl(null); }} sx={{ py:0.75 }}><ListItemIcon><FileDownloadIcon fontSize="small" /></ListItemIcon><ListItemText>CSV</ListItemText></MenuItem>
                <MenuItem onClick={() => { exportExcel(); setExportAnchorEl(null); }} sx={{ py:0.75 }}><ListItemIcon><TableChartIcon  fontSize="small" /></ListItemIcon><ListItemText>Excel</ListItemText></MenuItem>
                <MenuItem onClick={() => { exportPDF();   setExportAnchorEl(null); }} sx={{ py:0.75 }}><ListItemIcon><PictureAsPdfIcon fontSize="small" /></ListItemIcon><ListItemText>PDF</ListItemText></MenuItem>
                <Divider sx={{ my:0.25 }} />
                <MenuItem onClick={() => { exportFilteredRowsCsv(); setExportAnchorEl(null); }} sx={{ py:0.75 }}><ListItemIcon><FileDownloadIcon fontSize="small" /></ListItemIcon><ListItemText>Filtered rows CSV</ListItemText></MenuItem>
              </Menu>
 
            </Stack>
          </Box>
 
          
          <Box sx={{ px:2, py:1.5, bgcolor:C.paperBg, borderBottom:`1px solid ${C.border}`, flexShrink:0 }}>
 
 
            <Box sx={{ display:"flex", flexWrap:"wrap", gap:1.25, alignItems:"flex-end" }}
              onKeyDown={e => { if (e.key==="Enter") handleLookup(); }}
            >
 
              {/* PO # */}
              <Box sx={{ flex:"1 1 160px", minWidth:140 }}>
                <Typography variant="caption" sx={labelStyle}>Purchase Order #</Typography>
                <TextField size="small" fullWidth placeholder="e.g. PO-1234"
                  value={lookupInputs.purchaseOrder}
                  onChange={e => setLookupInputs(s=>({...s, purchaseOrder:e.target.value}))}
                  sx={inputSx(!!lookupInputs.purchaseOrder)}
                />
              </Box>
 
              {/* SO # */}
              <Box sx={{ flex:"1 1 160px", minWidth:140 }}>
                <Typography variant="caption" sx={labelStyle}>Sales Order #</Typography>
                <TextField size="small" fullWidth placeholder="e.g. SO-5678"
                  value={lookupInputs.salesOrder}
                  onChange={e => setLookupInputs(s=>({...s, salesOrder:e.target.value}))}
                  sx={inputSx(!!lookupInputs.salesOrder)}
                />
              </Box>
 
              {/* Project # */}
              <Box sx={{ flex:"1 1 160px", minWidth:140 }}>
                <Typography variant="caption" sx={labelStyle}>Project #</Typography>
                <TextField size="small" fullWidth placeholder="e.g. PRJ-9012"
                  value={lookupInputs.projectNumber}
                  onChange={e => setLookupInputs(s=>({...s, projectNumber:e.target.value}))}
                  sx={inputSx(!!lookupInputs.projectNumber)}
                />
              </Box>
 
             
 
              {/* Spacer */}
              {/* <Box sx={{ flex:1 }} /> */}

{/* Supplier filter */}
              <Box sx={{ flex:"1 1 160px", minWidth:140 }}>
  <Typography variant="caption" sx={labelStyle}>Supplier</Typography>
  <Autocomplete
    size="small"
    options={supplierOptions}
    getOptionLabel={(o) => typeof o === "string" ? o : (o?.name || o?.id || "")}
    value={supplierOptions.find(s => s === filters.supplierIds?.[0]) || null}
    onChange={(_, v) =>
      setFilters(p => ({
        ...p,
        supplierIds: v ? [typeof v === "string" ? v : (v?.id || v?.name)] : []
      }))
    }
    renderInput={(params) => (
      // <TextField {...params} placeholder="All suppliers" />
      <TextField
  {...params}
  placeholder="All suppliers"
  sx={inputSx((filters.supplierIds || []).length > 0)}
/>
    )}
  />
</Box>

 {/* Search / Lookup button */}
              <Box sx={{ flex:"0 0 auto", display:"flex", alignItems:"center", gap:1, pb:0 }}>
                <Button variant="contained" size="small"
                  startIcon={poLoading ? <CircularProgress size={14} sx={{ color:"inherit" }} /> : <SearchIcon />}
                  disabled={poLoading}
                  onClick={async () => {
                    const hasLookup = lookupInputs.purchaseOrder||lookupInputs.salesOrder||lookupInputs.projectNumber;
                    if (hasLookup) { await handleLookup(); }
                    else { await runPurchaseOrderSearch(filters); }
                  }}
                  sx={{ textTransform:"none", fontWeight:700, height:40, px:2.25, borderRadius:"6px", bgcolor:"#1e293b", "&:hover":{bgcolor:"#334155"}, fontSize:"0.875rem" }}
                >
                  {poLoading ? "Searching…" : "Search"}
                </Button>
 
                {(lookupInputs.purchaseOrder||lookupInputs.salesOrder||lookupInputs.projectNumber||hasFilters) && (
                  <Button variant="text" size="small"
                    startIcon={<ClearIcon sx={{ fontSize:14 }} />}
                    onClick={handleClearDashboard}
                    sx={{ textTransform:"none", fontSize:"0.8125rem", color:"#ef4444", fontWeight:500, height:40, px:1, whiteSpace:"nowrap", "&:hover":{bgcolor:"#fef2f2"} }}
                  >
                    Clear all
                  </Button>
                )}
              </Box>
 
              {/* More Filters toggle */}
              <Box sx={{ flex:"0 0 auto", display:"flex", alignItems:"center", pb:0 }}>
                <Divider orientation="vertical" flexItem sx={{ height:32, mr:1.5 }} />
                <Button size="small"
                  variant={showAdvancedFilters ? "contained" : "outlined"}
                  startIcon={showAdvancedFilters ? <ExpandLessIcon sx={{ fontSize:14 }} /> : <FilterListIcon sx={{ fontSize:14 }} />}
                  endIcon={advancedFilterCount > 0 ? (
                    <Box component="span" sx={{ minWidth:18, height:18, borderRadius:"50%", bgcolor:showAdvancedFilters?"#fff":"#3b82f6", color:showAdvancedFilters?"#3b82f6":"#fff", fontSize:"0.65rem", fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center" }}>
                      {advancedFilterCount}
                    </Box>
                  ) : null}
                  onClick={() => setShowAdvancedFilters(v => !v)}
                  sx={{ textTransform:"none", fontWeight:600, fontSize:"0.8125rem", borderRadius:"6px", height:40, px:1.75, whiteSpace:"nowrap", borderColor:C.border, color:showAdvancedFilters?"#fff":C.textSec, bgcolor:showAdvancedFilters?"#3b82f6":C.subtleBg, "&:hover":{ bgcolor:showAdvancedFilters?"#2563eb":C.subtleBg, borderColor:C.border } }}
                >
                  {showAdvancedFilters ? "Hide Filters" : "Filters"}
                </Button>
              </Box>
            </Box>
 
            {/* Active filter chips */}
            {hasFilters && (
              <Stack direction="row" spacing={0.75} sx={{ mt:1.25 }} flexWrap="wrap" useFlexGap>
                {(filters.supplierStage||[]).map(s => (<Chip key={s} label={`Stage: ${s}`} size="small" onDelete={() => setFilters(p=>({...p, supplierStage:p.supplierStage.filter(x=>x!==s)}))} sx={chipSx("blue")} />))}
                {(filters.productionRepStatus||[]).map(s => (<Chip key={s} label={`Status: ${s}`} size="small" onDelete={() => setFilters(p=>({...p, productionRepStatus:p.productionRepStatus.filter(x=>x!==s)}))} sx={chipSx(s==="Problem"?"red":s==="OK"?"green":"orange")} />))}
                {(filters.proofStatus||[]).map(s => (<Chip key={s} label={`Proof: ${s}`} size="small" onDelete={() => setFilters(p=>({...p, proofStatus:p.proofStatus.filter(x=>x!==s)}))} sx={chipSx("purple")} />))}
                {(filters.supplierIds||[]).map(s => (<Chip key={s} label={`Supplier: ${s}`} size="small" onDelete={() => setFilters(p=>({...p, supplierIds:p.supplierIds.filter(x=>x!==s)}))} sx={chipSx("gray")} />))}
                {(filters.clientIds||[]).map(id => { const c = clientOptions.find(x=>String(x.id)===String(id)); return (<Chip key={id} label={`Client: ${c?.name||id}`} size="small" onDelete={() => setFilters(p=>({...p, clientIds:p.clientIds.filter(x=>x!==id)}))} sx={chipSx("gray")} />); })}
                {filters.clientRepId && (<Chip label={`Client Rep: ${repOptions.find(r=>r.id===filters.clientRepId)?.label??filters.clientRepId}`} size="small" onDelete={() => setFilters(p=>({...p, clientRepId:null}))} sx={chipSx("gray")} />)}
                {filters.orderRepId  && (<Chip label={`Order Rep: ${repOptions.find(r=>r.id===filters.orderRepId)?.label??filters.orderRepId}`} size="small" onDelete={() => setFilters(p=>({...p, orderRepId:null}))}  sx={chipSx("gray")} />)}
                {filters.productionRepId && (<Chip label={`Prod Rep: ${repOptions.find(r=>r.id===filters.productionRepId)?.label??filters.productionRepId}`} size="small" onDelete={() => setFilters(p=>({...p, productionRepId:null}))} sx={chipSx("gray")} />)}
                {(filters.nextActionTypes||[]).map(s => (<Chip key={s} label={`Next Action: ${s}`} size="small" onDelete={() => setFilters(p=>({...p, nextActionTypes:p.nextActionTypes.filter(x=>x!==s)}))} sx={chipSx("purple")} />))}
                {filters.firm !== null && (<Chip label={filters.firm?"Firm":"Not Firm"} size="small" onDelete={() => setFilters(p=>({...p, firm:null}))} sx={chipSx("gray")} />)}
                {filters.dateQuick && filters.dateQuick!=="any" && (<Chip label={`Date: ${filters.dateQuick}`} size="small" onDelete={() => setFilters(p=>({...p, dateQuick:"any", dateFrom:"", dateTo:""}))} sx={chipSx("green")} />)}
                {filters.dateFrom && (<Chip label={`From: ${filters.dateFrom}`} size="small" onDelete={() => setFilters(p=>({...p, dateFrom:""}))} sx={chipSx("green")} />)}
                {filters.dateTo   && (<Chip label={`To: ${filters.dateTo}`}     size="small" onDelete={() => setFilters(p=>({...p, dateTo:""}))}   sx={chipSx("green")} />)}
              </Stack>
            )}
 
            {/* More Filters collapse panel */}
            <Collapse in={showAdvancedFilters}>
              <Box sx={{ mt:1.5, pt:1.5, borderTop:`1px dashed ${C.border}` }}>
                <Grid container spacing={2}>
 
                  {/* Stage */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" sx={labelStyle}>Stage</Typography>
                    <FormControl fullWidth size="small" sx={inputSx(filters.supplierStage?.length>0)}>
                      <Select displayEmpty multiple value={filters.supplierStage??[]}
                        onChange={e => setFilters(p=>({...p, supplierStage:e.target.value}))}
                        renderValue={sel => sel.length===0 ? <span style={{color:C.textMuted}}>All Stages</span> : sel.length===1 ? sel[0] : `${sel.length} stages`}
                      >
                        {["In Progress", ...PURCHASE_ORDER_STAGE_LABELS.filter((status) => status !== "In Progress")].map(s => (
                          <MenuItem key={s} value={s}><Checkbox size="small" checked={(filters.supplierStage||[]).includes(s)} /><ListItemText>{s}</ListItemText></MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
 
                  {/* Status */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" sx={labelStyle}>Status</Typography>
                    <FormControl fullWidth size="small" sx={inputSx(filters.productionRepStatus?.length>0)}>
                      <Select displayEmpty multiple value={filters.productionRepStatus??[]}
                        onChange={e => setFilters(p=>({...p, productionRepStatus:e.target.value}))}
                        renderValue={sel => sel.length===0 ? <span style={{color:C.textMuted}}>All Statuses</span> : sel.length===1 ? sel[0] : `${sel.length} selected`}
                      >
                        {["Problem","OK","Follow Up","N/A"].map(s => (
                          <MenuItem key={s} value={s}><Checkbox size="small" checked={(filters.productionRepStatus||[]).includes(s)} /><ListItemText>{s}</ListItemText></MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
 
                  {/* Proof Status */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" sx={labelStyle}>Proof Status</Typography>
                    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap sx={{ mt:0.5 }}>
                      {["Approved","Pending Approval","Proof Needed","Rejected","Not Required","Uploaded","Proof Complete"].map(s => {
                        const active = (filters.proofStatus||[]).includes(s);
                        return (
                          <Chip key={s} label={s} size="small"
                            onClick={() => setFilters(prev => { const cur=prev.proofStatus||[]; return {...prev, proofStatus:active?cur.filter(x=>x!==s):[...cur,s]}; })}
                            sx={{ fontSize:"0.74rem", height:26, borderRadius:"6px", fontWeight:500, cursor:"pointer", bgcolor:active?"#7c3aed":"transparent", color:active?"#fff":C.textSec, border:`1px solid ${active?"#7c3aed":C.border}`, "&:hover":{borderColor:"#7c3aed"} }}
                          />
                        );
                      })}
                    </Stack>
                  </Grid>
 
                  {/* Firm */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" sx={labelStyle}>Firm</Typography>
                    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap sx={{ mt:0.5 }}>
                      {[{label:"Any",value:null},{label:"Firm",value:true},{label:"Not Firm",value:false}].map(opt => {
                        const active = filters.firm === opt.value;
                        return (
                          <Chip key={String(opt.value)} label={opt.label} size="small"
                            onClick={() => setFilters(p=>({...p, firm:opt.value}))}
                            sx={{ fontSize:"0.74rem", height:26, borderRadius:"6px", fontWeight:500, cursor:"pointer", bgcolor:active?"#1e293b":"transparent", color:active?"#fff":C.textSec, border:`1px solid ${active?"#1e293b":C.border}`, "&:hover":{borderColor:"#1e293b"} }}
                          />
                        );
                      })}
                    </Stack>
                  </Grid>
 
                  {/* Client Rep */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" sx={labelStyle}>Client Rep</Typography>
                    <Autocomplete size="small" options={clientRepOptionsUI} getOptionLabel={o=>o?.label??""}
                      value={clientRepOptionsUI.find(r=>r.id===filters.clientRepId)??null}
                      onChange={(_, v) => setFilters(p=>({...p, clientRepId:v?.id??null}))}
                      renderInput={params => <TextField {...params} placeholder="All client reps" sx={inputSx(!!filters.clientRepId)} />}
                    />
                  </Grid>
 
                  {/* Order Rep */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" sx={labelStyle}>Order Rep</Typography>
                    <Autocomplete size="small" options={orderRepOptionsUI} getOptionLabel={o=>o?.label??""}
                      value={orderRepOptionsUI.find(r=>r.id===filters.orderRepId)??null}
                      onChange={(_, v) => setFilters(p=>({...p, orderRepId:v?.id??null}))}
                      renderInput={params => <TextField {...params} placeholder="All order reps" sx={inputSx(!!filters.orderRepId)} />}
                    />
                  </Grid>
 
                  {/* Production Rep */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" sx={labelStyle}>Purchasing Rep</Typography>
                    <Autocomplete size="small" options={productionRepOptionsUI} getOptionLabel={o=>o?.label??""}
                      value={productionRepOptionsUI.find(r=>r.id===filters.productionRepId)??null}
                      onChange={(_, v) => setFilters(p=>({...p, productionRepId:v?.id??null}))}
                      renderInput={params => <TextField {...params} placeholder="All purchasing reps" sx={inputSx(!!filters.productionRepId)} />}
                    />
                  </Grid>
 
                  {/* Client */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" sx={labelStyle}>Client</Typography>
                    <Autocomplete size="small" multiple options={clientOptions} getOptionLabel={o=>typeof o==="string"?o:(o?.name||"")}
                      value={(filters.clientIds||[]).map(id=>clientOptions.find(c=>String(c.id)===String(id))||id)}
                      onChange={(_, v) => setFilters(p=>({...p, clientIds:v.map(x=>typeof x==="string"?x:(x?.id??x?.name??x))}))}
                      renderInput={params => <TextField {...params} placeholder="All clients" sx={inputSx((filters.clientIds||[]).length>0)} />}
                    />
                  </Grid>
 
                  {/* Supplier */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" sx={labelStyle}>Supplier</Typography>
                    <Autocomplete size="small" multiple options={supplierOptions} getOptionLabel={o=>typeof o==="string"?o:(o?.name||o?.id||"")}
                      value={(filters.supplierIds||[]).map(id=>supplierOptions.find(s=>s.id===id||s===id)||id)}
                      onChange={(_, v) => setFilters(p=>({...p, supplierIds:v.map(x=>typeof x==="string"?x:(x?.id??x?.name??x))}))}
                      renderInput={params => <TextField {...params} placeholder="All suppliers" sx={inputSx((filters.supplierIds||[]).length>0)} />}
                    />
                  </Grid>
 
                  {/* Shipping Method */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" sx={labelStyle}>Shipping Method</Typography>
                    <FormControl fullWidth size="small" sx={inputSx(filters.shippingMethods?.length>0)}>
                      <Select displayEmpty multiple value={filters.shippingMethods||[]}
                        onChange={e => setFilters(p=>({...p, shippingMethods:e.target.value}))}
                        renderValue={sel => sel.length===0 ? <span style={{color:C.textMuted}}>All methods</span> : sel.join(', ')}
                      >
                        {shippingOptions.map(name => (
                          <MenuItem key={name} value={name}><Checkbox size="small" checked={(filters.shippingMethods||[]).includes(name)} /><ListItemText>{name}</ListItemText></MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
 
                  {/* Next Action Type */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" sx={labelStyle}>Next Action</Typography>
                    <FormControl fullWidth size="small" sx={inputSx(filters.nextActionTypes?.length>0)}>
                      <Select displayEmpty multiple value={filters.nextActionTypes||[]}
                        onChange={e => setFilters(p=>({...p, nextActionTypes:e.target.value}))}
                        renderValue={sel => sel.length===0 ? <span style={{color:C.textMuted}}>Any</span> : sel.join(', ')}
                      >
                        {nextActionTypeEnums.map(name => (
                          <MenuItem key={name} value={name}><Checkbox size="small" checked={(filters.nextActionTypes||[]).includes(name)} /><ListItemText>{name}</ListItemText></MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
 
                  {/* Date Type + Date Range */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" sx={labelStyle}>Date Type</Typography>
                    <FormControl fullWidth size="small" sx={inputSx(filters.dateType==="inHandsDate")}>
                      <Select value={filters.dateType||"nextActionDate"} onChange={e => setFilters(p=>({...p, dateType:e.target.value}))}>
                        <MenuItem value="nextActionDate">Next Action Date</MenuItem>
                        <MenuItem value="inHandsDate">In-Hands Date</MenuItem>
                        <MenuItem value="poCreated">PO Created</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
 
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" sx={labelStyle}>Date Range</Typography>
                    <FormControl fullWidth size="small" sx={inputSx(!!filters.dateQuick&&filters.dateQuick!=="any")}>
                      <Select displayEmpty value={filters.dateQuick||"any"}
                        onChange={e => setFilters(p=>({...p, dateQuick:e.target.value, dateFrom:"", dateTo:"", dateCustom:e.target.value==="custom"?(_ymd(new Date())):""}))}
                        renderValue={val => !val||val==="any" ? <span style={{color:C.textMuted}}>Any Date</span> : val==="overdue"?"Overdue":val==="today"?"Today":val==="next7"?"Next 7 Days":val==="noDate"?"No Date":val}
                      >
                        <MenuItem value="any">Any Date</MenuItem>
                        <MenuItem value="overdue">Overdue</MenuItem>
                        <MenuItem value="today">Today</MenuItem>
                        <MenuItem value="next7">Next 7 Days</MenuItem>
                        <MenuItem value="noDate">No Date</MenuItem>
                        <MenuItem value="custom">Custom…</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Custom date only when custom selected */}
                  {filters.dateQuick === "custom" && (
                    <Grid item xs={12} sm={6} md={3}>
                      <Typography variant="caption" sx={labelStyle}>Custom Date</Typography>
                      <TextField size="small" fullWidth type="date" InputLabelProps={{ shrink:true }}
                        value={filters.dateCustom||""}
                        onChange={e => setFilters(p=>({...p, dateCustom:e.target.value}))}
                        sx={inputSx(!!filters.dateCustom)}
                      />
                    </Grid>
                  )}
 
                  {/* Custom from / to override */}
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="caption" sx={labelStyle}>Custom Date Range</Typography>
                    <Stack direction="row" spacing={1}>
                      <TextField size="small" type="date" fullWidth label="From" InputLabelProps={{ shrink:true }}
                        value={filters.dateFrom||""} onChange={e => setFilters(p=>({...p, dateFrom:e.target.value, dateQuick:"any"}))}
                        sx={inputSx(!!filters.dateFrom)} />
                      <TextField size="small" type="date" fullWidth label="To" InputLabelProps={{ shrink:true }}
                        value={filters.dateTo||""}   onChange={e => setFilters(p=>({...p, dateTo:e.target.value,   dateQuick:"any"}))}
                        sx={inputSx(!!filters.dateTo)} />
                    </Stack>
                  </Grid>
 
                </Grid>
 
                {/* Apply / clear buttons */}
                <Box sx={{ display:"flex", gap:1, mt:2, pt:1.5, borderTop:`1px dashed ${C.border}` }}>
                  <Button variant="contained" size="small"
                    startIcon={poLoading ? <CircularProgress size={14} sx={{ color:"inherit" }} /> : <SearchIcon />}
                    disabled={poLoading}
                    onClick={async () => { await runPurchaseOrderSearch(filters); }}
                    sx={{ textTransform:"none", fontWeight:700, height:36, px:2, borderRadius:"6px", bgcolor:"#1e293b", "&:hover":{bgcolor:"#334155"} }}
                  >
                    {poLoading ? "Searching…" : "Apply Filters"}
                  </Button>
                  {hasFilters && (
                    <Button variant="text" size="small"
                      startIcon={<ClearIcon sx={{ fontSize:14 }} />}
                      onClick={() => { setFilters(RESET_FILTERS); setApplied(RESET_FILTERS); }}
                      sx={{ textTransform:"none", fontSize:"0.8125rem", color:"#ef4444", "&:hover":{bgcolor:"#fef2f2"} }}
                    >
                      Clear Filters
                    </Button>
                  )}
                  <Typography variant="caption" color="text.disabled" sx={{ alignSelf:"center", ml:1 }}>
                    Tip — fill lookup fields above for exact PO / SO / Project matching
                  </Typography>
                </Box>
              </Box>
            </Collapse>
          </Box>
 
 
          <Box sx={{ position:"relative", flex:1, overflow:"hidden" }}>
           
            {isBusy && (
              <Box sx={{ position:"absolute", inset:0, zIndex:5, bgcolor:"rgba(255,255,255,0.45)", display:"flex", alignItems:"flex-start", justifyContent:"center", pt:3, pointerEvents:"all" }}>
                <CircularProgress size={32} />
              </Box>
            )}
            {/* <TableContainer sx={{ maxHeight:"calc(100vh - 340px)", overflowY:"auto" }}> */}

            <TableContainer
                          sx={{
                            flex: 1,
                            overflow: "auto",
                            minHeight: 0,
                            //  borderRadius: 0,
                            borderRadius: "0 !important",
                            "&::-webkit-scrollbar": { width: 6, height: 6 },
                            "&::-webkit-scrollbar-thumb": {
                              backgroundColor: "var(--ec-color-border-strong)",
                              borderRadius: 99,
                            },
                            "&::-webkit-scrollbar-track": {
                              backgroundColor: "transparent",
                            },
                          }}
                        >
              {/* <Table size="small" stickyHeader> */}
                <Table
                              stickyHeader
                              size="small"
                              sx={{
                                tableLayout: "fixed",
                                minWidth: visibleTableWidth,
                                width: "100%",
                              }}
                            >
 
              
                <TableHead>
                  <TableRow>
                    {visibleColDefs.map((col, visibleIndex) => {
                      const built = col.build?.(instanceUniqueId) ?? {};
                      const sortable = built.sortable !== false;
                      const hovered = hoveredColumnId === col.id;
                      const canMoveLeft = visibleIndex > 0;
                      const canMoveRight = visibleIndex < visibleColDefs.length - 1;
                      const moveButtonSx = {
                        position: "absolute",
                        top: "50%",
                        transform: "translateY(-50%)",
                        width: 18,
                        height: 18,
                        p: 0,
                        color: C.headerText,
                        opacity: hovered ? 0.9 : 0,
                        visibility: hovered ? "visible" : "hidden",
                        transition: "opacity 120ms ease",
                        "&:hover": { bgcolor: "rgba(255,255,255,0.14)" },
                      };
                      return (
                        <TableCell key={col.id}
                          onClick={() => sortable && handleSort(col.id)}
                          onMouseEnter={() => setHoveredColumnId(col.id)}
                          onMouseLeave={() => setHoveredColumnId((current) => (current === col.id ? null : current))}
                          sx={{
                            ...columnWidthSx(col.id),
                            bgcolor:C.headerBg,
                            color:C.headerText,
                            fontWeight:700,
                            fontSize:"0.72rem",
                            letterSpacing:"0.04em",
                            textTransform:"uppercase",
                            userSelect:"none",
                            cursor:sortable?"pointer":"default",
                            "&:hover":sortable?{bgcolor:C.headerBgHover}:{}
                          }}
                        >
                          <Box sx={{ position:"relative", display:"flex", alignItems:"center", justifyContent:"center", minWidth:0, width:"100%", maxWidth:"100%", overflow:"hidden", pl:2.5, pr:sortable ? (canMoveRight ? 4 : 2.5) : 2.5 }}>
                            <IconButton
                              size="small"
                              disabled={!canMoveLeft}
                              aria-label={`Move ${col.label} left`}
                              onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                moveVisibleColumn(col.id, "left");
                              }}
                              sx={{ ...moveButtonSx, left: 0, visibility: hovered && canMoveLeft ? "visible" : "hidden" }}
                            >
                              <KeyboardArrowLeftIcon sx={{ fontSize:14 }} />
                            </IconButton>
                            <EllipsisHeaderLabel label={col.label} />
                            {sortable && (
                              sortBy===col.id
                                ? (sortDir==="asc" ? <ArrowUpwardIcon sx={{ position:"absolute", right:canMoveRight ? 18 : 0, fontSize:12, flexShrink:0 }} /> : <ArrowDownwardIcon sx={{ position:"absolute", right:canMoveRight ? 18 : 0, fontSize:12, flexShrink:0 }} />)
                                : <UnfoldMoreIcon sx={{ position:"absolute", right:canMoveRight ? 18 : 0, fontSize:12, opacity:0.35, flexShrink:0 }} />
                            )}
                            <IconButton
                              size="small"
                              disabled={!canMoveRight}
                              aria-label={`Move ${col.label} right`}
                              onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                moveVisibleColumn(col.id, "right");
                              }}
                              sx={{ ...moveButtonSx, right: 0, visibility: hovered && canMoveRight ? "visible" : "hidden" }}
                            >
                              <KeyboardArrowRightIcon sx={{ fontSize:14 }} />
                            </IconButton>
                          </Box>
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
 
              
                <TableBody>
                  {/* {loading ? ( */}
                  {poLoading && !isAppendingInfiniteRows ? (
                    Array.from({ length: 8 }).map((_, i) => (
                      <TableRow key={i}>
                        {visibleColDefs.map(c => (
                          <TableCell key={c.id} sx={{ ...columnWidthSx(c.id), py:currentDensity.py }}>
                            <Skeleton variant="text" width="80%" />
                          </TableCell>
                        ))}
                      </TableRow>
                    ))
                  ) : displayedPurchaseOrders.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={visibleColDefs.length} sx={{ py:8, textAlign:"center" }}>
                        <Box sx={{ display:"flex", flexDirection:"column", alignItems:"center", gap:1, color:"text.disabled" }}>
                          <FolderOffIcon sx={{ fontSize:40 }} />
                          <Typography variant="body2">
                            {!hasTriggeredSearch
                              ? "Enter a PO, Sales Order, Project, Supplier, or filters, then click Search to load purchase orders."
                              : "No purchase orders match your filters"}
                          </Typography>
                          {hasTriggeredSearch && hasFilters && (
                            <Button size="small" variant="text" onClick={() => { setFilters(RESET_FILTERS); setApplied(RESET_FILTERS); }}>
                              Clear filters
                            </Button>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : (
                    displayedPurchaseOrders
                      .slice(
                        infiniteDashboardScrollEnabled ? 0 : tablePage * rowsPerPage,
                        infiniteDashboardScrollEnabled
                          ? displayedPurchaseOrders.length
                          : (tablePage + 1) * rowsPerPage
                      )
                      .map((row) => (
                        <TableRow key={row.id} hover
                          sx={{ cursor:"pointer", "&:last-child td":{borderBottom:0}, "& td":{py:currentDensity.py, fontSize:currentDensity.fontSize}, ...(isRowSaving(row.id)?{opacity:0.6, pointerEvents:"none"}:{}) }}
                          onDoubleClick={() => handleOpenOverview(row)}
                        >
                          {visibleColDefs.map(col => {
                            const def   = COLUMN_DEFS[col.id];
                            if (!def) return <TableCell key={col.id} />;
                            const built = def.build?.(instanceUniqueId) ?? {};
                            return (
                              <TableCell key={col.id} sx={{ ...columnWidthSx(col.id), verticalAlign:"middle" }}>
                                <Box sx={{
                                  minWidth:0,
                                  maxWidth:"100%",
                                  overflow:"hidden",
                                  textOverflow:"ellipsis",
                                  whiteSpace:"nowrap",
                                  "& > *": { maxWidth:"100%" },
                                }}>
                                  {built.renderCell
                                    ? built.renderCell({ row, value: row[built.field] })
                                    : built.valueGetter
                                      ? built.valueGetter(row[built.field], row)
                                      : (row[built.field] ?? "—")}
                                </Box>
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
 
          
          <Box sx={{ display:"flex", alignItems:"center", justifyContent:"space-between", px:2, py:0.5, borderTop:`1px solid ${C.border}`, bgcolor:C.paperBg, flexWrap:"wrap", gap:1 }}>
            <Typography variant="caption" sx={{ color:C.textMuted, fontWeight:500 }}>
              {!hasTriggeredSearch
                ? "Search to load purchase orders"
                : displayedPurchaseOrders.length === 0
                ? "No results"
                : infiniteDashboardScrollEnabled
                ? `Showing ${displayedPurchaseOrders.length} of ${dashboardFetchMeta.total || displayedPurchaseOrders.length} purchase order${(dashboardFetchMeta.total || displayedPurchaseOrders.length) !== 1 ? "s" : ""}`
                : `Showing ${tablePage * rowsPerPage + 1}–${Math.min((tablePage + 1) * rowsPerPage, displayedPurchaseOrders.length)} of ${displayedPurchaseOrders.length} purchase order${displayedPurchaseOrders.length !== 1 ? "s" : ""}`}
            </Typography>
            {infiniteDashboardScrollEnabled ? (
              <FormControl size="small" sx={{ minWidth: 128 }}>
                <InputLabel id="dashboard-batch-size-label">Batch size</InputLabel>
                <Select
                  labelId="dashboard-batch-size-label"
                  value={rowsPerPage}
                  label="Batch size"
                  onChange={async (event) => {
                    const nextValue = parseInt(event.target.value, 10);
                    setRowsPerPage(nextValue);
                    setTablePage(0);
                    dashboardRequestPagesRef.current.clear();
                    setDashboardFetchMeta((prev) => (
                      lookupMode
                        ? {
                            ...buildTerminalLookupMeta(purchaseOrders),
                            limit: nextValue,
                          }
                        : {
                            ...DEFAULT_PURCHASING_DASHBOARD_META,
                            limit: nextValue,
                          }
                    ));
                    if (hasTriggeredSearch) {
                      if (lookupMode) return;
                      skipNextInfiniteReloadRef.current = true;
                      await loadPurchaseOrdersPage({
                        filters: applied,
                        page: 1,
                        append: false,
                        limit: nextValue,
                      });
                    }
                  }}
                  disabled={poLoading}
                >
                  {[10, 25, 50, 100].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <TablePagination component="div"
                count={displayedPurchaseOrders.length}
                page={tablePage}
                onPageChange={(_, p) => setTablePage(p)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={e => { setRowsPerPage(parseInt(e.target.value, 10)); setTablePage(0); }}
                rowsPerPageOptions={[10, 25, 50, 100]}
                labelRowsPerPage="Rows:"
                sx={{ ".MuiTablePagination-toolbar":{minHeight:40, pl:0}, ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":{fontSize:"0.8rem", color:C.textMuted} }}
              />
            )}
          </Box>
          {infiniteDashboardScrollEnabled && hasTriggeredSearch && displayedPurchaseOrders.length > 0 ? (
            <Box ref={infiniteSentinelRef} sx={{ minHeight: 2 }}>
              {poLoading && dashboardFetchMeta.page > 1 ? <LinearProgress /> : null}
            </Box>
          ) : null}
 
        </UITableShell>
 
       
        <Menu anchorEl={statusMenu.anchorEl} open={Boolean(statusMenu.anchorEl)} onClose={closeStatusMenu} keepMounted slotProps={{ paper:{ sx:{ p:0.5, minWidth:180 } } }}>
          {["Problem","OK","Follow Up"].map(opt => (
            <MenuItem key={opt} onClick={() => handleStatusChange(statusMenu.rowId, opt)} dense>{opt}</MenuItem>
          ))}
        </Menu>
 
 
        <PurchasingPopup
          open={proofOpen}
          onClose={() => setProofOpen(false)}
          poData={selectedPO}
          initialTab={proofInitialTab}
          usersForMentions={mentionDirectory}
          initialRecipients={selectedPO ? buildInitialRecipients(selectedPO, recipientDirectory) : undefined}
          onPoFlagChange={(poId, val) => setPurchaseOrders(prev => prev.map(po => po.id===poId ? {...po, allProofsUploaded:!!val} : po))}
          onPoUpdated={updated => setPurchaseOrders(prev => prev.map(po => po.id===updated.id ? {...po,...updated} : po))}
          onProofsChange={handleProofsChange}
        />
 
        <ReportingPanel
          open={reportsOpen}
          onClose={() => setReportsOpen(false)}
          instanceUniqueId={instanceUniqueId}
          filters={filters}
          visibleCols={visibleCols}
          onApplyDefinition={({ filters: f }) => {
            if (f) { setFilters(f); runPurchaseOrderSearch(f); toast.success("Report filters applied"); }
          }}
          onPinsChanged={refreshPinnedReports}
        />
 
        {/* Snackbar */}
        <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar(s=>({...s,open:false}))} anchorOrigin={{ vertical:"bottom", horizontal:"right" }}>
          <Alert severity={snackbar.severity} onClose={() => setSnackbar(s=>({...s,open:false}))}>{snackbar.message}</Alert>
        </Snackbar>
 
      </div>
    </div>
  );
}
 

const normalizeNote = (n, i) => ({
  id: n.id || `cust-${n.sequence ?? i ?? Date.now()}`,
  message: n.message ?? "",
  createdAt: n.createdAt || n.timestamp || new Date().toISOString(),
  userName: n.userName || n.action || "Customer",
  userId: n.userId ?? null,
  userAvatar: normalizeAvatarUrl(n.userAvatar || n.profilePicture || n.userProfilePicture || null), // ✅
  poId: n.poId ?? null,
  orderId: n.orderId ?? null,
  _origin: n._origin || "unknown",
});


// Upsert one or many notes into state (by id; also merges optimistic duplicates)
const upsertNotes = (prev, incomingRaw) => {
  const incomingArr = Array.isArray(incomingRaw) ? incomingRaw : [incomingRaw];
  const incoming = incomingArr.map((n, i) => normalizeNote(n, i));

  // Map current notes by id (stringified)
  const map = new Map(prev.map(n => [String(n.id), n]));

  incoming.forEach(n => {
    const key = String(n.id);

    if (map.has(key)) {
      // Merge fields (server copy can overwrite optimistic placeholder)
      map.set(key, { ...map.get(key), ...n });
      return;
    }

    // Try to collapse obvious optimistic duplicates (same message, same minute)
    const dupe = [...map.values()].find(x =>
      !x.id?.toString().startsWith("tmp-") &&
      x.message === n.message &&
      Math.abs(new Date(x.createdAt) - new Date(n.createdAt)) < 5000
    );

    if (dupe) {
      map.set(String(dupe.id), { ...dupe, ...n });
    } else {
      map.set(key || `tmp-${Date.now()}`, n);
    }
  });

  // Newest first
  return [...map.values()].sort((a, b) =>
    new Date(b.createdAt) - new Date(a.createdAt)
  );
};

const ProofThumb = ({ src, href, onDelete, width = 160 }) => {
  const handleDeleteClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const ok = window.confirm("Delete this image?");
    if (!ok) return;
    await onDelete();
  };

  return (
    <Box
      className="proof-thumb"
      sx={{
        position: "relative",
        borderRadius: 1,
        overflow: "hidden",
        "&:hover .delBtn, &:focus-within .delBtn": {
          opacity: 1,
          transform: "scale(1)",
        },
        // Optional: keep visible on touch devices (comment out if you truly want *only* hover)
        // "@media (hover: none)": { "& .delBtn": { opacity: 1 } },
      }}
    >
      <a href={href} target="_blank" rel="noopener noreferrer" aria-label="Open proof in new tab">
        <Box
          component="img"
          src={src}
          alt="Proof image"
          sx={{ display: "block", width: "100%", objectFit: "contain" }}
        />
      </a>

      <IconButton
        aria-label="Delete image"
        title="Delete"
        className="delBtn"
        size="small"
        onClick={handleDeleteClick}
        sx={{
          position: "absolute",
          top: 6,
          right: 6,
          opacity: 0,
          transform: "scale(0.9)",
          transition: "opacity 120ms ease, transform 120ms ease",
          bgcolor: "rgba(0,0,0,0.55)",
          color: "common.white",
          "&:hover": { bgcolor: "error.main" },
          zIndex: 2,
        }}
      >
        <DeleteForeverIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

// --- proof normalization (UI <-> server) ---
const normalizeProof = (p) => {
  const out = {
    ...p,
    status: p?.status ?? p?.proofStatus ?? "Proof Needed",
    filePath: p?.filePath ?? p?.proofFilePath ?? null,
    approvals: p?.approvals ?? {
      user:   { state: "pending", by: null, byId: null, at: null },
      client: { state: "pending", by: null, byId: null, at: null },
    },
  };

  // If there’s an upload, infer status from approvals when status is stale
  if (out.filePath) {
    const u = out.approvals?.user?.state?.toLowerCase();
    const c = out.approvals?.client?.state?.toLowerCase();
    if (u === 'rejected' || c === 'rejected') out.status = 'Rejected';
    else if (u === 'approved' && c === 'approved') out.status = 'Approved';
    else if (!out.status || out.status === 'Proof Needed') out.status = 'Uploaded';
  }
  return out;
};



const toServerUpdate = (partial) => {
  const out = { ...partial };
  if ("status" in out) { out.proofStatus = out.status; delete out.status; }
  if ("filePath" in out) { out.proofFilePath = out.filePath; delete out.filePath; }
  return out;
};

const statusOptions = [
  { id: "Proof Needed", name: "Proof Needed" },
  { id: "Uploaded",     name: "Proof Uploaded" },
  { id: "Requested",    name: "Requested" },
  { id: "Approved",     name: "Approved" },
  { id: "Rejected",     name: "Rejected" },
];

// Compact approval chip used in SIMPLE view
// Compact approval chip (simple view)
const ApprovalChip = ({ roleLabel, state, at, by }) => {
  const s = String(state || "pending").toLowerCase();
  const map = {
    approved: { bg: '#eafdeb', fg: '#1f7a33', label: 'Approved' },
    rejected: { bg: '#fff1f1', fg: '#b91c1c', label: 'Rejected' },
    pending:  { bg: '#fff7ed', fg: '#b45309', label: 'Pending'  },
  };
  const { bg, fg, label } = map[s] || map.pending;
  const dateShort = at ? new Date(at).toLocaleDateString() : null;
  const byShort = by ? (by.split(' ').slice(0,2).join(' ')) : null; // “Jamie Lee”
  const inlineBits = [
    label,
    dateShort && s !== "pending" ? `— ${dateShort}` : null,
    byShort && s !== "pending" ? `(${byShort})` : null,
  ].filter(Boolean).join(' ');

  return (
    <Tooltip
      arrow
      title={[
        roleLabel,
        by ? `By: ${by}` : null,
        at ? `At: ${new Date(at).toLocaleString()}` : null
      ].filter(Boolean).join(' • ')}
    >
      <Box sx={{
        display:'inline-flex', alignItems:'center', gap:0.75,
        px:1, py:0.25, borderRadius:1, bgcolor:bg, color:fg,
        fontSize:12, fontWeight:700
      }}>
        <Box sx={{ width:8, height:8, borderRadius:'50%', bgcolor:fg }} />
        <span>{roleLabel}: {inlineBits}</span>
      </Box>
    </Tooltip>
  );
};
